import { TabError } from '@/utils/class/TabError'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import * as seaCargoDocApi from '@/api/seaExport/seaCargoDoc'
import { getEnsByCargoDoc, getEnsCargoInfoByCargoDoc } from '@/api/seaExport/seaCargoDoc'
import * as ediApi from '@/api/seaExport/edi'
import { getAfrEFreight, sendAfrEFreightXml } from '@/api/seaExport/edi'
import { Office } from '@/class/model/sys/Office'
import { getOfficeById, getOfficeListByTenantId } from '@/api/office'
import StrUtils from '@/utils/StrUtils'
import * as ShipmentTypeCode from '@/class/cargo/model/parameters/ShipmentTypeCode'
import * as AmsBLType from '@/class/cargo/model/parameters/AmsBLType'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { Voyage } from '@/class/model/mdm/Voyage'
import * as destinationInlandLocationApi from '@/api/seaExport/destinationInlandLocation'
import { getObjectByCache, getObjectByCacheMatchFiled } from '@/utils/basicDataCache'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { loadLclJobSeaCargoDocList, loadSeaExportJobRelated } from '@/api/seaExport/seaExportJob'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { queryMapByChannelDataTypeList } from '@/api/basicData/thirdPartyMapping'
import DateUtils from '@/utils/dateUtils'
import { getVesselList } from '@/api/vessel'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { getByUuidShipCompany, matchEori, matchEoriByEns } from '@/api/partner/shipping'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import { CORRECT, DELETE, DELETE_ALL, DELETE_CUSTOMS, ORIGINAL, SAVE } from '@/class/cargo/model/parameters/AmsType'
import { basicCacheKeys } from '@/utils/cacheConfig'
import Vue from 'vue'
import UIDUtil from '@/utils/uidUtil'
import { EQ_SIZES } from '@/class/cargo/model/parameters/EQSize'
import { poItems as getPoItems } from '@/api/seaExport/poItems'
import { checkBsItemOpened } from '@/api/booking/job'
import { deletePrefix } from '../../../../../../../../tools/convertor/util/stringUtil'
import { companyCacheByCmpIdx } from '@/api/company'
import * as NumberUtils from '@/utils/NumberUtils'

export class TabAMSPM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$message = view.$message
    this.$confirm = view.$confirm
    this.cargoDocs = view.cargoDocs
    this.afrCargoDocs = view.afrCargoDocs
    this.hbl2Arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    this._isAMSLogVisible = false
    this.AMSCompanyCodeFlag = false
    this.amsDataList = []
    this.afrDataList = []
    this.addressFields = ['Line1', 'Line2', 'Line3', 'Line4', 'Line5', 'Country', 'Province', 'City', 'Postalcode', 'Tel', 'Fax']
    this.addressFieldsEns = ['Eori', 'StreetNo', 'ContactName', 'TypeOfPerson', 'Email']
    this.buyerSellerAddressFields = ['Name', 'Address1', 'Address2', 'StreetNo', 'Country', 'City', 'Postalcode', 'Province', 'Tel', 'Email', 'TypeOfPerson', 'ContactName', 'Eori']
    this.lclSlaveJobMap = new Map()
    this.slaveHbls = []
    this.aiRecognitionPostHandlerByCargoDoc = this.aiRecognitionPostHandlerByCargoDoc.bind(this)
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    // 不可赋值
  }
  get config() {
    return this.view.context.config
  }
  set config(config) {
    this.view.context.config = config
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get cargoDocs() {
    return this.view.cargoDocs
  }
  set cargoDocs(cargoDocs) {
    this.view.cargoDocs = cargoDocs
  }
  get afrCargoDocs() {
    return this.view.afrCargoDocs
  }
  set afrCargoDocs(afrCargoDocs) {
    this.view.afrCargoDocs = afrCargoDocs
  }
  get thailandCargoDocs() {
    return this.view.thailandCargoDocs
  }
  set thailandCargoDocs(thailandCargoDocs) {
    this.view.thailandCargoDocs = thailandCargoDocs
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.view.form = form
  }
  get afrForm() {
    return this.view.afrForm
  }
  set afrForm(afrForm) {
    this.view.afrForm = afrForm
  }
  get thailandForm() {
    return this.view.thailandForm
  }
  set thailandForm(thailandForm) {
    this.view.thailandForm = thailandForm
  }
  init() {
    this.view.isUppercase = Number(this.config.get('SEShipperConsigneNotifyUppercase')) === 1
    this._isAMSLogVisible = this.config.get('AMSInterfaceName') === 'decarts'
    this.AMSCompanyCodeFlag = this.config.get('AMSCompanyCode') !== ''
    this.view.isJs = this.config.get('AMSInterfaceName') === 'Crimsonlogic'
    this.view.ensIsEFreight = this.config.get('ENSSupplierConfiguration') === 'eFreight'
    this.view.ensIsYitong = this.config.get('ENSSupplierConfiguration') === 'yitong'
    this.view.ensIsTradetech = this.config.get('ENSSupplierConfiguration') === 'tradetech'
    this.view.ensIsLink = this.config.get('ENSSupplierConfiguration') === 'link'
    this.view.amsIsLink = this.config.get('AMSInterfaceName') === 'link'
    this.view.afrIsLink = this.config.get('afrSupplierConfiguration') === 'link'
    this.view.afrIsOther = this.config.get('afrSupplierConfiguration') === 'other'
    this.view.amsIsOther = this.config.get('AMSInterfaceName') === 'other'
    this.view.ensIsOther = this.config.get('ENSSupplierConfiguration') === 'other'
    if (this.view.afrIsOther) {
      this.view.isJs = false
    }
    if (this.view.isJs) {
      // 初始化劲升基础数据
      queryMapByChannelDataTypeList({ platformChannelCode: 'js', dataTypeList: ['seaport', 'country', 'afrPacking', 'afrSeaport', 'afrDangerous', 'amsDischarging'] }).then(res => {
        // 劲升ams/aci港口数据
        this.view.localData.jsPortList = res.data.seaport || []
        // 劲升afr港口数据
        this.view.localData.jsAfrPortList = res.data.afrSeaport || []
        // 劲升aci国家数据
        this.view.localData.jsCountry = res.data.country || []
        // 劲升afr包装代码
        this.view.localData.jsAfrPacking = res.data.afrPacking || []
        // 劲升afr危险品代码
        this.view.localData.jsAfrDangerous = res.data.afrDangerous || []
        // 劲升ams卸货港
        this.view.localData.jsAmsDischargingList = res.data.amsDischarging || []
      })
    }
    if (this.view.afrIsLink) {
      queryMapByChannelDataTypeList({ platformChannelCode: 'link', dataTypeList: ['spcCode'] }).then(res => {
        this.view.localData.linkAfrSpcCode = res.data.spcCode || []
      })
    }
    if (this.view.ensIsYitong || this.view.ensIsLink) {
      queryMapByChannelDataTypeList({ platformChannelCode: 'yt', dataTypeList: ['country'] }).then(res => {
        // 亿通进入欧盟的第一个国家国家数据
        this.view.localData.ytCountry = res.data.country || []
      })
    }
    this.view.localData.shipCompanyInfos = []
    // 查询船公司eori信息
    matchEoriByEns().then(res => {
      this.view.localData.shipCompanyInfos = res.data
    })
  }
  async changeJob() {
    // 优先清除掉错误的数据
    await new SeaExportJob(this.job).removeAmsBlankCargoDoc()
    const cargoDoc = await new SeaExportJob(this.job).getSeaCargoDoc()
    this.cargoDocs = cargoDoc
    await this.loadCargoDoc2Handler(cargoDoc)
    this.view.masterInfo.rowData = [{
      jobNo: this.job.jobNo,
      afrSendState: this.job.afrSendState,
      afrReceiptStatus: this.job.afrReceiptStatus
    }]
    if (this.afrAllMatched()) {
      this.view.masterInfo.rowData[0].afrReceiptStatus = 'Matched'
    }
    if (Number(this.config.get('SpecialCharacterCheck')) === 1) {
      for (const key in this.view.specialCharCheck) {
        this.view.specialCharCheck[key] = StrUtils.getSpecialTexts(cargoDoc[key])
      }
    } else {
      for (const key in this.view.specialCharCheck) {
        this.view.specialCharCheck[key] = null
      }
    }
  }
  print() {
  }
  validateForm(cargoDoc) {
    if (!cargoDoc.hblNbr2) {
      throw new TabError(this.view.$t('Message.HAWBCannotBeNull'), 'tabAMS')
    } else if (!this.checkHblNbr2(cargoDoc)) {
      throw new TabError(this.view.$t('Message.HAWBCannotBeRepeated'), 'tabAMS')
    } else if (!this.checkInLandPoint()) {
      throw new TabError(this.view.$t('Message.InlandCannotBeNull'), 'tabAMS')
    } else if (this.view.form.AMSType === 2 && this.view.secondGenerationCheck) { // 校验加拿大海关备案号是否填写
      if (StrUtils.isEmpty(this.view.form.recordNumber)) {
        throw new TabError(this.view.$t('Message.rocordNumberCannotBeNull'), 'tabAMS')
      }
    }
    // 校验AFR的HBL是否重复
    if (this.view.tabAfr) {
      this.checkHBLNoRepeat()
    }
  }
  /**
   * 校验内陆点
   * 当申报类型（FilingType） = on Board 时，该值为非必填，其他值全部为必填
   */
  checkInLandPoint() {
    const type = this.view.form.frob
    if (type === 'F' || this.view.form.AMSType === 0) return true // 非必填项，不校验，放行.允许保存
    if (StrUtils.isEmpty(this.view.form.subLocationCode)) return false // 空,不允许保存
    return true // 允许保存
  }
  executeTask() {
    const afrAddress = this.form.afrAddress[0]
    if (afrAddress) {
      this.syncAfrAddress('shipper', afrAddress, DocCommon.AMS_History)
      this.syncAfrAddress('consignee', afrAddress, DocCommon.AMS_History)
      this.syncAfrAddress('notify', afrAddress, DocCommon.AMS_History)
      this.syncAfrAddress('shipper', afrAddress, this.form)
      this.syncAfrAddress('consignee', afrAddress, this.form)
      this.syncAfrAddress('notify', afrAddress, this.form)
      this.syncAfrAddress('alsonotify', afrAddress, DocCommon.AMS_History)
      if (this.view.activeTabName === 'ens') {
        this.syncAfrAddressEns('shipper', afrAddress, DocCommon.AMS_History)
        this.syncAfrAddressEns('consignee', afrAddress, DocCommon.AMS_History)
        this.syncAfrAddressEns('notify', afrAddress, DocCommon.AMS_History)
        this.syncBuyerSellerAfrAddress('seller', afrAddress, DocCommon.AMS_History)
        this.syncBuyerSellerAfrAddress('buyer', afrAddress, DocCommon.AMS_History)
      }
    }
    const otherAfrAddress = this.afrForm.afrAddress[0]
    if (otherAfrAddress) {
      this.syncAfrAddress('shipper', otherAfrAddress, DocCommon.AFR_History)
      this.syncAfrAddress('consignee', otherAfrAddress, DocCommon.AFR_History)
      this.syncAfrAddress('notify', otherAfrAddress, DocCommon.AFR_History)
      this.syncAfrAddress('shipper', otherAfrAddress, this.afrForm)
      this.syncAfrAddress('consignee', otherAfrAddress, this.afrForm)
      this.syncAfrAddress('notify', otherAfrAddress, this.afrForm)
      this.syncAfrAddress('alsonotify', otherAfrAddress, DocCommon.AFR_History)
    }
    const thailandAfrAddress = this.thailandForm.afrAddress[0]
    if (thailandAfrAddress) {
      this.syncAfrAddress('shipper', thailandAfrAddress, DocCommon.THAILAND_History)
      this.syncAfrAddress('consignee', thailandAfrAddress, DocCommon.THAILAND_History)
      this.syncAfrAddress('notify', thailandAfrAddress, DocCommon.THAILAND_History)
      this.syncAfrAddress('shipper', thailandAfrAddress, this.thailandForm)
      this.syncAfrAddress('consignee', thailandAfrAddress, this.thailandForm)
      this.syncAfrAddress('notify', thailandAfrAddress, this.thailandForm)
      this.syncAfrAddress('alsonotify', thailandAfrAddress, DocCommon.THAILAND_History)
    }
    DocCommon.AMS_History.mark = this.form.mark
    DocCommon.AFR_History.mark = this.afrForm.mark
    DocCommon.THAILAND_History.mark = this.thailandForm.mark
    this.form.emainAccount = this.view.localData.emainAccountStr
    this.form.emainAccountAci = this.view.localData.emainAccountAciStr
  }
  checkHblNbr2(cargoDoc) {
    let notRepeat = true
    let count = 0
    let cargoDocs = null
    if (cargoDoc.docType === CargoDocConsts.THAILAND) {
      cargoDocs = this.thailandCargoDocs
    } else if (this.view.tabAfr) {
      cargoDocs = this.afrCargoDocs
    } else {
      cargoDocs = this.cargoDocs
    }
    for (const doc of cargoDocs) {
      if (doc !== cargoDoc && doc.hblNbr2 === cargoDoc.hblNbr2 && !doc.deleted) {
        count += 1
        if (count > 1) {
          notRepeat = false
          break
        }
      }
    }
    return notRepeat
  }
  async loadCargoDoc2Handler(cargoDocList) {
    this.cargoDocs = []
    this.afrCargoDocs = []
    const thailandCargoDocs = []
    if (cargoDocList && cargoDocList.length > 0) {
      for (const doc of cargoDocList) {
        if (doc.docType === CargoDocConsts.AMS) {
          // 直接赋值
          if (this.view.isNewWindowByENS) {
            Vue.set(doc, 'noHouseNumberByShipper', false)
            Vue.set(doc, 'noHouseNumberByConsignee', false)
            Vue.set(doc, 'noHouseNumberBySeller', false)
            Vue.set(doc, 'noHouseNumberByBuyer', false)
          }
          this.cargoDocs.push(doc)
        } else if (doc.docType === CargoDocConsts.AFR) {
          this.afrCargoDocs.push(doc)
        } else if (doc.docType === CargoDocConsts.THAILAND) {
          thailandCargoDocs.push(doc)
        }
      }
    }
    await seaCargoDocApi.querySendStatus({ jobUuid: this.view.job.uuid }).then(async resp => {
      await this.querySendStatusResultHandler(resp)
    })
    if (!this.job.masterFlag) {
      if (this.cargoDocs.length > 0) {
        this.form = this.cargoDocs[0]
        this.view.container.rowData = await new SeaCargoDoc(this.form).getEdiContainer()
        this.view.ams2.isSelected = true
      } else {
        this.view.ams2.isSelected = false
        await this.onAddCargoDoc()
      }
    }
    if (this.view.loadAfrFlag) {
      if (this.afrCargoDocs.length > 0) {
        this.afrForm = this.afrCargoDocs[0]
        this.view.afrContainer.rowData = await new SeaCargoDoc(this.afrForm).getEdiContainer()
        this.view.afr2.isSelected = true
      } else {
        this.view.afr2.isSelected = false
        await this.onAddAfrCargoDoc()
      }
    }
    if (!this.job.masterFlag) {
      // seaCargoDoc列表无ams时，将form添加到列表
      const amsDoc = await new SeaExportJob(this.job).getCargoDocByType('AMS', false)
      if (!amsDoc) {
        const cargoDoc = await new SeaExportJob(this.job).getSeaCargoDoc()
        cargoDoc.push(this.form)
      }
    }
    if (this.view.loadAfrFlag) {
      // seaCargoDoc列表无afr时，将afrForm添加到列表
      const afrDoc = await new SeaExportJob(this.job).getCargoDocByType('AFR', false)
      if (!afrDoc) {
        const cargoDoc = await new SeaExportJob(this.job).getSeaCargoDoc()
        cargoDoc.push(this.afrForm)
      }
    }
    // CARGO-49127 处理船公司和分公司反恐舱单配置
    if (this.view.isNewWindowByENS) {
      // 查询eori信息
      await getOfficeById(this.view.$store.getters.currentOfficeId).then(res => {
        if (res.data.officeEoriList && res.data.officeEoriList.length) {
          // 根据dateCreated倒序排列
          this.view.localData.officeEoriList = res.data.officeEoriList.sort((a, b) => {
            return new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
          })
        } else {
          this.view.localData.officeEoriList = []
        }
      })
    }
    this.showCarrierAgentScac()
    this.view.localData.eFreighs = null
    this.AMSTypeRefreshHandler()
    await this.eFreighChangeHandler(this.form.AMSType)
    this.setNameOfCountry()
    this.lclSlaveJobMap = new Map()
    this.slaveHbls = []
    if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
      for (const lclSlave of this.job.lclSlaves) {
        this.lclSlaveJobMap.set(lclSlave.uuid, lclSlave)
      }
      await loadLclJobSeaCargoDocList([...this.lclSlaveJobMap.keys()]).then(resp => {
        this.slaveHbls = resp.data || []
        this.slaveHbls = this.slaveHbls.filter(item => item.docType === CargoDocConsts.HBL && item.hblNbr2)
      })
    }
    for (const cargoDoc of thailandCargoDocs) {
      const hbl = this.slaveHbls.find(p => p.hblNbr2 === cargoDoc.hblNbr2)
      if (hbl) {
        const lclSlave = this.lclSlaveJobMap.get(hbl.jobUuid)
        cargoDoc.jobNo = lclSlave ? lclSlave.jobNo : ''
      } else {
        cargoDoc.jobNo = this.job.jobNo
      }
    }
    this.thailandCargoDocs = thailandCargoDocs
    this.view.thailand2.rowData = [...this.thailandCargoDocs]
    if (this.view.thailand2.rowData.length > 0) {
      setTimeout(async() => {
        await ensureExecuteSuccess(() => this.view.thailand2.gridApi)
        this.view.thailand2.gridApi.setFocusedCell(0, this.view.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
      }, 100)
    } else {
      this.thailandForm = new SeaCargoDoc().fillDefaultValue().getData()
      this.thailandForm.docType = CargoDocConsts.THAILAND
      this.view.thailandContainer.rowData = []
    }
  }
  showCarrierAgentScac() {
    const company = this.companyList.find(p => p.cmpIdx === this.job.carrierId)
    if (company) {
      this.view.localData.carrierScAc = company.scac ? company.scac : ''
      this.view.localData.txtCarrierScAc = company.scac ? company.scac : ''
      this.view.localData.afrCarrierScAc = company.scac ? company.scac : ''
      this.view.localData.eManifestCarrierScAc = company.scac ? company.scac : ''
      if (company.shipCompanyUuid) {
        getByUuidShipCompany({ uuid: company.shipCompanyUuid }).then(resp => {
          if (resp.data) {
            const shipCompanyInfo = resp.data
            if (shipCompanyInfo.amsScacCode) {
              this.view.localData.txtCarrierScAc = shipCompanyInfo.amsScacCode
            }
            if (shipCompanyInfo.afrScacCode) {
              this.view.localData.afrCarrierScAc = shipCompanyInfo.afrScacCode
            } else if (shipCompanyInfo.amsScacCode) {
              this.view.localData.afrCarrierScAc = shipCompanyInfo.amsScacCode
            }
            if (shipCompanyInfo.emanifestScacCode) {
              this.view.localData.eManifestCarrierScAc = shipCompanyInfo.emanifestScacCode
            } else if (shipCompanyInfo.amsScacCode) {
              this.view.localData.eManifestCarrierScAc = shipCompanyInfo.amsScacCode
            }
          }
        })
      }
    }
    const company1 = this.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  /**
   * 同步HBL信息
   */
  async btnSynchroClickHandler() {
    // 如果已有的ams数量大于HBL+HBL2数量，则弹窗提醒删除指定条数数据
    const seaCargoDoc = await new SeaExportJob(this.job).getCargoDoc()
    const sourceCargoDoc = []
    for (const item of seaCargoDoc) {
      if (!item.hblNbr2 || item.deleted) continue
      if (item.docType === CargoDocConsts.HBL || item.docType === CargoDocConsts.HBL2) {
        sourceCargoDoc.push(item)
      }
    }
    if (!sourceCargoDoc || sourceCargoDoc.length === 0) {
      // 不存在可复制的HBL或HBL拆单
      return
    }
    const amsList = this.getAmsList()
    if (amsList && amsList.length > sourceCargoDoc.length) {
      for (let i = 0; i < amsList.length - sourceCargoDoc.length; i++) {
        this.deleteAms(amsList.length - i - 1)
      }
    }
    this.view.ams2.rowData = []
    for (let i = 0; i < sourceCargoDoc.length; i++) {
      const hbl = sourceCargoDoc[i]
      if (!amsList || amsList.length < i + 1) {
        await this.addAms(hbl)
        continue
      }
      const curAms = amsList[i]
      await this.cloneSeaCargoDoc(curAms, hbl)
      this.syncAmsList(curAms)
    }
    const newAmsList = this.getAmsList()
    if (newAmsList.length > 0) {
      this.form = this.view.ams2FinalRowData[0]
      this.AMSTypeRefreshHandler()
      this.form.frob = this.form.frob ? this.form.frob : 'I'
      setTimeout(() => {
        this.view.ams2.gridApi.clearFocusedCell()
        this.setSelectNode(0)
      }, 100)
    }
    this.view.ams2.gridOptions.api.clearFocusedCell()
    this.view.ams2.gridOptions.api.refreshCells({ force: true })
    this.amsDataList = this.view.ams2.rowData
    await this.syncContainer(sourceCargoDoc)
  }

  /**
   * ENS新版同步分单逻辑
   * @returns {Promise<void>}
   */
  async btnSynchroClickHandlerByNewEns() {
    // 分单号列表如果为空就初始化
    if (!this.view.ams2.rowData || !this.view.ams2.rowData.length) {
      this.view.ams2.rowData = []
    }
    // 如果已有的ams数量大于HBL+HBL2数量，则弹窗提醒删除指定条数数据
    const seaCargoDoc = await new SeaExportJob(this.job).getCargoDoc()
    const sourceCargoDoc = []
    for (const item of seaCargoDoc) {
      if (!item.hblNbr2 || item.deleted) continue
      if (item.docType === CargoDocConsts.HBL || item.docType === CargoDocConsts.HBL2) {
        sourceCargoDoc.push(item)
      }
    }
    if (!sourceCargoDoc || sourceCargoDoc.length === 0) {
      // 不存在可复制的HBL或HBL拆单
      return
    }
    const amsList = this.cargoDocs.filter(p => !p.deleted && p.docType === 'AMS')
    for (let i = 0; i < sourceCargoDoc.length; i++) {
      const hbl = sourceCargoDoc[i]
      if (amsList.findIndex(item => item.hblNbr2 === hbl.hblNbr2 && item.docType === CargoDocConsts.AMS) === -1) {
        await this.addAmsByNewEns(hbl)
        continue
      }
      const curAms = amsList[i]
      await this.cloneSeaCargoDocByNewEns(curAms, hbl, false)
      // 填充默认值
      this.fillCustomFieldDefaultValue(curAms)
      // 格式化收发通信息
      this.convertAfrAddressByRule(curAms)
      // 同步收发通信息
      this.syncSellerAndBuyerInfoAfrAddress(curAms)
    }

    this.amsDataList = this.view.ams2.rowData
    const lastData = this.view.ams2.rowData[this.view.ams2.rowData.length - 1]
    if (this.cargoDocs && this.cargoDocs.length > 0) {
      this.form = this.cargoDocs.find(item => item.hblNbr2 === lastData.hblNbr2 && item.docType === CargoDocConsts.AMS && !item.deleted)
    } else {
      this.form = new SeaCargoDoc().fillDefaultValue().getData()
    }
    this.view.curAms = this.form
    this.AMSTypeRefreshHandler()
    // 刷新分单号列表
    this.view.ams2.gridOptions.api.clearFocusedCell()
    this.view.ams2.gridOptions.api.refreshCells({ force: true })
    // 设置焦点
    setTimeout(async() => {
      const lastRowIndex = this.view.ams2.rowData.length - 1
      if (lastRowIndex >= 0) {
        this.setSelectNode(lastRowIndex)
      }
    }, 100)
    await this.onSelectionChange(this.form)
    // 刷新箱子和货物列表
    if (this.view.$refs['ens']) {
      this.view.$refs['ens'].aiRecognitionPostRefreshListHandler()
    }
  }
  /**
   * 增加分单
   * 1.不受HBL页签的限制，不论HBL页签是否有数据，页不管HBL里是几票，ENS都可以发任意的分单数量，所以可以导入HBL也可以自建空白分单。
   * 2.点击新增，即新增一票新数据，分单号栏位置空，双击可编辑，即使是通过导入HBL生成的数据，也可以双击修改分单号。
   * 3.新增的分单默认复制上一票的数据（除了分单号之外，忽视自动生成的字段，复制优先），如果新建的是第一票，则只能空白数据（各个字段的默认值不冲突，依然可以自动取值生成，字段表中有说明）
   */
  async btnAddHblHandler(newAms) {
    // 构建新表单
    let curAms = {}
    if (newAms) {
      curAms = newAms
    } else {
      curAms = this.buildCargoDoc()
    }

    // 添加到分单列表
    this.cargoDocs.push(curAms)
    this.syncAmsListByNewEns(curAms)
    // 当前curAms设置为新增
    this.amsDataList = this.view.ams2.rowData
    // 刷新分单号列表
    this.view.ams2.gridOptions.api.clearFocusedCell()
    this.view.ams2.gridOptions.api.refreshCells({ force: true })
    // 设置焦点
    setTimeout(async() => {
      const lastRowIndex = this.view.ams2.rowData.length - 1
      if (lastRowIndex >= 0) {
        this.setSelectNode(lastRowIndex)
      }
    }, 100)

    await this.onSelectionChange(curAms)
    return ''
  }

  async aiRecognitionPostHandlerByCargoDoc(data) {
    try {
      // 解析返回的JSON字符串并获取实际数据
      const parsedData = typeof data === 'string' ? JSON.parse(data) : data
      if (!Array.isArray(parsedData) || !parsedData[0]?.text?.data) {
        return
      }

      const recognizedData = parsedData[0].text.data
      // 处理字段映射问题 起运港、目的港、国家
      this.aiRecognitionFiledConvertHandler(recognizedData)
      // 构建新的对象
      const curAms = new SeaCargoDoc().fillDefaultValue().getData()
      // 初始基础信息
      curAms.jobUuid = this.job.uuid
      curAms.docType = CargoDocConsts.AMS
      curAms.dateCreated = DateUtils.customFormat(new Date(), 'YYYY-MM-DD HH:mm:ss')
      curAms.declarationType = 'F15'
      // 初始地址信息
      const defaultAfrAddressArr = []
      defaultAfrAddressArr.push(new AfrAddress().fillDefaultValue().getData())
      curAms.afrAddress = defaultAfrAddressArr
      // 初始箱子信息
      curAms.ediContainer = []
      // 初始货物信息
      curAms.ensCargoInfo = []

      // 赋值
      this.updateAmsPostAiHandler(recognizedData, curAms)

      if (!recognizedData.hblNbr2) {
        // 分单号为空=》生成分单号
        const hblNbr2NewValue = this.findMaxHblNbr2AndIncrement([...this.amsDataList])
        if (hblNbr2NewValue) {
          curAms.hblNbr2 = hblNbr2NewValue
        } else {
          curAms.hblNbr2 = this.job.jobNo
        }

        // 走新增的逻辑
        // 填充默认值
        this.fillCustomFieldDefaultValue(curAms)
        // 格式化收发通信息
        this.convertAfrAddressByRule(curAms)
        // 同步收发通信息
        this.syncSellerAndBuyerInfoAfrAddress(curAms)

        // 处理箱子信息
        if (recognizedData?.cargoInfo && recognizedData.cargoInfo.length) {
          const containerList = []
          const cargoInfoList = []
          this.convertValidCagoInfoHandler(recognizedData.cargoInfo, containerList, cargoInfoList)
          // 箱子处理更新的数据
          this.aiRecognitionPostUpdateHandler(curAms.ediContainer, containerList, 'containerNo')
          // 货物处理更新的数据
          this.aiRecognitionPostUpdateHandler(curAms.ensCargoInfo, cargoInfoList, 'hsCode')
          // 刷新箱子的属性
          this.aiRecognitionPostUpdateCargoInfoHandler(curAms.ensCargoInfo, curAms.ediContainer)
        }
        // 走新增分单逻辑
        await this.btnAddHblHandler(curAms).then(r => {})
        // 刷新箱子和货物列表
        this.view.$refs['ens'].aiRecognitionPostRefreshListHandler()
      } else {
        // 判断与当前的是否重复
        // 查找是否存在匹配的分单
        const existingDoc = this.cargoDocs.find(doc =>
          doc.docType === 'AMS' &&
            doc.hblNbr2 === recognizedData.hblNbr2 &&
            !doc.deleted
        )

        if (existingDoc) {
          // 覆盖逻辑
          this.updateAmsPostAiHandler(curAms, existingDoc)
          // 处理收发通的赋值逻辑
          this.syncAfrAddressPostAiHandler(existingDoc)
          // 处理箱子和货物
          if (recognizedData?.cargoInfo && recognizedData.cargoInfo.length) {
            // 如果existingDoc的箱子为空就初始化
            if (!existingDoc.ediContainer || !existingDoc.ediContainer.length) {
              existingDoc.ediContainer = []
            }
            if (!existingDoc.ensCargoInfo || !existingDoc.ensCargoInfo.length) {
              existingDoc.ensCargoInfo = []
            }

            const containerList = []
            const cargoInfoList = []
            this.convertValidCagoInfoHandler(recognizedData.cargoInfo, containerList, cargoInfoList)
            // 箱子处理更新的数据
            this.aiRecognitionPostUpdateHandler(existingDoc.ediContainer, containerList, 'containerNo')
            // 货物处理更新的数据
            this.aiRecognitionPostUpdateHandler(existingDoc.ensCargoInfo, cargoInfoList, 'hsCode')
            // 刷新箱子的属性
            this.aiRecognitionPostUpdateCargoInfoHandler(existingDoc.ensCargoInfo, existingDoc.ediContainer)
          }
          // 切换
          this.form = existingDoc
          this.view.curAms = this.form
          // 刷新分单号列表数据，更新焦点
          this.view.ams2.gridOptions.api.clearFocusedCell()
          this.view.ams2.gridOptions.api.refreshCells({ force: true })
          // 设置焦点
          setTimeout(async() => {
            const lastRowIndex = this.view.ams2.rowData.findIndex(item => item.hblNbr2 === existingDoc.hblNbr2)
            if (lastRowIndex >= 0) {
              this.setSelectNode(lastRowIndex)
            }
          }, 100)
          // 切换数据
          await this.onSelectionChange(existingDoc)
          // 刷新箱子和货物列表
          this.view.$refs['ens'].aiRecognitionPostRefreshListHandler()
        } else {
          // 走新增的逻辑
          // 填充默认值
          this.fillCustomFieldDefaultValue(curAms)
          // 格式化收发通信息
          this.convertAfrAddressByRule(curAms)
          // 同步收发通信息
          this.syncSellerAndBuyerInfoAfrAddress(curAms)

          // 处理箱子信息
          if (recognizedData?.cargoInfo && recognizedData.cargoInfo.length) {
            const containerList = []
            const cargoInfoList = []
            this.convertValidCagoInfoHandler(recognizedData.cargoInfo, containerList, cargoInfoList)
            // 箱子处理更新的数据
            this.aiRecognitionPostUpdateHandler(curAms.ediContainer, containerList, 'containerNo')
            // 货物处理更新的数据
            this.aiRecognitionPostUpdateHandler(curAms.ensCargoInfo, cargoInfoList, 'hsCode')
            // 刷新箱子的属性
            this.aiRecognitionPostUpdateCargoInfoHandler(curAms.ensCargoInfo, curAms.ediContainer)
          }
          // 走新增分单逻辑
          await this.btnAddHblHandler(curAms).then(r => {})
          // 刷新箱子和货物列表
          this.view.$refs['ens'].aiRecognitionPostRefreshListHandler()
        }
      }
    } catch (error) {
      console.error('AI识别数据处理失败:', error)
    }
    return ''
  }

  convertValidCagoInfoHandler(sourceData = [], containerList = [], cargoInfoList = []) {
    if (!sourceData || !sourceData.length) {
      return
    }
    for (const item of sourceData) {
      const filedList = ['containerNo', 'eqSize', 'eqType', 'hsCode', 'quantity', 'packing', 'weight', 'packing', 'cargoEnglishName']
      for (const field of filedList) {
        if (item[field]) {
          item[field] = this.validAndCounvertField(field, item[field])
        }
      }
      // 构建箱子数据
      const newContainer = this.aiRecognitionPostBuildObjectHandler('container', item)
      // 如果箱子的箱号、箱型、箱子种类都为空则视为没有箱子
      if (newContainer.containerNo || newContainer.eqSize || newContainer.eqType) {
        // 排除识别一致的数据
        if (containerList.findIndex(item => item === newContainer) === -1) {
          containerList.push(newContainer)
        }
      }
      // 如货物的hscode、唛头 品名就时无效数据
      const newCargoInfo = this.aiRecognitionPostBuildObjectHandler('cargoInfo', item)
      // 构建货物数据
      if (newCargoInfo.hsCode || newCargoInfo.mark || newCargoInfo.cargoEnglishName) {
        if (cargoInfoList.findIndex(item => item === newContainer) === -1) {
          cargoInfoList.push(newCargoInfo)
        }
      }
    }
  }

  aiRecognitionPostUpdateHandler(oldList, newList, keyField) {
    // 新数据为空不需要处理
    if (!newList || !newList.length) {
      return oldList
    }

    // 旧数据为空直接填充后返回
    if (!oldList || !oldList.length) {
      // 直接将新数据赋值给旧数据引用
      oldList = Array.isArray(oldList) ? oldList : []
      oldList.push(...newList)
      return oldList
    }

    // 遍历新列表
    newList.forEach(newItem => {
      const keyValue = newItem[keyField]

      // 如果 keyField 值为空，直接新增
      if (!keyValue) {
        oldList.push({ ...newItem })
        return
      }

      // 查找是否有匹配的项
      let found = false

      // 遍历旧列表查找匹配项
      for (let i = 0; i < oldList.length; i++) {
        const oldItem = oldList[i]

        // 找到具有相同 keyField 值的所有项
        if (oldItem[keyField] === keyValue) {
          found = true

          // 更新非空字段
          Object.keys(newItem).forEach(key => {
            if (newItem[key] !== null &&
                newItem[key] !== undefined &&
                newItem[key] !== '') {
              oldItem[key] = newItem[key]
            }
          })
        }
      }

      // 如果没有找到匹配项，则添加为新项
      if (!found) {
        oldList.push(newItem)
      }
    })

    return oldList
  }

  /**
   * AMS 的货物识别
   */
  convertValidCagoInfoHandlerAms(sourceData = [], containerList = []) {
    if (!sourceData || !sourceData.length) {
      return
    }
    for (const item of sourceData) {
      const filedList = ['containerNo', 'eqSize', 'eqType', 'hsCode', 'quantity', 'packing', 'weight', 'packing', 'cargoEnglishName', 'cubage', 'mark', 'cargoName', 'undgCode']
      for (const field of filedList) {
        if (item[field]) {
          item[field] = this.validAndCounvertField(field, item[field])
        }
      }
      // 构建箱子数据
      const newContainer = this.aiRecognitionPostBuildObjectHandlerAms('container', item)
      // 如果箱子的箱号为空则视为没有箱子
      if (newContainer.containerNo) {
        // 排除识别一致的数据
        if (containerList.findIndex(item => item === newContainer) === -1) {
          containerList.push(newContainer)
        }
      }
    }
  }

  /**
   * AFR 的货物识别
   */
  convertValidCagoInfoHandlerAfr(sourceData = [], containerList = [], cargoInfo) {
    if (!sourceData || !sourceData.length) {
      return
    }
    const cargoList = []
    for (const item of sourceData) {
      const filedList = ['containerNo', 'eqSize', 'eqType', 'hsCode', 'quantity', 'packing', 'weight', 'packing', 'cargoEnglishName', 'cubage', 'mark', 'dangerClass', 'undgCode']
      for (const field of filedList) {
        if (item[field]) {
          item[field] = this.validAndCounvertField(field, item[field])
        }
      }
      // 构建箱子数据
      const newContainer = this.aiRecognitionPostBuildObjectHandlerAfr('container', item)
      // 如果箱子的箱号为空则视为没有箱子
      if (newContainer.containerNo) {
        // 排除识别一致的数据
        if (containerList.findIndex(item => item === newContainer) === -1) {
          containerList.push(newContainer)
          cargoList.push(item)
        }
      }
    }
    if (cargoList && cargoList.length > 0) {
      const cargo = cargoList[0]
      const { totalQuantity, totalWeight, totalCubage } = this.summarize(cargoList)
      cargoInfo.cargoEnglishName = cargo.cargoEnglishName || ''
      cargoInfo.mark = cargo.mark || ''
      cargoInfo.undgCode = cargo.undgCode || ''
      cargoInfo.dangerClass = cargo.dangerClass || ''
      cargoInfo.packing = cargo.packing || ''
      cargoInfo.quantity = totalQuantity || 0
      cargoInfo.weight = totalWeight || 0.0
      cargoInfo.cubage = totalCubage || 0.0
    }
  }

  summarize(sourceData = []) {
    const safeNum = v => Number.isNaN(Number(v)) ? 0 : Number(v)

    const totals = sourceData.reduce(
      (acc, cur) => {
        acc.q += safeNum(cur.quantity)
        acc.w += safeNum(cur.weight)
        acc.c += safeNum(cur.cubage)
        return acc
      },
      { q: 0, w: 0, c: 0 }
    )

    return {
      totalQuantity: Math.round(totals.q),
      totalWeight: Number(totals.w.toFixed(3)),
      totalCubage: Number(totals.c.toFixed(3))
    }
  }

  /**
   * 根据货物的 correlativeContainerNo 重新处理箱子的 linkedCargoInformationNo 属性
   */
  aiRecognitionPostUpdateCargoInfoHandler(cargoList, containerList) {
    if (containerList || !containerList.length) {
      return
    }
    containerList.forEach(container => {
      if (container.containerNo) {
        const hsCodeSet = new Set()
        if (cargoList && cargoList.length) {
          cargoList.forEach(cargo => {
            if (cargo?.correlativeContainerNo) {
              if (cargo.correlativeContainerNo.split(',').includes(container)) {
                if (cargo.hsCode) {
                  hsCodeSet.add(cargo.hsCode)
                }
              }
            }
          })
          if (hsCodeSet.size) {
            container.linkedCargoInformationNo = Array.from(hsCodeSet).join(';')
          }
        }
      }
    })
  }

  /**
   * 构建箱子或者货物的实体数据
   * @param type
   * @param item
   * @returns {*|{correlativeContainerNo, cubage, deleted: boolean, quantity, hsCode, newUuid: (*), weight, cusCode: *, packing, cargoEnglishName, mark, undgCode: *}}
   */
  aiRecognitionPostBuildObjectHandler(type, item) {
    if (type === 'container') {
      const newContainer = new EDIContainer().fillDefaultValue().getData()
      // 设置基本属性
      newContainer.deleted = false
      newContainer.cargoDocUuid = this.form.uuid
      newContainer.containerUsageUuid = null
      // 设置默认值
      newContainer.containerNo = item.containerNo
      newContainer.linkedCargoInformationNo = item.hsCode
      // 处理设备类型和尺寸相关字段
      newContainer.eqType = item.eqType
      newContainer.eqSize = item.eqSize
      // 特别处理 eqCode 字段
      if (item.eqType && item.eqSize) {
        const containerSize = SystemConstants.EF_ENS_CONTAINER_MAP.get(item.eqSize + item.eqType)
        if (containerSize) {
          newContainer.eqCode = containerSize
        } else {
          // 如果eqCode就将eqSize、eqType让用户自己选择
          newContainer.eqCode = ''
          newContainer.eqSize = ''
          newContainer.eqType = ''
        }
      }
      // 特别处理 eqCode 字段
      if (item.hsCode) {
        newContainer.linkedCargoInformationNo = item.hsCode
      }
      // 设置所有权代码
      newContainer.containerOwnershipCode = this.matchAndFillDefaultEnsContainerOwner(item.containerOwnershipCode)
      return newContainer
    }

    if (type === 'cargoInfo') {
      return {
        // 基础字段与默认值
        newUuid: UIDUtil.createUID(),
        deleted: false,
        hsCode: item.hsCode,
        correlativeContainerNo: item.containerNo,
        quantity: item.quantity,
        weight: item.weight,
        packing: item.packing,
        mark: item.mark,
        cargoEnglishName: item.cargoEnglishName,
        undgCode: item.undgCode,
        cusCode: item.cusCode,
        cubage: item.cubage
      }
    }
  }

  aiRecognitionPostBuildObjectHandlerAms(type, item) {
    if (type === 'container') {
      const newContainer = new EDIContainer().fillDefaultValue().getData()
      // 设置基本属性
      newContainer.deleted = false
      newContainer.cargoDocUuid = this.form.uuid
      newContainer.containerUsageUuid = null
      newContainer.containerNo = item.containerNo
      newContainer.hsCode = item.hsCode || ''
      newContainer.cubage = item.cubage || 0.0
      newContainer.quantity = item.quantity || 0
      newContainer.weight = item.weight || 0.0
      newContainer.cargoName = item.cargoName || ''
      newContainer.mark = item.mark || ''
      newContainer.undgCode = item.undgCode || ''
      return newContainer
    }

    if (type === 'cargoInfo') {
      return {
        // 基础字段与默认值
        newUuid: UIDUtil.createUID(),
        deleted: false,
        hsCode: item.hsCode,
        correlativeContainerNo: item.containerNo,
        quantity: item.quantity,
        weight: item.weight,
        packing: item.packing,
        mark: item.mark,
        cargoEnglishName: item.cargoEnglishName,
        undgCode: item.undgCode,
        cusCode: item.cusCode,
        cubage: item.cubage
      }
    }
  }

  aiRecognitionPostBuildObjectHandlerAfr(type, item) {
    if (type === 'container') {
      const newContainer = new EDIContainer().fillDefaultValue().getData()
      // 设置基本属性
      newContainer.deleted = false
      newContainer.cargoDocUuid = this.form.uuid
      newContainer.containerUsageUuid = null
      newContainer.containerNo = item.containerNo
      newContainer.eqSize = item.eqSize
      newContainer.eqType = item.eqType
      return newContainer
    }

    if (type === 'cargoInfo') {
      return {
        // 基础字段与默认值
        newUuid: UIDUtil.createUID(),
        deleted: false,
        hsCode: item.hsCode,
        correlativeContainerNo: item.containerNo,
        quantity: item.quantity,
        weight: item.weight,
        packing: item.packing,
        mark: item.mark,
        cargoEnglishName: item.cargoEnglishName,
        undgCode: item.undgCode,
        cusCode: item.cusCode,
        cubage: item.cubage
      }
    }
  }

  matchAndFillDefaultEnsContainerOwner(code) {
    if (code) {
      for (const efEnsContainerOwner of SystemConstants.EF_ENS_CONTAINER_OWNER_AI) {
        if (efEnsContainerOwner.code === code) {
          return efEnsContainerOwner.code
        }
      }
    }
    return SystemConstants.EF_ENS_CONTAINER_OWNER_1_AI.code
  }

  /**
   * 处理格式
   * //   "cubage": 128,
   *         //   "containerNo": "SUDU9721774",
   *         //   "quantity": 3,
   *         //   "eqSize": "40",
   *         //   "hsCode": "",
   *         //   "weight": 24200,
   *         //   "packing": "PKGS",
   *         //   "cargoEnglish": "",
   *         //   "mark": "",
   *         //   "undgCode": "",
   *         //   "eqType": "ft"
   * @param field
   * @param value
   * @returns {string}
   */
  validAndCounvertField(field, value) {
    if (!value) {
      return ''
    }
    switch (field) {
      case 'hblNbr2':
        return value
          .toUpperCase()
          .replace(/[^A-Z0-9\-/]/g, '')
          .slice(0, 30) // 限制长度为30
      case 'containerNo':
        // 转大写并过滤不合规字符
        let valueContainerNo = value
          .toUpperCase()
          .replace(/[^A-Z0-9]/g, '')
          .slice(0, 11)

        // 检查第4位是否为U
        if (valueContainerNo.length >= 4 && valueContainerNo[3] !== 'U') {
          valueContainerNo = valueContainerNo.slice(0, 3) + 'U' + valueContainerNo.slice(4)
        }

        // 补全或截断到11位
        if (valueContainerNo.length < 11) {
          valueContainerNo = valueContainerNo.padEnd(11, '0')
        } else {
          valueContainerNo = valueContainerNo.slice(0, 11)
        }
        return valueContainerNo
      case 'eqSize':
        const valueEqSize = EQ_SIZES.find(item => item.code === value)
        if (valueEqSize) {
          return valueEqSize.code
        } else {
          return ''
        }
      case 'eqType':
        const valueEqType = getObjectByCacheMatchFiled(basicCacheKeys.basic_data_EQType, ['code'], value.toUpperCase())
        if (valueEqType) {
          return valueEqType.code
        } else {
          return ''
        }
      case 'hsCode':
        // 过滤不合规字符，只保留数字
        let valueHsCode = value
          .replace(/[^\d]/g, '')
          .slice(0, 6) // 限制长度为6位
        // 补全到6位
        if (valueHsCode.length < 6) {
          valueHsCode = valueHsCode.padEnd(6, '0')
        }
        return valueHsCode
      case 'quantity':
        let valueQuantity = Number.isNaN(Number(value)) ? 0 : Number(value)
        if (value > 99999999) {
          valueQuantity = 99999999
        }
        if (value <= 0) {
          valueQuantity = 0
        }
        return valueQuantity
      case 'packing':
        const valuePacking = getObjectByCacheMatchFiled(basicCacheKeys.basic_data_Packing, ['code', 'name', 'chineseName'], value)
        if (valuePacking) {
          return valuePacking.code
        } else {
          return ''
        }
      case 'weight':
        let valueWeight = Number.isNaN(Number(value)) ? 0 : Number(value)
        if (value > 999999999.999999) {
          valueWeight = 999999999.999999
        }
        if (value <= 0) {
          valueWeight = 0
          return valueWeight
        }
        return ColumnUtils.formatNumber(valueWeight, 6, false, false, false)
      case 'cubage':
        let valueCubage = Number.isNaN(Number(value)) ? 0 : Number(value)
        if (value > 999999999.999999) {
          valueCubage = 999999999.999999
        }
        if (value <= 0) {
          valueCubage = 0
          return valueCubage
        }
        return ColumnUtils.formatNumber(valueCubage, 6, false, false, false)
      case 'mark':
        // 过滤不合规字符，只保留合规字符：大小写字母、数字、短横杠、斜杠、逗号、空格、冒号、引号、加号、下划线
        return value
          .replace(/[^a-zA-Z0-9"\-/,: '_"+]/g, '')
          .slice(0, 512) // 限制长度为512个字符
      case 'cargoEnglishName':
        // 过滤不合规字符，只保留合规字符：大小写字母、数字、短横杠、斜杠、逗号、空格、冒号、引号、加号、下划线
        return value
          .replace(/[^a-zA-Z0-9"\-/,: '_"+]/g, '')
          .slice(0, 512) // 限制长度为512个字符
      case 'cargoName':
        // 过滤不合规字符，只保留合规字符：大小写字母、数字、短横杠、斜杠、逗号、空格、冒号、引号、加号、下划线
        return value
          .replace(/[^a-zA-Z0-9"\-/,: '_"+]/g, '')
          .slice(0, 512) // 限制长度为512个字符
      case 'undgCode':
        return value
      case 'cusCode':
        // 过滤不合规字符，只保留数字和短横杠
        let valueCusCode = value
          .replace(/[^\d-]/g, '')

        // 确保格式为 NNNNNNN-N
        if (valueCusCode.length > 0) {
          // 先提取所有数字
          const numbers = valueCusCode.replace(/[^0-9]/g, '')
          if (numbers.length >= 8) {
            // 格式化为 NNNNNNN-N
            valueCusCode = numbers.slice(0, 7) + '-' + numbers.slice(7, 8)
          } else {
            // 不足8位数字时，用0补全
            valueCusCode = numbers.padEnd(7, '0') + '-' + (numbers[7] || '0')
          }
        }
        return valueCusCode
      case 'eori':
        // 先转换为大写
        const valueEori = value.toUpperCase()

        // 过滤不合规字符，只保留大写字母和数字
        return valueEori
          .replace(/[^A-Z0-9]/g, '')
          .slice(0, 17) // 限制长度为17个字符
      default:
        return value
    }
  }

  validAndCounvertFieldByAddress(addressForm, field) {
    // 如果字段值为空，直接返回
    if (!addressForm[field]) {
      return
    }

    // 验证规则配置
    const validationRules = {
      // 名称和地址字段规则
      nameAndAddress: {
        fields: [
          'name', 'address1', 'address2'
        ],
        pattern: /[^a-zA-Z0-9"\-/,: '_"+]/g,
        maxLength: 70,
        transform: value => value
      },

      // 街道号和邮编规则
      streetNoAndPostal: {
        fields: [
          'streetNo', 'postalcode'
        ],
        pattern: /[^A-Z0-9 /-]/g,
        maxLength: 10,
        transform: value => value.toUpperCase()
      },

      // 城市规则
      city: {
        fields: [
          'city'
        ],
        pattern: /[^A-Z0-9 /-]/g,
        maxLength: 35,
        transform: value => value.toUpperCase()
      },

      // 电话规则
      telephone: {
        fields: [
          'tel'
        ],
        pattern: /[^+\d \-]/g,
        transform: value => value
      },
      // EORI规则
      eori: {
        fields: [
          'eori'
        ],
        pattern: /[^A-Z0-9]/g,
        maxLength: 17,
        transform: value => value.toUpperCase()
      }
    }

    // 查找适用的规则
    const rule = Object.values(validationRules).find(r => r.fields.includes(field))
    if (!rule) {
      return ''
    }

    // 应用验证规则
    let value = rule.transform(addressForm[field])
    value = value.replace(rule.pattern, '')
    if (rule.maxLength) {
      value = value.slice(0, rule.maxLength)
    }

    // 如果值发生变化，更新表单
    if (value !== addressForm[field]) {
      addressForm[field] = value
    }
  }

  buildContainerHandler(containerInfoResult) {
    // 创建新的箱子对象
    return containerInfoResult.map(item => {
      // 创建基础数据对象
      const baseContainer = new EDIContainer().fillDefaultValue().getData()

      // 设置基本属性
      baseContainer.deleted = false
      baseContainer.cargoDocUuid = this.form.uuid
      baseContainer.containerUsageUuid = null

      // 设置默认值
      baseContainer.containerNo = item.containerNo || ''
      baseContainer.sealNo = item.sealNo || ''
      baseContainer.quantity = item.quantity || 0
      baseContainer.weight = item.weight || 0
      baseContainer.cubage = item.cubage || 0
      baseContainer.mark = item.mark || ''
      baseContainer.cargoName = item.cargoName || ''

      // 处理设备类型和尺寸相关字段
      baseContainer.eqType = item.eqType || ''
      baseContainer.eqSize = item.eqSize || ''

      // 特别处理 eqCode 字段
      if (item.eqType && item.eqSize) {
        const containerSize = SystemConstants.EF_ENS_CONTAINER_MAP.get(item.eqSize + item.eqType)
        if (containerSize) {
          item.eqCode = containerSize
        } else {
          baseContainer.eqCode = ''
        }
      }

      // 特别处理 eqCode 字段
      if (item.hsCode) {
        item.linkedCargoInformationNo = item.hsCode
      }

      // 设置所有权代码
      baseContainer.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_1_AI.code

      // 合并其他识别到的字段
      return {
        ...baseContainer,
        ...item
      }
    })
  }

  buildCargoInfoHandler(curAms, cargoInfoResult) {
    const newCargoInfo = cargoInfoResult.map(item => {
      // 创建新对象并直接赋值识别结果
      return {
        // 基础字段与默认值
        newUuid: UIDUtil.createUID(),
        deleted: false,
        mark: item.mark,
        correlativeContainerNo: item.correlativeContainerNo || '',
        correlativeContainerNoList: item.correlativeContainerNo ? item.correlativeContainerNo.split(',').filter(Boolean) : [],

        // 识别的主要字段
        hsCode: item.hsCode || '',
        cargoEnglishName: item.cargoEnglishName || '',
        weight: item.weight || '',
        quantity: item.quantity || '',
        packing: item.packing || '',
        undgCode: item.undgCode || '',
        cusCode: item.cusCode || '',
        cubage: item.cubage,

        // 其他可能的字段
        ...item
      }
    })

    curAms.ensCargoInfo = [...curAms.ensCargoInfo, ...newCargoInfo]
  }

  /**
   * AI识别结果后将数据更新
   */
  updateAmsPostAiHandler(from, to) {
    const formFieldList = ['hblNbr2', 'carrierEori', 'declarantEori', 'frob', 'declaringMemberCountry', 'mbl', 'chargesPaymentMethod', 'loadingPortCode', 'dischargingPortCode']
    const afrAddressFieldList = ['shipperLine1', 'shipperLine3', 'shipperLine4', 'shipperStreetNo', 'shipperPostalcode', 'shipperCountry', 'shipperCity', 'shipperTel',
      'shipperEmail', 'shipperTypeOfPerson', 'shipperEori', 'consigneeLine1', 'consigneeLine3', 'consigneeLine4', 'consigneeStreetNo', 'consigneePostalcode', 'consigneeCountry',
      'consigneeCity', 'consigneeTel', 'consigneeEmail', 'consigneeTypeOfPerson', 'consigneeEori', 'sellerName', 'sellerAddress1', 'sellerAddress2', 'sellerStreetNo',
      'sellerPostalcode', 'sellerCity', 'sellerCountry', 'sellerTel', 'sellerEmail', 'sellerTypeOfPerson', 'sellerEori', 'buyerName', 'buyerAddress1', 'buyerAddress2',
      'buyerStreetNo', 'buyerPostalcode', 'buyerCountry', 'buyerCity', 'buyerTel', 'buyerEmail', 'buyerContactName', 'buyerTypeOfPerson', 'buyerEori', 'carrierName',
      'carrierAddress1', 'carrierAddress2', 'carrierStreetNo', 'carrierPostalcode', 'carrierEmail', 'carrierTel', 'carrierCity', 'carrierCountry']

    // 更新基本表单字段
    formFieldList.forEach(field => {
      if (from[field]) {
        to[field] = from[field]
      }
    })

    // 更新地址相关字段
    if (from.afrAddress && from.afrAddress.length > 0 && to.afrAddress && to.afrAddress.length > 0) {
      const fromAddress = from.afrAddress[0]
      const toAddress = to.afrAddress[0]

      afrAddressFieldList.forEach(field => {
        if (fromAddress[field]) {
          toAddress[field] = fromAddress[field]
        }
      })
    }
  }
  syncAfrAddressPostAiHandler(cargoDoc) {
    const addressForm = cargoDoc.afrAddress[0]
    if (addressForm.copyToSeller && cargoDoc.declarationType === 'F15') {
      for (const oraginFieldName of ColumnUtils.shipperToSellerMap.keys()) {
        const targetFieldName = ColumnUtils.shipperToSellerMap.get(oraginFieldName)
        addressForm[targetFieldName] = addressForm[oraginFieldName]
        cargoDoc.noHouseNumberBySeller = cargoDoc.noHouseNumberByShipper
      }
    }
    if (addressForm.copyToBuyer && cargoDoc.declarationType === 'F15') {
      for (const oraginFieldName of ColumnUtils.consigneeToBuyerMap.keys()) {
        const targetFieldName = ColumnUtils.consigneeToBuyerMap.get(oraginFieldName)
        addressForm[targetFieldName] = addressForm[oraginFieldName]
        cargoDoc.noHouseNumberByBuyer = cargoDoc.noHouseNumberByConsignee
      }
    }
    // 如果收发货人买家卖家的门牌号值为N/A就将勾选对应的没有门牌号字段
    if (addressForm.shipperStreetNo && addressForm.shipperStreetNo === 'N/A') {
      cargoDoc.noHouseNumberByShipper = true
    }
    if (addressForm.consigneeStreetNo && addressForm.consigneeStreetNo === 'N/A') {
      cargoDoc.noHouseNumberByConsignee = true
    }
    if (cargoDoc.sellerStreetNo && cargoDoc.sellerStreetNo === 'N/A') {
      cargoDoc.noHouseNumberBySeller = true
    }
    if (cargoDoc.buyerStreetNo && cargoDoc.buyerStreetNo === 'N/A') {
      cargoDoc.noHouseNumberByBuyer = true
    }
  }
  aiRecognitionFiledConvertHandler(curAms) {
    // 港口 识别的是英文并且赋值在loadingPortCode 和dischargingPortCode 上，如果能够识别就赋值上，如果识别不到就为空
    if (curAms.loadingPortCode) {
      const aiRecognitionLoadingPort = curAms.loadingPortCode
      const loadingPort = getObjectByCacheMatchFiled(basicCacheKeys.basic_data_Seaport, ['englishName', 'code', 'chineseName'], aiRecognitionLoadingPort)
      curAms.loadingPort = loadingPort ? loadingPort.englishName : ''
      curAms.loadingPortCode = loadingPort ? loadingPort.code : ''
    }

    if (curAms.dischargingPortCode) {
      const aiRecognitionDischargingPort = curAms.dischargingPortCode
      const dischargingPort = getObjectByCacheMatchFiled(basicCacheKeys.basic_data_Seaport, ['englishName', 'code', 'chineseName'], aiRecognitionDischargingPort)
      curAms.dischargingPort = dischargingPort ? dischargingPort.englishName : ''
      curAms.dischargingPortCode = dischargingPort ? dischargingPort.code : ''
    }

    // 船公司 无需处理会自动识别映射 如果映射不上会创建一个undefined的数据
    // `${item.shipCompanyCode	} | ${item.carrierEori} | ${item.shipCompanyEnglishName} | ${item.shipCompanyChineseName}`
    if (curAms.carrierEori) {
      if (this.view.localData.shipCompanyInfos && this.view.localData.shipCompanyInfos.length) {
        // 匹配船公司
        const carrierEoriSearchValue = curAms.carrierEori
        const shipperCompany = this.view.localData.shipCompanyInfos.find(item =>
          item.carrierEori === carrierEoriSearchValue ||
            item.shipCompanyCode === carrierEoriSearchValue ||
            item.shipCompanyEnglishName === carrierEoriSearchValue ||
            item.shipCompanyChineseName === carrierEoriSearchValue
        )
        curAms.carrierEori = shipperCompany && shipperCompany.carrierEori ? shipperCompany.carrierEori : ''
      } else {
        curAms.carrierEori = ''
      }
    }

    // 申报人 如果有值就匹配数据源将相关的字段赋值
    if (curAms.declarantEori) {
      if (this.view.localData.officeEoriList && this.view.localData.officeEoriList.length) {
        const declarantEoriSearchValue = curAms.declarantEori
        const officeEori = this.view.localData.officeEoriList.find(doc => doc.eori === declarantEoriSearchValue || doc.name === declarantEoriSearchValue)
        if (officeEori) {
          // 申报人也就是承运人相关赋值
          const addressForm = curAms.afrAddress[0]
          curAms.declarantEori = officeEori.eori
          addressForm.carrierName = officeEori.name
          addressForm.carrierAddress1 = officeEori.address1
          addressForm.carrierAddress2 = officeEori.address2
          addressForm.carrierStreetNo = officeEori.streetNo
          addressForm.carrierPostalcode = officeEori.postalcode
          addressForm.carrierEmail = officeEori.email
          addressForm.carrierTel = officeEori.tel
          addressForm.carrierCity = officeEori.city
          addressForm.carrierCountry = officeEori.country
        }
      } else {
        const addressForm = curAms.afrAddress[0]
        curAms.declarantEori = ''
        addressForm.carrierName = ''
        addressForm.carrierAddress1 = ''
        addressForm.carrierAddress2 = ''
        addressForm.carrierStreetNo = ''
        addressForm.carrierPostalcode = ''
        addressForm.carrierEmail = ''
        addressForm.carrierTel = ''
        addressForm.carrierCity = ''
        addressForm.carrierCountry = ''
      }
    }

    // 第一欧盟入境国
    if (curAms.declaringMemberCountry) {
      if (this.view.localData.ytCountry && this.view.localData.ytCountry.length) {
        const declaringMemberCountrySearchValue = curAms.declaringMemberCountry
        const findValue = this.view.localData.ytCountry.find(doc => doc.name === declaringMemberCountrySearchValue || doc.code === declaringMemberCountrySearchValue)
        curAms.declaringMemberCountry = findValue ? findValue.code : ''
      }
    } else {
      curAms.declaringMemberCountry = ''
    }

    // 运输类型 识别已经处理默认值
    if (curAms.frob) {
      const findValue = SystemConstants.AMS_ENS_TRANSPORT_TYPES_AI.find(item => item.code === curAms.frob)
      if (!findValue) {
        curAms.frob = ''
      }
    }
    // MBL主单号 进行格式化验证
    if (curAms.mbl) {
      // 1. 转大写并过滤不合规字符(只保留大写字母、数字、短横杠、斜杠)
      let formattedValue = curAms.mbl.toUpperCase().replace(/[^A-Z0-9\-/]/g, '')

      // 2. 限制长度为30个字符
      formattedValue = formattedValue.slice(0, 30)

      // 3. 更新表单值
      curAms.mbl = formattedValue
    }

    // 付款方式 识别已经处理默认值
    if (curAms.chargesPaymentMethod) {
      const findValue = SystemConstants.AMS_ENS_PAYMENT_METHODS.find(item => item.code === curAms.chargesPaymentMethod)
      if (!findValue) {
        curAms.chargesPaymentMethod = ''
      }
    }
    // 处理收发通的中的国家字段 ${item.code} | ${item.name} | ${item.chineseName}
    if (curAms.afrAddress && curAms.afrAddress.length) {
      const curAmsAfrAddress = curAms.afrAddress[0]
      this.convertAfrAddressCountry(curAmsAfrAddress, 'shipperCountry')
      this.convertAfrAddressCountry(curAmsAfrAddress, 'consigneeCountry')
      this.convertAfrAddressCountry(curAmsAfrAddress, 'sellerCountry')
      this.convertAfrAddressCountry(curAmsAfrAddress, 'buyerCountry')
    }
  }

  convertAfrAddressCountry(curAmsAfrAddress, field) {
    if (curAmsAfrAddress[field]) {
      const country = getObjectByCacheMatchFiled(basicCacheKeys.basic_data_Country, ['code', 'name', 'chineseName'], curAmsAfrAddress[field])
      curAmsAfrAddress[field] = country ? country.code : ''
    }
  }

  buildCargoDoc(hblNbr2) {
    // 创建新的空白分单
    const curAms = new SeaCargoDoc().fillDefaultValue().getData()
    curAms.jobUuid = this.job.uuid
    curAms.docType = CargoDocConsts.AMS
    curAms.dateCreated = DateUtils.customFormat(new Date(), 'YYYY-MM-DD HH:mm:ss')

    if (!hblNbr2) {
      const hblNbr2NewValue = this.findMaxHblNbr2AndIncrement([...this.amsDataList])
      if (hblNbr2NewValue) {
        curAms.hblNbr2 = hblNbr2NewValue
      } else {
        curAms.hblNbr2 = this.job.jobNo
      }
    } else {
      curAms.hblNbr2 = hblNbr2
    }

    // 初始化货物信息
    if (!curAms.afrAddress && !curAms.afrAddress.length) {
      const defaultAfrAddressArr = []
      const newAfrAddress = new AfrAddress().fillDefaultValue().getData()
      newAfrAddress.copyToSeller = true
      newAfrAddress.copyToBuyer = true
      defaultAfrAddressArr.push(newAfrAddress)
      curAms.afrAddress = defaultAfrAddressArr
    }

    // 货物信息
    curAms.ensCargoInfo = []

    // 填充默认值
    this.fillCustomFieldDefaultValue(curAms)

    return curAms
  }

  findMaxHblNbr2AndIncrement(thisAmsDataList = []) {
    if (!thisAmsDataList || !thisAmsDataList.length) {
      return null
    }
    let maxNumber = -1 // 初始化最大数字为 -1，假设所有数字都是正数
    let resultHblNbr2 = null // 用于存储最终结果
    let hasHyphenNumber = false // 标记是否存在以横线数字结尾的 hblNbr2

    for (let i = 0; i < thisAmsDataList.length; i++) {
      const hblNbr2 = thisAmsDataList[i].hblNbr2

      // 检查 hblNbr2 是否存在且以横线数字结尾
      if (hblNbr2 && typeof hblNbr2 === 'string') {
        const match = hblNbr2.match(/-([0-9]+)$/) // 使用正则表达式匹配以横线数字结尾的部分
        if (match) {
          hasHyphenNumber = true // 标记存在以横线数字结尾的 hblNbr2
          const number = parseInt(match[1], 10) // 提取数字部分并转换为整数
          if (number > maxNumber) {
            maxNumber = number // 更新最大数字
            resultHblNbr2 = hblNbr2 // 更新结果
          }
        }
      }
    }

    // 如果找到了符合条件的 hblNbr2，将数字部分加1
    if (resultHblNbr2) {
      const incrementedHblNbr2 = resultHblNbr2.replace(/-([0-9]+)$/, (match, number) => {
        return `-${parseInt(number, 10) + 1}` // 将数字部分加1
      })
      return incrementedHblNbr2 // 返回加1后的结果
    }

    // 如果没有以横线数字结尾的 hblNbr2，使用最后一个元素的 hblNbr2 作为基础
    if (!hasHyphenNumber && thisAmsDataList.length > 0) {
      const lastHblNbr2 = thisAmsDataList[thisAmsDataList.length - 1].hblNbr2
      if (lastHblNbr2) {
        return `${lastHblNbr2}-1` // 在最后一个 hblNbr2 后添加 "-1"
      }
    }

    return null // 如果数组为空或最后一个 hblNbr2 为空，返回 null
  }

  fillCustomFieldDefaultValue(curAms) {
    // 船公司 默认根据基本页签，船公司字段的值自动填充
    this.fillCarrierEori(curAms)

    // 申报人 是，默认选中权限设置，反恐舱单设置中维护的第一个EORI
    if (this.view.localData.officeEoriList && this.view.localData.officeEoriList.length) {
      const officeEori = this.view.localData.officeEoriList[0]

      this.form.declarantEori = officeEori.eori
      // 申报人也就是承运人相关赋值
      const addressForm = curAms.afrAddress[0]
      curAms.declarantEori = officeEori.eori
      addressForm.carrierName = officeEori.name
      addressForm.carrierAddress1 = officeEori.address1
      addressForm.carrierAddress2 = officeEori.address2
      addressForm.carrierStreetNo = officeEori.streetNo
      addressForm.carrierPostalcode = officeEori.postalcode
      addressForm.carrierEmail = officeEori.email
      addressForm.carrierTel = officeEori.tel
      addressForm.carrierCity = officeEori.city
      addressForm.carrierCountry = officeEori.country
    }

    // 报文类型默认为F15
    if (!curAms?.declarationType) {
      curAms.declarationType = 'F15'
    }

    // 运输类型 默认选中Import
    if (!curAms?.frob) {
      curAms.frob = SystemConstants.AMS_ENS_TRANSPORT_TYPE_I.code
    }

    // 主单号 默认取值MBL页签MBL No字段
    if (!curAms?.mbl) {
      curAms.mbl = this.job?.mbl || ''
    }

    // 付款方式 默认选中Other(e.g.direct debit to cash account) | 其他
    if (!curAms?.chargesPaymentMethod) {
      curAms.chargesPaymentMethod = SystemConstants.AMS_ENS_PAYMENT_D.code
    }

    // 起运港	默认取基本页签的起运港
    if (!curAms?.loadingPortCode) {
      curAms.loadingPortCode = this.job?.loadingPortCode || ''
    }

    // 目的港	默认取基本页签的卸货港
    if (!curAms?.dischargingPortCode) {
      curAms.dischargingPortCode = this.job?.dischargingPortCode || ''
    }

    // 收货人、发货人、卖家、买家  类型	默认选中Legal person | 法人
    if (!curAms.afrAddress[0].shipperTypeOfPerson) {
      curAms.afrAddress[0].shipperTypeOfPerson = '1'
    }
    if (!curAms.afrAddress[0].consigneeTypeOfPerson) {
      curAms.afrAddress[0].consigneeTypeOfPerson = '1'
    }
    if (!curAms.afrAddress[0].sellerTypeOfPerson) {
      curAms.afrAddress[0].sellerTypeOfPerson = '1'
    }
    if (!curAms.afrAddress[0].buyerTypeOfPerson) {
      curAms.afrAddress[0].buyerTypeOfPerson = '1'
    }
    // 填充勾选项默认值
    this.fillEnsCheckBoxDefaultValue(curAms)

    // 如果是AMS
    if (this.view.tabAms && this.view.amsIsLink) {
      const containerLoadTypes = ['FCL', 'BCF']
      curAms.containerLoadType = containerLoadTypes.includes(this.job.containerLoadType) ? 'FCL' : 'LCL'
      this.fillCarrierEori(curAms)
    }
  }

  fillEnsCheckBoxDefaultValue(cargoDoc) {
    cargoDoc.afrAddress[0].copyToSeller = true
    cargoDoc.afrAddress[0].copyToBuyer = true
    cargoDoc.noHouseNumberByShipper = false
    cargoDoc.noHouseNumberByConsignee = false
    cargoDoc.noHouseNumberBySeller = false
    cargoDoc.noHouseNumberByBuyer = false
  }

  syncSellerAndBuyerInfoAfrAddress(cargoDoc) {
    if (!cargoDoc || !cargoDoc.afrAddress || !cargoDoc.afrAddress.length) {
      return
    }

    const afrAddress = cargoDoc.afrAddress[0]

    if (afrAddress.copyToSeller) {
      for (const oraginFieldName of ColumnUtils.shipperToSellerMap.keys()) {
        const targetFieldName = ColumnUtils.shipperToSellerMap.get(oraginFieldName)
        afrAddress[targetFieldName] = afrAddress[oraginFieldName]
      }
    }
    if (afrAddress.copyToBuyer) {
      for (const oraginFieldName of ColumnUtils.consigneeToBuyerMap.keys()) {
        const targetFieldName = ColumnUtils.consigneeToBuyerMap.get(oraginFieldName)
        afrAddress[targetFieldName] = afrAddress[oraginFieldName]
      }
    }
  }

  syncAmsList(cargoDoc) {
    const newDOC = {}
    newDOC.hblNbr2 = cargoDoc.hblNbr2
    newDOC.EFSTATUS = -1
    newDOC.AMSSTATUS = -1
    newDOC.ISF5STATUS = -1
    newDOC.ISF10STATUS = -1
    newDOC.ENSSTATUS = -1
    this.view.ams2.rowData.push(newDOC)
  }

  syncAmsListByNewEns(cargoDoc) {
    const newDOC = {}
    newDOC.hblNbr2 = cargoDoc.hblNbr2
    newDOC.EFSTATUS = -1
    newDOC.AMSSTATUS = -1
    newDOC.ISF5STATUS = -1
    newDOC.ISF10STATUS = -1
    newDOC.ENSSTATUS = -1
    newDOC.docType = CargoDocConsts.AMS
    this.view.ams2.rowData.push(newDOC)
  }

  getAmsList() {
    return this.cargoDocs.filter(p => !p.deleted && p.docType === 'AMS').sort((a, b) => {
      const suffixA = a.hblNbr2.replace(`${this.job.jobNo}-`, '')
      const suffixB = b.hblNbr2.replace(`${this.job.jobNo}-`, '')
      return suffixA - suffixB
    })
  }

  async btnSynchroAfrClickHandler() {
    // 如果已有的ams数量大于HBL+HBL2数量，则弹窗提醒删除指定条数数据
    let seaCargoDoc = []
    let seaCargoMap = {}
    let lclSlavesMap = {}
    const currentAfrNo = this.afrForm.hblNbr2
    if (this.job.masterFlag) {
      if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
        lclSlavesMap = this.job.lclSlaves.reduce((acc, cur) => {
          acc[cur.uuid] = cur.jobNo
          return acc
        }, {})
        // 获取lclSlaves中的uuid转为list
        const jobUuidList = this.job.lclSlaves.map(p => p.uuid)
        jobUuidList.push(this.job.uuid)
        await loadLclJobSeaCargoDocList(jobUuidList).then(resp => {
          seaCargoDoc = resp.data || []
          seaCargoDoc = seaCargoDoc.filter(item => item.docType === CargoDocConsts.HBL || item.docType === CargoDocConsts.HBL2)
          seaCargoMap = seaCargoDoc.reduce((acc, cur) => {
            acc[cur.hblNbr2] = cur.jobUuid
            return acc
          }, {})
        })
      }
    } else {
      seaCargoDoc = await new SeaExportJob(this.job).getCargoDoc()
    }
    const sourceCargoDoc = []
    for (const item of seaCargoDoc) {
      if (!item.hblNbr2 || item.deleted) continue
      if (item.docType === CargoDocConsts.HBL || item.docType === CargoDocConsts.HBL2) {
        sourceCargoDoc.push(item)
      }
    }
    if (!sourceCargoDoc || sourceCargoDoc.length === 0) {
      // 不存在可复制的HBL或HBL拆单
      return
    }
    const afrList = this.getAfrList()
    let flg = false
    for (const afr of this.afrCargoDocs) {
      if (afr && !afr.deleted && afr.fromAdd) {
        flg = true
        break
      }
    }
    if (flg) {
      const confirmOk = await this.$confirm(this.view.$t('SeaExport.ConfirmSynchronizeHBL'), this.view.$t('SeaExport.tips'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        return true
      }).catch(() => {
        return false
      })
      if (!confirmOk) {
        return
      }
    }

    if (afrList && afrList.length > sourceCargoDoc.length) {
      for (let i = 0; i < afrList.length - sourceCargoDoc.length; i++) {
        this.deleteAfr(afrList.length - i - 1)
      }
    }
    this.view.afr2.rowData = []
    for (let i = 0; i < sourceCargoDoc.length; i++) {
      const hbl = sourceCargoDoc[i]
      let jobNo = ''
      if (this.job.masterFlag) {
        if (seaCargoMap[hbl.hblNbr2]) {
          jobNo = lclSlavesMap[seaCargoMap[hbl.hblNbr2]]
        }
      }
      if (!jobNo) {
        jobNo = this.job.jobNo
      }
      if (!afrList || afrList.length < i + 1) {
        await this.addAfr(hbl, jobNo)
        continue
      }
      const curAfr = afrList[i]
      curAfr.afrLast = false
      await this.cloneSeaCargoDoc(curAfr, hbl)
      this.syncAfrList(curAfr, jobNo)
    }
    if (this.view.afr2.rowData && this.view.afr2.rowData.length > 0) {
      const afrLastCount = this.view.afr2.rowData.filter(p => p.afrLast).length
      if (afrLastCount === 0) {
        const lastAfr = this.view.afr2.rowData[this.view.afr2.rowData.length - 1]
        lastAfr.afrLast = true
        const lastDoc = this.afrCargoDocs.find(p => p.hblNbr2 === lastAfr.hblNbr2)
        if (lastDoc) {
          lastDoc.afrLast = true
        }
      }
    }
    this.view.afr2.rowData = this.getAfr2List()
    const newAfrList = this.getAfrList()
    if (newAfrList.length > 0) {
      const currentDoc = newAfrList.find(p => p.hblNbr2 === currentAfrNo)
      if (currentDoc) {
        this.afrForm = currentDoc
      } else {
        this.afrForm = this.view.afr2FinalRowData[0]
      }
      this.afrForm.frob = this.afrForm.frob ? this.afrForm.frob : 'I'
      setTimeout(() => {
        this.view.afr2.gridApi.clearFocusedCell()
        const index = this.view.afr2.rowData.findIndex(afr => afr.hblNbr2 === this.afrForm.hblNbr2)
        this.setSelectAfrNode(index)
      }, 100)
    }
    this.view.afr2.gridOptions.api.clearFocusedCell()
    this.view.afr2.gridOptions.api.refreshCells({ force: true })
    this.afrDataList = this.view.afr2.rowData
    await this.syncContainer(sourceCargoDoc)
    this.setNameOfCountry()
  }
  async syncContainer(sourceCargoDoc) {
    if (this.job.masterFlag && this.job.containers && this.job.containers.length > 0) {
      let usages = []
      for (const container of this.job.containers) {
        if (container.containerUsage && container.containerUsage.length > 0) {
          usages = usages.concat(container.containerUsage)
        }
      }
      if (usages && usages.length > 0) {
        await this.addSyncMasterContainer(usages, sourceCargoDoc)
      }
    } else {
      await this.addSyncNormalContainer(this.job.containerUsages)
    }
  }
  async addSyncNormalContainer(usages) {
    if (!usages) {
      return
    }
    const activeTabName = this.view.activeTabName
    let cargoDocs = []
    if (this.view.isJs) {
      if (activeTabName === 'ams' || activeTabName === 'aci') {
        cargoDocs = this.cargoDocs
      } else {
        cargoDocs = this.afrCargoDocs
      }
    }
    for (const doc of cargoDocs) {
      const curContainer = await new SeaCargoDoc(doc).getEdiContainer()
      for (const item of usages) {
        if (!await this.existAfrContainerUsage(item, doc)) {
          const ec = new EDIContainer().fillDefaultValue().getData()
          ec.deleted = false
          ec.containerNo = item.container.containerNo
          ec.sealNo = item.container.sealNo
          ec.eqType = item.container.eqType
          ec.eqSize = item.container.eqSize
          ec.quantity = Number(item.quantity)
          ec.weight = Number(item.weight)
          ec.cubage = Number(item.cubage)
          ec.mark = item.mark
          ec.cargoName = item.cargoName
          ec.cargoDocUuid = doc.uuid
          ec.containerUsageUuid = null
          ec.hsCodeContainer = this.afrForm.hsCode
          if (this.view.isJs) {
            if (activeTabName === 'ams') {
              if (item.container.eqType === 'RF') {
                ec.eqCode = SystemConstants.JS_AFR_CZ.code
              } else if (item.container.eqType === 'OT' && item.container.eqSize === '20') {
                ec.eqCode = SystemConstants.JS_AFR_20.code
              } else if (item.container.eqType === 'OT' && item.container.eqSize === '40') {
                ec.eqCode = SystemConstants.JS_AFR_40.code
              } else if ((item.container.eqType === 'GP' || item.container.eqType === 'HQ' || item.container.eqType === 'HC') && item.container.eqSize === '20') {
                ec.eqCode = SystemConstants.JS_AFR_2B.code
              } else if ((item.container.eqType === 'GP' || item.container.eqType === 'HQ' || item.container.eqType === 'HC') && item.container.eqSize === '40') {
                ec.eqCode = SystemConstants.JS_AFR_4B.code
              } else {
                ec.eqCode = SystemConstants.JS_AFR_CN.code
              }
              if (item.packing) {
                ec.packing = item.packing
              } else if (doc.packing) {
                ec.packing = doc.packing
              }
            } else if (activeTabName === 'afr') {
              if (item.container.eqType === 'RF' || item.container.eqType === 'REEFER') {
                ec.eqType = SystemConstants.JS_AFR_RT.code
              } else if (item.container.eqType === 'OT') {
                ec.eqType = SystemConstants.JS_AFR_UT.code
              } else if (item.container.eqType === 'FR') {
                ec.eqType = SystemConstants.JS_AFR_PF.code
              } else if (item.container.eqType === 'PC') {
                ec.eqType = SystemConstants.JS_AFR_PL.code
              } else if (item.container.eqType === 'TK') {
                ec.eqType = SystemConstants.JS_AFR_TN.code
              } else if (item.container.eqType === 'GP' || item.container.eqType === 'HC' || item.container.eqType === 'HQ') {
                ec.eqType = SystemConstants.JS_AFR_GP.code
              } else {
                ec.eqType = SystemConstants.JS_AFR_SN.code
              }
              if (item.soc) {
                ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_1.code
              } else {
                ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_2.code
              }
              if (item.container.eqType === 'HQ' || item.container.eqType === 'HC') {
                ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_5.code
              } else {
                ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_2.code
              }
            } else if (activeTabName === 'aci') {
              if (item.packing) {
                ec.packing = item.packing
              } else if (doc.packing) {
                ec.packing = doc.packing
              }
            }
          }
          if (activeTabName === 'ens') {
            if (item.soc) {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_1.code
            } else {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_2.code
            }
            const containerSize = SystemConstants.EF_ENS_CONTAINER_MAP.get(item.container.eqSize + item.container.eqType)
            if (containerSize) {
              ec.eqCode = containerSize
            }
          }
          curContainer.push(ec)
        }
      }
      if (doc.hblNbr2 === this.afrForm.hblNbr2 && activeTabName === 'afr') {
        this.view.afrContainer.rowData = curContainer
      } else if (doc.hblNbr2 === this.form.hblNbr2) {
        this.view.container.rowData = curContainer
      }
    }
    if (this.afrForm.docType === CargoDocConsts.AFR) {
      await this.refreshAfrEdiGrid()
    }
  }

  /**
   * ens同步箱子处理
   * @param usages
   * @returns {Promise<void>}
   */
  async addSyncNormalContainerByEns(usages) {
    if (!usages) {
      return
    }
    const activeTabName = this.view.activeTabName
    let cargoDocs = []
    if (this.view.isJs) {
      if (activeTabName === 'ams' || activeTabName === 'aci') {
        cargoDocs = this.cargoDocs
      } else {
        cargoDocs = this.afrCargoDocs
      }
    }
    for (const doc of cargoDocs) {
      const curContainer = await new SeaCargoDoc(doc).getEdiContainer()
      for (const item of usages) {
        if (!await this.existAfrContainerUsage(item, doc)) {
          const ec = new EDIContainer().fillDefaultValue().getData()
          ec.deleted = false
          ec.containerNo = item.container.containerNo
          ec.sealNo = item.container.sealNo
          ec.eqType = item.container.eqType
          ec.eqSize = item.container.eqSize
          ec.quantity = Number(item.quantity)
          ec.weight = Number(item.weight)
          ec.cubage = Number(item.cubage)
          ec.mark = item.mark
          ec.cargoName = item.cargoName
          ec.cargoDocUuid = doc.uuid
          ec.containerUsageUuid = null
          ec.hsCodeContainer = this.afrForm.hsCode
          if (this.view.isJs) {
            if (activeTabName === 'ams') {
              if (item.container.eqType === 'RF') {
                ec.eqCode = SystemConstants.JS_AFR_CZ.code
              } else if (item.container.eqType === 'OT' && item.container.eqSize === '20') {
                ec.eqCode = SystemConstants.JS_AFR_20.code
              } else if (item.container.eqType === 'OT' && item.container.eqSize === '40') {
                ec.eqCode = SystemConstants.JS_AFR_40.code
              } else if ((item.container.eqType === 'GP' || item.container.eqType === 'HQ' || item.container.eqType === 'HC') && item.container.eqSize === '20') {
                ec.eqCode = SystemConstants.JS_AFR_2B.code
              } else if ((item.container.eqType === 'GP' || item.container.eqType === 'HQ' || item.container.eqType === 'HC') && item.container.eqSize === '40') {
                ec.eqCode = SystemConstants.JS_AFR_4B.code
              } else {
                ec.eqCode = SystemConstants.JS_AFR_CN.code
              }
              if (item.packing) {
                ec.packing = item.packing
              } else if (doc.packing) {
                ec.packing = doc.packing
              }
            } else if (activeTabName === 'afr') {
              if (item.container.eqType === 'RF' || item.container.eqType === 'REEFER') {
                ec.eqType = SystemConstants.JS_AFR_RT.code
              } else if (item.container.eqType === 'OT') {
                ec.eqType = SystemConstants.JS_AFR_UT.code
              } else if (item.container.eqType === 'FR') {
                ec.eqType = SystemConstants.JS_AFR_PF.code
              } else if (item.container.eqType === 'PC') {
                ec.eqType = SystemConstants.JS_AFR_PL.code
              } else if (item.container.eqType === 'TK') {
                ec.eqType = SystemConstants.JS_AFR_TN.code
              } else if (item.container.eqType === 'GP' || item.container.eqType === 'HC' || item.container.eqType === 'HQ') {
                ec.eqType = SystemConstants.JS_AFR_GP.code
              } else {
                ec.eqType = SystemConstants.JS_AFR_SN.code
              }
              if (item.soc) {
                ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_1.code
              } else {
                ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_2.code
              }
              if (item.container.eqType === 'HQ' || item.container.eqType === 'HC') {
                ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_5.code
              } else {
                ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_2.code
              }
            } else if (activeTabName === 'aci') {
              if (item.packing) {
                ec.packing = item.packing
              } else if (doc.packing) {
                ec.packing = doc.packing
              }
            }
          }
          if (activeTabName === 'ens') {
            if (item.soc) {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_1.code
            } else {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_2.code
            }
            const containerSize = SystemConstants.EF_ENS_CONTAINER_MAP.get(item.container.eqSize + item.container.eqType)
            if (containerSize) {
              ec.eqCode = containerSize
            }
          }
          curContainer.push(ec)
        }
      }
      if (doc.hblNbr2 === this.afrForm.hblNbr2 && activeTabName === 'afr') {
        this.view.afrContainer.rowData = curContainer
      } else if (doc.hblNbr2 === this.form.hblNbr2) {
        this.view.container.rowData = curContainer
      }
    }
    if (this.afrForm.docType === CargoDocConsts.AFR) {
      await this.refreshAfrEdiGrid()
    }
  }
  async syncAfrInfo(field) {
    if (!field) {
      return
    }
    let vessel = null
    if (this.view.isJs && field === 'vessel') {
      let vesselGrid = []
      await getVesselList().then(res => {
        if (res.data) {
          vesselGrid = res.data.filter(p => p.englishName === this.afrForm[field])
        }
      })
      if (vesselGrid) {
        for (const item of vesselGrid) {
          if (item.regCountry) {
            vessel = item
            break
          }
        }
      }
    }
    for (const doc of this.afrCargoDocs) {
      doc[field] = this.afrForm[field]
      if (vessel) {
        doc.nationalityCodeofVessel = vessel.regCountry
        doc.vesselCode = vessel.callSign
      }
    }
  }
  syncThailandInfo(field) {
    if (!field) {
      return
    }
    for (const doc of this.thailandCargoDocs) {
      doc[field] = this.thailandForm[field]
    }
  }
  async btnSynchroThailandClickHandler() {
    if (this.job.masterFlag) {
      this.btnSynchroThailandClickHandlerMaster()
    } else {
      this.btnSynchroThailandClickHandlerSlave()
    }
  }
  async btnSynchroThailandClickHandlerMaster() {
    if (this.slaveHbls.length === 0) {
      return
    }
    const currentHblNbr2 = this.thailandForm.hblNbr2
    let count = 0
    for (let i = 0; i < this.thailandCargoDocs.length; ++i) {
      const cargoDoc = this.thailandCargoDocs[i]
      if (cargoDoc.deleted) {
        continue
      }
      if (count < this.slaveHbls.length) {
        cargoDoc.afrLast = false
        await this.cloneThailandCargoDoc(cargoDoc, this.slaveHbls[count])
        const lclSlave = this.lclSlaveJobMap.get(this.slaveHbls[count].jobUuid)
        cargoDoc.jobNo = lclSlave ? lclSlave.jobNo : ''
        count += 1
      } else {
        if (cargoDoc.uuid) {
          cargoDoc.deleted = true
        } else {
          this.thailandCargoDocs.splice(i, 1)
          i = i - 1
        }
      }
    }
    if (count < this.slaveHbls.length) {
      for (; count < this.slaveHbls.length; ++count) {
        const newDoc = new SeaCargoDoc().fillDefaultValue().getData()
        newDoc.jobUuid = this.job.uuid
        this.thailandCargoDocs.push(newDoc)
        await this.cloneThailandCargoDoc(newDoc, this.slaveHbls[count])
        const lclSlave = this.lclSlaveJobMap.get(this.slaveHbls[count].jobUuid)
        newDoc.jobNo = lclSlave ? lclSlave.jobNo : ''
      }
    }
    const rowData = this.thailandCargoDocs.filter(p => !p.deleted)
    const lastDoc = rowData[rowData.length - 1]
    lastDoc.afrLast = true
    await this.syncThailandContainer(this.slaveHbls)
    this.view.thailand2.rowData = rowData
    setTimeout(() => {
      const nodes = this.view.thailand2.gridApi.rowModel.rowsToDisplay
      for (const node of nodes) {
        if (node.data.hblNbr2 === currentHblNbr2) {
          this.view.thailand2.gridApi.setFocusedCell(node.rowIndex, this.view.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
          return
        }
      }
      this.view.thailand2.gridApi.setFocusedCell(0, this.view.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
    }, 100)
  }
  async btnSynchroThailandClickHandlerSlave() {
    const hbl = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL)
    if (!hbl) {
      return
    }
    let count = 0
    for (let i = 0; i < this.thailandCargoDocs.length; ++i) {
      const cargoDoc = this.thailandCargoDocs[i]
      if (cargoDoc.deleted) {
        continue
      }
      if (count < 1) {
        cargoDoc.afrLast = true
        await this.cloneThailandCargoDoc(cargoDoc, hbl)
        cargoDoc.jobNo = this.job.jobNo
        count += 1
      } else {
        if (cargoDoc.uuid) {
          cargoDoc.deleted = true
        } else {
          this.thailandCargoDocs.splice(i, 1)
          i = i - 1
        }
      }
    }
    if (count < 1) {
      const newDoc = new SeaCargoDoc().fillDefaultValue().getData()
      newDoc.jobUuid = this.job.uuid
      this.thailandCargoDocs.push(newDoc)
      newDoc.afrLast = true
      await this.cloneThailandCargoDoc(newDoc, hbl)
      newDoc.jobNo = this.job.jobNo
    }
    const rowData = this.thailandCargoDocs.filter(p => !p.deleted)
    await this.syncThailandContainer([hbl])
    this.view.thailand2.rowData = rowData
    setTimeout(() => {
      this.view.thailand2.gridApi.setFocusedCell(0, this.view.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
    }, 100)
  }
  async syncThailandContainer(sourceCargoDoc) {
    if (this.job.masterFlag) {
      if (this.job.containers && this.job.containers.length > 0) {
        let usages = []
        for (const container of this.job.containers) {
          if (container.containerUsage && container.containerUsage.length > 0) {
            usages = usages.concat(container.containerUsage)
          }
        }
        if (usages && usages.length > 0) {
          for (const doc of this.thailandCargoDocs) {
            const curContainer = await new SeaCargoDoc(doc).getEdiContainer()
            for (let i = curContainer.length - 1; i >= 0; --i) {
              const containerItem = curContainer[i]
              if (containerItem.uuid) {
                containerItem.deleted = true
              } else {
                curContainer.splice(i, 1)
              }
            }
            for (const item of usages) {
              const sourceDoc = sourceCargoDoc.find(p => p.hblNbr2 === doc.hblNbr2)
              if (sourceDoc && sourceDoc.jobUuid === item.jobUuid) {
                const ec = new EDIContainer().fillDefaultValue().getData()
                ec.deleted = false
                ec.containerNo = item.containerNo
                ec.sealNo = item.sealNo
                ec.eqType = item.eqType
                ec.eqSize = item.eqSize
                ec.quantity = Number(item.quantity)
                ec.weight = Number(item.weight)
                ec.cubage = Number(item.cubage)
                ec.mark = item.mark
                ec.cargoName = item.cargoName
                ec.containerUsageUuid = null
                ec.hsCodeContainer = this.thailandForm.hsCode
                ec.goodsCargoType = doc.docCargoType
                ec.containerStatus = doc.containerStatus
                ec.cargoDocUuid = doc.uuid
                curContainer.push(ec)
              }
            }
          }
        }
      }
    } else {
      if (this.job.containerUsages && this.job.containerUsages.length > 0) {
        for (const doc of this.thailandCargoDocs) {
          const curContainer = await new SeaCargoDoc(doc).getEdiContainer()
          for (let i = curContainer.length - 1; i >= 0; --i) {
            const containerItem = curContainer[i]
            if (containerItem.uuid) {
              containerItem.deleted = true
            } else {
              curContainer.splice(i, 1)
            }
          }
          for (const item of this.job.containerUsages) {
            const sourceDoc = sourceCargoDoc.find(p => p.hblNbr2 === doc.hblNbr2)
            if (sourceDoc && sourceDoc.jobUuid === item.jobUuid) {
              const ec = new EDIContainer().fillDefaultValue().getData()
              ec.deleted = false
              ec.containerNo = item.containerNo
              ec.sealNo = item.sealNo
              ec.eqType = item.eqType
              ec.eqSize = item.eqSize
              ec.quantity = Number(item.quantity)
              ec.weight = Number(item.weight)
              ec.cubage = Number(item.cubage)
              ec.mark = item.mark
              ec.cargoName = item.cargoName
              ec.containerUsageUuid = null
              ec.hsCodeContainer = this.thailandForm.hsCode
              ec.goodsCargoType = doc.docCargoType
              ec.containerStatus = doc.containerStatus
              ec.cargoDocUuid = doc.uuid
              curContainer.push(ec)
            }
          }
        }
      }
    }
  }

  async existThailandContainerUsage(u, doc) {
    const containerList = await new SeaCargoDoc(doc).getEdiContainer()
    const container = this.job.masterFlag ? u : u.container
    for (const item of containerList) {
      if (!item.deleted && container.eqSize === item.eqSize && container.eqType === item.eqType &&
        container.containerNo === item.containerNo && container.sealNo === item.sealNo) {
        item.hsCodeContainer = doc.hsCode
        return true
      }
    }
    return false
  }

  async addSyncMasterContainer(usages, sourceCargoDoc) {
    for (const doc of this.afrCargoDocs) {
      let curContainer = []
      for (const item of usages) {
        if (!await this.existAfrContainerUsage(item, doc)) {
          const sourceDoc = sourceCargoDoc.find(p => p.hblNbr2 === doc.hblNbr2)
          if (sourceDoc && sourceDoc.jobUuid === item.jobUuid) {
            curContainer = await new SeaCargoDoc(doc).getEdiContainer()
            const ec = new EDIContainer().fillDefaultValue().getData()
            ec.deleted = false
            ec.containerNo = item.containerNo
            ec.sealNo = item.sealNo
            ec.eqType = item.eqType
            ec.eqSize = item.eqSize
            ec.quantity = Number(item.quantity)
            ec.weight = Number(item.weight)
            ec.cubage = Number(item.cubage)
            ec.mark = item.mark
            ec.cargoName = item.cargoName
            ec.containerUsageUuid = null
            ec.hsCodeContainer = this.afrForm.hsCode
            if (this.view.isJs) {
              if (item.eqType === 'RF' || item.eqType === 'REEFER') {
                ec.eqType = SystemConstants.JS_AFR_RT.code
              } else if (item.eqType === 'OT') {
                ec.eqType = SystemConstants.JS_AFR_UT.code
              } else if (item.eqType === 'FR') {
                ec.eqType = SystemConstants.JS_AFR_PF.code
              } else if (item.eqType === 'PC') {
                ec.eqType = SystemConstants.JS_AFR_PL.code
              } else if (item.eqType === 'TK') {
                ec.eqType = SystemConstants.JS_AFR_TN.code
              } else if (item.eqType === 'GP' || item.eqType === 'HC' || item.eqType === 'HQ') {
                ec.eqType = SystemConstants.JS_AFR_GP.code
              } else {
                ec.eqType = SystemConstants.JS_AFR_SN.code
              }
              if (item.containerAscription && item.containerAscription === SeaExportConstants.CONTAINER_ASCRIPTION_SOC_STATE.code) {
                ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_1.code
              } else {
                ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_2.code
              }
              if (item.eqType === 'HQ' || item.eqType === 'HC') {
                ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_5.code
              } else {
                ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_2.code
              }
            }
            ec.cargoDocUuid = doc.uuid
            curContainer.push(ec)
          }
        }
      }
      if (doc.hblNbr2 === this.afrForm.hblNbr2) {
        this.view.afrContainer.rowData = curContainer
      }
    }
    if (this.afrForm.docType === CargoDocConsts.AFR) {
      await this.refreshAfrEdiGrid()
    }
  }

  syncAfrList(cargoDoc, jobNo) {
    const newDOC = {}
    if (jobNo) {
      newDOC.jobNo = jobNo
    }
    newDOC.hblNbr2 = cargoDoc.hblNbr2
    newDOC.afrStatus = -1
    newDOC.afrLast = false
    newDOC.afrReceiptStatus = ''
    this.view.afr2.rowData.push(newDOC)
  }
  getAfrList() {
    return this.afrCargoDocs.filter(p => !p.deleted && p.docType === 'AFR').sort((a, b) => {
      const suffixA = a.hblNbr2.substr(a.hblNbr2.indexOf('-') + 1, a.hblNbr2.length)
      const suffixB = b.hblNbr2.substr(b.hblNbr2.indexOf('-') + 1, b.hblNbr2.length)
      return suffixA - suffixB
    })
  }
  getAfr2List() {
    return this.view.afr2.rowData.sort((a, b) => {
      const suffixA = a.hblNbr2.substr(a.hblNbr2.indexOf('-') + 1, a.hblNbr2.length)
      const suffixB = b.hblNbr2.substr(b.hblNbr2.indexOf('-') + 1, b.hblNbr2.length)
      return suffixA - suffixB
    })
  }
  async addAfr(curHbl, jobNo) {
    // 如果cargoDocs中已有，则不新增数据
    // 没有该数据则新增一条
    // 没有该数据则新增一条
    const curAfr = new SeaCargoDoc().fillDefaultValue().getData()
    curAfr.jobUuid = this.job.uuid
    curAfr.afrLast = false
    await this.cloneSeaCargoDoc(curAfr, curHbl)
    curAfr.hsCode = curHbl.hsCode
    if (curAfr.hsCode && curAfr.hsCode.length > 6) {
      curAfr.hsCode = curAfr.hsCode.substring(0, 6)
    }
    this.view.afrCargoDocs.push(curAfr)
    const newDOC = {}
    if (jobNo) {
      newDOC.jobNo = jobNo
    }
    newDOC.hblNbr2 = curAfr.hblNbr2
    newDOC.afrStatus = -1
    newDOC.afrLast = false
    this.view.afr2.rowData.push(newDOC)
  }

  async addAms(curHbl) {
    // 如果cargoDocs中已有，则不新增数据
    // 没有该数据则新增一条
    // 没有该数据则新增一条
    const curAms = new SeaCargoDoc().fillDefaultValue().getData()
    curAms.jobUuid = this.job.uuid
    await this.cloneSeaCargoDoc(curAms, curHbl)
    this.view.cargoDocs.push(curAms)
    const newDOC = {}
    newDOC.hblNbr2 = curAms.hblNbr2
    newDOC.EFSTATUS = -1
    newDOC.AMSSTATUS = -1
    newDOC.ISF5STATUS = -1
    newDOC.ISF10STATUS = -1
    newDOC.ENSSTATUS = -1
    this.view.ams2.rowData.push(newDOC)
  }

  async addAmsByNewEns(curHbl) {
    // 如果cargoDocs中已有，则不新增数据
    // 没有该数据则新增一条
    // 没有该数据则新增一条
    const curAms = new SeaCargoDoc().fillDefaultValue().getData()
    curAms.jobUuid = this.job.uuid
    await this.cloneSeaCargoDocByNewEns(curAms, curHbl)
    // 填充默认值
    this.fillCustomFieldDefaultValue(curAms)
    // 格式化收发通信息
    this.convertAfrAddressByRule(curAms)
    // 同步收发通信息
    this.syncSellerAndBuyerInfoAfrAddress(curAms)
    this.view.cargoDocs.push(curAms)
    this.syncAmsListByNewEns(curAms)
  }

  deleteAms(docIndex) {
    // 现有ams数量大于HBL数量，删除后再同步数据
    const doc = this.cargoDocs[docIndex]
    if (doc.uuid) {
      doc.deleted = true
    } else {
      this.cargoDocs.splice(docIndex, 1)
    }
    // 更改当前选择的cargoDoc
    // 删除列表对应的行
    const index = this.amsDataList.findIndex(ams => ams.hblNbr2 === doc.hblNbr2)
    if (index > -1) {
      this.amsDataList.splice(index, 1)
    }
  }
  deleteAfr(docIndex) {
    // 现有ams数量大于HBL数量，删除后再同步数据
    const doc = this.afrCargoDocs[docIndex]
    if (doc.uuid) {
      doc.deleted = true
    } else {
      this.afrCargoDocs.splice(docIndex, 1)
    }
    // 更改当前选择的cargoDoc
    // 删除列表对应的行
    const index = this.afrDataList.findIndex(ams => ams.hblNbr2 === doc.hblNbr2)
    if (index > -1) {
      this.afrDataList.splice(index, 1)
    }
  }
  /**
   *克隆新的cargoDoc对象
   */
  async cloneSeaCargoDoc(newDoc, seaCargoDoc) {
    if (this.view.tabAfr) {
      newDoc.destinationAgentDoc = this.job.destinationAgent
      newDoc.vesselCode = this.job.vesselCode
      newDoc.countryOrigin = 'CN'
      newDoc.hsCode = seaCargoDoc.hsCode
      if (newDoc.hsCode && newDoc.hsCode.length > 6) {
        newDoc.hsCode = newDoc.hsCode.substring(0, 6)
      }
      newDoc.docType = CargoDocConsts.AFR
    } else {
      newDoc.docType = CargoDocConsts.AMS
    }
    newDoc.goodsType = 0
    newDoc.paperlessInBondParticipant = 1
    newDoc.shipperLine1 = seaCargoDoc.shipperLine1
    newDoc.shipperLine2 = seaCargoDoc.shipperLine2
    newDoc.shipperLine3 = seaCargoDoc.shipperLine3
    newDoc.shipperLine4 = seaCargoDoc.shipperLine4
    newDoc.shipperLine5 = seaCargoDoc.shipperLine5
    newDoc.shipperLine6 = seaCargoDoc.shipperLine6
    newDoc.shipperCode = seaCargoDoc.shipperCode
    newDoc.consigneeLine1 = seaCargoDoc.consigneeLine1
    newDoc.consigneeLine2 = seaCargoDoc.consigneeLine2
    newDoc.consigneeLine3 = seaCargoDoc.consigneeLine3
    newDoc.consigneeLine4 = seaCargoDoc.consigneeLine4
    newDoc.consigneeLine5 = seaCargoDoc.consigneeLine5
    newDoc.consigneeLine6 = seaCargoDoc.consigneeLine6
    newDoc.consigneeCode = seaCargoDoc.consigneeCode
    newDoc.notifyLine1 = seaCargoDoc.notifyLine1
    newDoc.notifyLine2 = seaCargoDoc.notifyLine2
    newDoc.notifyLine3 = seaCargoDoc.notifyLine3
    newDoc.notifyLine4 = seaCargoDoc.notifyLine4
    newDoc.notifyLine5 = seaCargoDoc.notifyLine5
    newDoc.notifyLine6 = seaCargoDoc.notifyLine6
    newDoc.notifyCode = seaCargoDoc.notifyCode
    newDoc.notifyCode = seaCargoDoc.notifyCode
    // 提单发货地
    newDoc.dispatchingPlace = seaCargoDoc.dispatchingPlace
    newDoc.dispatchingPlaceCode = seaCargoDoc.dispatchingPlaceCode

    // 如果 提单发货地为空，则取基本页签的发货地
    if (!newDoc.dispatchingPlaceCode) {
      newDoc.dispatchingPlaceCode = this.job.dispatchingPlaceCode
      newDoc.dispatchingPlace = this.job.dispatchingPlace
    }
    // 如果 提单发货地为空，则取基本页签的起运港
    if (!newDoc.dispatchingPlaceCode && this.job.loadingPortCode) {
      newDoc.dispatchingPlaceCode = this.job.loadingPortCode
      const jobLoadingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.loadingPortCode)
      if (jobLoadingPort) {
        newDoc.dispatchingPlace = jobLoadingPort.englishName
      }
    }
    // 提单起运港
    if (this.view.tabAfr) {
      newDoc.loadingPortCode = this.job.loadingPortCode
      const jobLoadingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.loadingPortCode)
      if (jobLoadingPort) {
        newDoc.loadingPort = jobLoadingPort.englishName
      }
    } else {
      newDoc.loadingPort = seaCargoDoc.loadingPort
      newDoc.loadingPortCode = seaCargoDoc.loadingPortCode
    }
    // 最后一个境外港口
    newDoc.lastAbroadProd = seaCargoDoc.loadingPortCode
    newDoc.lastAbroadProdName = seaCargoDoc.loadingPort
    // 第一个停靠港
    newDoc.firstPortOfCallCode = seaCargoDoc.dischargingPortCode
    newDoc.firstPortOfCall = seaCargoDoc.dischargingPort
    // hscode
    newDoc.hsCode = seaCargoDoc.hsCode
    // 提单卸货港
    if (this.view.tabAfr) {
      newDoc.dischargingPortCode = this.job.dischargingPortCode
      const jobDischargingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode)
      if (jobDischargingPort) {
        newDoc.dischargingPort = jobDischargingPort.englishName
      }
    } else {
      newDoc.dischargingPort = seaCargoDoc.dischargingPort
      newDoc.dischargingPortCode = seaCargoDoc.dischargingPortCode
    }
    // 提单目的港
    // 当HBL填写了“提单最终目的地”时，反恐舱单里的“Place of Delivery"取”提单最终目的地“的值，填入到文本框中，选择器内容为空
    if (!StrUtils.isEmpty(seaCargoDoc.destinationPlace)) {
      newDoc.destinationPortCode = '' // 提单目的港
      newDoc.destinationPort = seaCargoDoc.destinationPlace // 提单目的地
    } else {
      newDoc.destinationPortCode = seaCargoDoc.destinationPortCode // 提单目的港
      newDoc.destinationPort = seaCargoDoc.destinationPort // 提单目的港
    }
    if (this.view.tabAfr && this.view.afrIsLink) {
      newDoc.destinationPortCode = seaCargoDoc.destinationPortCode
    }
    // 提单目的地
    newDoc.destinationPlace = seaCargoDoc.destinationPlace
    // 提单件数
    newDoc.quantity = seaCargoDoc.quantity
    // 重量
    newDoc.weight = seaCargoDoc.weight
    // 体积
    newDoc.cubage = seaCargoDoc.cubage
    // 包装
    newDoc.packing = seaCargoDoc.packing
    // AMS 编号
    if (parseInt(cache.config.get('AMSNoRule')) === 1 && this.view.activeTabName !== 'afr') {
      newDoc.hblNbr2 = this.convertSpecialCharactersInHblNbr2(seaCargoDoc.hblNbr2)
    } else {
      newDoc.hblNbr2 = seaCargoDoc.hblNbr2
    }
    newDoc.mblNbr2 = seaCargoDoc.mblNbr2

    const containerLoadTypes = ['FCL', 'SPA', 'BCF']
    newDoc.containerLoadType = containerLoadTypes.includes(this.job.containerLoadType) ? 'FCL' : 'LCL'
    newDoc.eta = this.job.eta
    newDoc.etd = this.job.etd

    if (this.view.tabAfr) {
      newDoc.mbl = this.job.mbl
    } else {
      // CARGO-32896 整拼类型=自拼箱，每个小票【反恐仓单-MB/L NO】改为取值【主单 -MB/L NO.】
      CargoDocUtil.syncMblNo(newDoc, this.job)
    }

    // 英文品名
    newDoc.cargoEnglishName = seaCargoDoc.cargoEnglishName
    // 唛头
    newDoc.mark = seaCargoDoc.mark
    // 提单份数
    newDoc.blNumber = seaCargoDoc.blNumber
    // 提单备注
    newDoc.remarks = seaCargoDoc.remarks

    const hasDischargingPort = this.job.transfering && !StrUtils.isEmpty(this.job.transferPortCode) // 中转港是否不为空

    newDoc.vessel = hasDischargingPort ? this.view.job.secondVesselVoyage : this.view.job.vessel
    const voyage = hasDischargingPort ? this.view.job.secondVoyage : this.view.job.voyageFlight
    newDoc.voyageFlight = CargoDocUtil.replaceVoyage(voyage, true)
    if (hasDischargingPort) {
      const jobTransferPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.transferPortCode)
      if (jobTransferPort) {
        newDoc.loadingPort = jobTransferPort.englishName
        newDoc.lastAbroadProdName = jobTransferPort.englishName
      }
      newDoc.loadingPortCode = this.job.transferPortCode
      newDoc.lastAbroadProd = this.job.transferPortCode
    }
    newDoc.vesselIMO = hasDischargingPort ? (StrUtils.isEmpty(newDoc.vessel) ? '' : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', newDoc.vessel, 'imoCode')) : this.job.vesselIMO
    // CARGO-35213 AFR从订舱页签取不到船舶呼号和IMO的时候，直接从船名维护那里匹配取值
    if (!newDoc.vesselCode || !newDoc.vesselIMO) {
      const vessel = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'englishName', newDoc.vessel)
      // 船舶呼号
      if (!newDoc.vesselCode && vessel) {
        newDoc.vesselCode = vessel.callSign
      }
      // IMO
      if (!newDoc.vesselIMO && vessel) {
        newDoc.vesselIMO = vessel.imoCode
      }
    }
    // job
    newDoc.jobUuid = this.view.job.uuid
    // 处理反恐地址格式化
    if (!newDoc.afrAddress || newDoc.afrAddress.length === 0) {
      // 没有的话，根据去查后端加载出来AFR反恐地址
      await new SeaCargoDoc(newDoc).getAfrAddress().then(data => {
        if (!data[0]) {
          newDoc.afrAddress = []
          const addressForm = new AfrAddress().fillDefaultValue().getData()
          addressForm.cargoDocUuid = newDoc.uuid
          newDoc.afrAddress.push(addressForm)
        }
      })
    }
    const activeTabName = this.view.activeTabName
    // 开通了劲生走以下逻辑
    if (this.view.isJs) {
      let vesselGrid = []
      await getVesselList().then(res => {
        if (res.data) {
          vesselGrid = res.data.filter(p => p.englishName === this.job.vessel)
        }
      })
      // 同步 发货人 收货人/通知人的Country
      if (activeTabName === 'aci' || activeTabName === 'afr') {
        if (seaCargoDoc.loadingPortCode) {
          // Country（国家）
          newDoc.afrAddress[0].shipperCountry = seaCargoDoc.loadingPortCode.substring(0, 2).toUpperCase()
        }
        if (seaCargoDoc.dischargingPortCode) {
          const consigneeCountry = seaCargoDoc.dischargingPortCode.substring(0, 2).toUpperCase()
          // Country（国家）
          newDoc.afrAddress[0].consigneeCountry = consigneeCountry
          newDoc.afrAddress[0].notifyCountry = consigneeCountry
        }
      }
      if (activeTabName === 'aci') {
        // DestinationCountry（目的地国家）
        if (seaCargoDoc.dischargingPortCode) {
          newDoc.cargoDestinationCountry = seaCargoDoc.dischargingPortCode.substring(0, 2).toUpperCase()
        }
      }
      if (activeTabName === 'afr') {
        // Unit Type（包装）
        if (this.job.packing) {
          const packingName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', this.job.packing, 'name')
          for (const item of this.view.localData.jsAfrPacking) {
            if (item.code === this.job.packing || item.name === packingName) {
              newDoc.packing = item.code
            }
          }
        }
        // Vessel Code
        if (this.job.vesselCode) {
          newDoc.vesselCode = this.job.vesselCode
        } else if (vesselGrid) {
          for (const item of vesselGrid) {
            if (item.callSign) {
              newDoc.vesselCode = item.callSign
              break
            }
          }
        }
        // ETA
        if (this.job.eta) {
          newDoc.eta = this.job.eta
        } else if (this.job.etd) {
          newDoc.eta = DateUtils.addDays(this.job.etd, 3)
        }
      }
      if (activeTabName === 'ams' || activeTabName === 'aci' || activeTabName === 'afr') {
        //
        if (this.job.cargoType === 'DG') {
          newDoc.goodsType = 1
          let specialGoods = this.job.specialGoods || []
          if (!specialGoods || specialGoods.length <= 0) {
            const params = {
              jobUuid: this.job.uuid,
              specialGoods: true
            }
            await loadSeaExportJobRelated(params).then(res => {
              specialGoods = res.data.specialGoods || []
            })
          }
          if (specialGoods && specialGoods.length > 0) {
            for (const item of specialGoods) {
              if (activeTabName === 'ams') {
                if (item.danPoint) {
                  newDoc.flashPointTemp = parseInt(item.danPoint) || 0
                }
              }
              if (activeTabName === 'afr') {
                if (item.danClassNo) {
                  newDoc.imdgClass = item.danClassNo
                }
                if (item.danUNNo) {
                  newDoc.unNo = item.danUNNo
                }
              }
            }
          }
        }
      }
      if (activeTabName === 'ams' || activeTabName === 'afr') {
        if (vesselGrid) {
          for (const item of vesselGrid) {
            if (item.regCountry) {
              newDoc.nationalityCodeofVessel = item.regCountry
              break
            }
          }
        }
      }
      // 卸货港
      const dischargingPortPort = this.job.dischargingPortCode ? getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode) : null
      // 起运港
      const loadingPortPort = this.job.loadingPortCode ? getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.loadingPortCode) : null
      if (activeTabName === 'ams' || activeTabName === 'aci') {
        if (dischargingPortPort) {
          newDoc.dischargingPortCode = this.getMatchedCollection(this.view.localData.jsAmsDischargingList, dischargingPortPort.englishName, 'name')
        }
        if (loadingPortPort) {
          newDoc.loadingPortCode = this.getMatchedCollection(this.view.localData.jsPortList, loadingPortPort.englishName, 'name')
        }
      }
      if (activeTabName === 'afr') {
        if (dischargingPortPort) {
          // 先用五子码匹配
          let dischargingPortCode = this.getMatchedCollection(this.view.localData.jsAfrPortList, dischargingPortPort.code, 'code')
          if (dischargingPortCode) {
            newDoc.dischargingPortCode = dischargingPortCode
          } else {
            // 匹配不上再用英文名匹配
            dischargingPortCode = this.getMatchedCollection(this.view.localData.jsAfrPortList, dischargingPortPort.englishName, 'name')
            if (dischargingPortCode) {
              newDoc.dischargingPortCode = dischargingPortCode
            }
          }

          // 先用五子码匹配
          let loadingPortCode = this.getMatchedCollection(this.view.localData.jsAfrPortList, loadingPortPort.code, 'code')
          if (loadingPortCode) {
            newDoc.loadingPortCode = loadingPortCode
          } else {
            // 匹配不上再用英文名匹配
            loadingPortCode = this.getMatchedCollection(this.view.localData.jsAfrPortList, loadingPortPort.englishName, 'name')
            if (loadingPortCode) {
              newDoc.loadingPortCode = loadingPortCode
            }
          }
        }
      }
    }
    if (activeTabName === 'ens') {
      // ens 所有人员类型默认法人
      newDoc.afrAddress[0].shipperTypeOfPerson = '2'
      newDoc.afrAddress[0].consigneeTypeOfPerson = '2'
      newDoc.afrAddress[0].notifyTypeOfPerson = '2'
      newDoc.afrAddress[0].sellerTypeOfPerson = '2'
      newDoc.afrAddress[0].buyerTypeOfPerson = '2'
      newDoc.afrAddress[0].carrierTypeOfPerson = '2'
      newDoc.afrAddress[0].representativeTypeOfPerson = '2'
      // 亿通的 carrierEmail 取当前用户的email
      newDoc.afrAddress[0].carrierEmail = this.view.$store.getters.userInfo.email
      // IMO 取海运出口 船名的
      const vessel = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'englishName', this.job.vessel)
      if (vessel) {
        newDoc.vesselIMO = vessel.imoCode
      }
      // 默认危险品
      if (this.job.cargoType === 'DG') {
        newDoc.goodsType = 1
      }
      if (seaCargoDoc.loadingPortCode) {
        // Country（国家）
        newDoc.afrAddress[0].shipperCountry = seaCargoDoc.loadingPortCode.substring(0, 2).toUpperCase()
      }
      if (seaCargoDoc.dischargingPortCode) {
        // Country（国家）
        newDoc.afrAddress[0].consigneeCountry = seaCargoDoc.dischargingPortCode.substring(0, 2).toUpperCase()
        const declaringMemberCountry = seaCargoDoc.dischargingPortCode.substring(0, 2).toUpperCase()
        if (this.view.ensIsYitong) {
          const etCountry = this.view.localData.ytCountry
          console.log('etCountry',)
          for (const item of etCountry) {
            if (item.code === declaringMemberCountry) {
              newDoc.declaringMemberCountry = declaringMemberCountry
              break
            }
          }
        } else {
          newDoc.declaringMemberCountry = declaringMemberCountry
        }
        this.view.localData.carrierEoriList = []
        newDoc.carrierEori = ''
        if (this.job.carrierId) {
          await matchEori({ companyId: this.job.carrierId }).then(res => {
            if (res.data && res.data.length > 0) {
              if (res.data.length === 1) {
                newDoc.carrierEori = res.data[0]
              } else {
                newDoc.carrierEori = ''
              }
              const eori = []
              for (const item of res.data) {
                eori.push({ code: item })
              }
              this.view.localData.carrierEoriList = eori
            }
          })
        }
      }
      // 同步货物信息
      // CARGO-51844 货物明细数据，需要同步到反恐舱单-ENS界面的货物信息
      const ensCargoInfos = []
      if (this.view.ensIsTradetech && this.job.uuid) {
        let poItems = this.job.poItems || []
        if (!poItems || poItems.length === 0) {
          poItems = this.job.uuid ? await getPoItems({ jobUuid: this.job.uuid }).then(res => res.data) : []
        }
        if (poItems.length > 0) {
          let correlativeNo = 1
          for (const poItem of poItems) {
            const ensCargoInfo = {
              correlativeNo: correlativeNo,
              hsCode: poItem.hsCode,
              quantity: poItem.quantity,
              packing: poItem.packing,
              weight: poItem.grossWeight,
              cubage: poItem.cubage,
              cargoEnglishName: poItem.englishCommodity,
              mark: poItem.mark,
              cusCode: poItem.cusCode
            }
            correlativeNo++
            ensCargoInfo.serialNo = ensCargoInfos.length + 1
            ensCargoInfos.push(ensCargoInfo)
          }
        }
      } else {
        const ensCargoInfo = {
          correlativeNo: 1,
          hsCode: seaCargoDoc.hsCode,
          quantity: seaCargoDoc.quantity,
          packing: seaCargoDoc.packing,
          weight: seaCargoDoc.weight,
          volume: seaCargoDoc.volume,
          cubage: seaCargoDoc.cubage,
          cargoEnglishName: seaCargoDoc.cargoEnglishName,
          mark: seaCargoDoc.mark
        }
        ensCargoInfo.serialNo = ensCargoInfos.length + 1
        ensCargoInfos.push(ensCargoInfo)
      }
      newDoc.ensCargoInfo = ensCargoInfos
    }
    CargoDocUtil.copyAfrAddress(newDoc.afrAddress[0], seaCargoDoc)
    // CARGO-33651 利通 反恐舱单-企泰报文取值修改
    CargoDocUtil.syncFreightTermForAms(newDoc, seaCargoDoc)
    //
    await CargoDocUtil.fillNvoccScacAndEfNvoccScac(newDoc)
    if (this.view.afrIsLink) {
      if (activeTabName === 'afr') {
        this.formatAddress(newDoc)
        newDoc.mbl = this.job.mbl
        this.fillCarrierEori(newDoc)
        // 处理发送离港通知
        if (new Date() >= new Date(this.job.atd)) {
          newDoc.atdCompleted = 1
        } else {
          newDoc.atdCompleted = 2
        }
        // 处理货物信息
        if (!newDoc.ensCargoInfo || newDoc.ensCargoInfo.length === 0) {
          newDoc.ensCargoInfo = []
          newDoc.ensCargoInfo.push({})
        }
        newDoc.ensCargoInfo[0].hsCode = this.afrValidateHsCodeDescription(seaCargoDoc.hsCode)
        newDoc.ensCargoInfo[0].weight = seaCargoDoc.weight
        newDoc.ensCargoInfo[0].quantity = seaCargoDoc.quantity
        newDoc.ensCargoInfo[0].packing = seaCargoDoc.packing
        newDoc.ensCargoInfo[0].cubage = seaCargoDoc.cubage
        newDoc.ensCargoInfo[0].mark = this.afrValidateMarksDescription(seaCargoDoc.mark)
        newDoc.ensCargoInfo[0].cargoEnglishName = this.afrValidateMarksDescription(seaCargoDoc.cargoEnglishName)
      }
    }
  }

  async cloneSeaCargoDocByNewEns(newDoc, seaCargoDoc, isNew = true) {
    newDoc.docType = CargoDocConsts.AMS
    // 默认为I
    newDoc.forb = seaCargoDoc?.forb || SystemConstants.AMS_ENS_TRANSPORT_TYPE_I_AI
    // 默认15
    newDoc.forb = seaCargoDoc?.declarationType || 'F15'
    newDoc.goodsType = 0
    newDoc.paperlessInBondParticipant = 1
    newDoc.shipperLine1 = seaCargoDoc.shipperLine1
    newDoc.shipperLine2 = seaCargoDoc.shipperLine2
    newDoc.shipperLine3 = seaCargoDoc.shipperLine3
    newDoc.shipperLine4 = seaCargoDoc.shipperLine4
    newDoc.shipperLine5 = seaCargoDoc.shipperLine5
    newDoc.shipperLine6 = seaCargoDoc.shipperLine6
    newDoc.shipperCode = seaCargoDoc.shipperCode
    newDoc.consigneeLine1 = seaCargoDoc.consigneeLine1
    newDoc.consigneeLine2 = seaCargoDoc.consigneeLine2
    newDoc.consigneeLine3 = seaCargoDoc.consigneeLine3
    newDoc.consigneeLine4 = seaCargoDoc.consigneeLine4
    newDoc.consigneeLine5 = seaCargoDoc.consigneeLine5
    newDoc.consigneeLine6 = seaCargoDoc.consigneeLine6
    newDoc.consigneeCode = seaCargoDoc.consigneeCode
    newDoc.notifyLine1 = seaCargoDoc.notifyLine1
    newDoc.notifyLine2 = seaCargoDoc.notifyLine2
    newDoc.notifyLine3 = seaCargoDoc.notifyLine3
    newDoc.notifyLine4 = seaCargoDoc.notifyLine4
    newDoc.notifyLine5 = seaCargoDoc.notifyLine5
    newDoc.notifyLine6 = seaCargoDoc.notifyLine6
    newDoc.notifyCode = seaCargoDoc.notifyCode
    newDoc.notifyCode = seaCargoDoc.notifyCode
    newDoc.dischargingPort = seaCargoDoc.dischargingPort
    newDoc.dischargingPortCode = seaCargoDoc.dischargingPortCode

    // 提单目的港
    // 当HBL填写了“提单最终目的地”时，反恐舱单里的“Place of Delivery"取”提单最终目的地“的值，填入到文本框中，选择器内容为空
    if (!StrUtils.isEmpty(seaCargoDoc.destinationPlace)) {
      newDoc.destinationPortCode = '' // 提单目的港
      newDoc.destinationPort = seaCargoDoc.destinationPlace // 提单目的地
    } else {
      newDoc.destinationPortCode = seaCargoDoc.destinationPortCode // 提单目的港
      newDoc.destinationPort = seaCargoDoc.destinationPort // 提单目的港
    }
    // 提单目的地
    newDoc.destinationPlace = seaCargoDoc.destinationPlace
    // 提单件数
    newDoc.quantity = seaCargoDoc.quantity
    // 重量
    newDoc.weight = seaCargoDoc.weight
    // 体积
    newDoc.cubage = seaCargoDoc.cubage
    // 包装
    newDoc.packing = seaCargoDoc.packing
    // AMS 编号
    newDoc.hblNbr2 = seaCargoDoc.hblNbr2
    newDoc.mblNbr2 = seaCargoDoc.mblNbr2

    const containerLoadTypes = ['FCL', 'SPA', 'BCF']
    newDoc.containerLoadType = containerLoadTypes.includes(this.job.containerLoadType) ? 'FCL' : 'LCL'
    newDoc.eta = this.job.eta
    newDoc.etd = this.job.etd

    // CARGO-32896 整拼类型=自拼箱，每个小票【反恐仓单-MB/L NO】改为取值【主单 -MB/L NO.】
    CargoDocUtil.syncMblNo(newDoc, this.job)

    // 英文品名
    newDoc.cargoEnglishName = seaCargoDoc.cargoEnglishName
    // 唛头
    newDoc.mark = seaCargoDoc.mark
    // 提单份数
    newDoc.blNumber = seaCargoDoc.blNumber
    // 提单备注
    newDoc.remarks = seaCargoDoc.remarks

    const hasDischargingPort = this.job.transfering && !StrUtils.isEmpty(this.job.transferPortCode) // 中转港是否不为空

    newDoc.vessel = hasDischargingPort ? this.view.job.secondVesselVoyage : this.view.job.vessel
    const voyage = hasDischargingPort ? this.view.job.secondVoyage : this.view.job.voyageFlight
    newDoc.voyageFlight = CargoDocUtil.replaceVoyage(voyage, true)
    if (hasDischargingPort) {
      const jobTransferPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.transferPortCode)
      if (jobTransferPort) {
        newDoc.loadingPort = jobTransferPort.englishName
        newDoc.lastAbroadProdName = jobTransferPort.englishName
      }
      newDoc.loadingPortCode = this.job.transferPortCode
      newDoc.lastAbroadProd = this.job.transferPortCode
    }
    newDoc.vesselIMO = hasDischargingPort ? (StrUtils.isEmpty(newDoc.vessel) ? '' : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', newDoc.vessel, 'imoCode')) : this.job.vesselIMO
    // CARGO-35213 AFR从订舱页签取不到船舶呼号和IMO的时候，直接从船名维护那里匹配取值
    if (!newDoc.vesselCode || !newDoc.vesselIMO) {
      const vessel = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'englishName', newDoc.vessel)
      // 船舶呼号
      if (!newDoc.vesselCode && vessel) {
        newDoc.vesselCode = vessel.callSign
      }
      // IMO
      if (!newDoc.vesselIMO && vessel) {
        newDoc.vesselIMO = vessel.imoCode
      }
    }
    // job
    newDoc.jobUuid = this.view.job.uuid
    // 处理反恐地址格式化
    if (!newDoc.afrAddress || newDoc.afrAddress.length === 0) {
      // 没有的话，根据去查后端加载出来AFR反恐地址
      await new SeaCargoDoc(newDoc).getAfrAddress().then(data => {
        if (!data[0]) {
          newDoc.afrAddress = []
          const addressForm = new AfrAddress().fillDefaultValue().getData()
          addressForm.cargoDocUuid = newDoc.uuid
          newDoc.afrAddress.push(addressForm)
        }
      })
    }
    const activeTabName = this.view.activeTabName
    if (activeTabName === 'ens') {
      // ens 所有人员类型默认法人
      newDoc.afrAddress[0].shipperTypeOfPerson = '2'
      newDoc.afrAddress[0].consigneeTypeOfPerson = '2'
      newDoc.afrAddress[0].notifyTypeOfPerson = '2'
      newDoc.afrAddress[0].sellerTypeOfPerson = '2'
      newDoc.afrAddress[0].buyerTypeOfPerson = '2'
      newDoc.afrAddress[0].carrierTypeOfPerson = '2'
      newDoc.afrAddress[0].representativeTypeOfPerson = '2'
      // 亿通的 carrierEmail 取当前用户的email
      newDoc.afrAddress[0].carrierEmail = this.view.$store.getters.userInfo.email
      if (seaCargoDoc.loadingPortCode) {
        // Country（国家）
        newDoc.afrAddress[0].shipperCountry = seaCargoDoc.loadingPortCode.substring(0, 2).toUpperCase()
      }
      if (seaCargoDoc.dischargingPortCode) {
        // Country（国家）
        newDoc.afrAddress[0].consigneeCountry = seaCargoDoc.dischargingPortCode.substring(0, 2).toUpperCase()
        const declaringMemberCountry = seaCargoDoc.dischargingPortCode.substring(0, 2).toUpperCase()
        if (this.view.ensIsYitong) {
          const etCountry = this.view.localData.ytCountry
          console.log('etCountry',)
          for (const item of etCountry) {
            if (item.code === declaringMemberCountry) {
              newDoc.declaringMemberCountry = declaringMemberCountry
              break
            }
          }
        } else {
          newDoc.declaringMemberCountry = declaringMemberCountry
        }
        this.view.localData.carrierEoriList = []
        newDoc.carrierEori = ''
        if (this.job.carrierId) {
          const shipperCompany = this.findShipperByCarrierId(this.job.carrierId)
          newDoc.carrierEori = shipperCompany && shipperCompany.carrierEori ? shipperCompany.carrierEori : ''
        }
      }
      // 同步货物信息===如果是新增才赋值货物信息数据
      if (isNew) {
        const ensCargoInfo = {
          correlativeNo: 1,
          hsCode: seaCargoDoc.hsCode,
          quantity: seaCargoDoc.quantity,
          packing: seaCargoDoc.packing,
          weight: seaCargoDoc.weight,
          volume: seaCargoDoc.volume,
          cubage: seaCargoDoc.cubage,
          cargoEnglishName: seaCargoDoc.cargoEnglishName,
          mark: seaCargoDoc.mark,
          correlativeContainerNo: '',
          serialNo: 1
        }
        newDoc.ensCargoInfo = [ensCargoInfo]
      }
    }
    CargoDocUtil.copyAfrAddress(newDoc.afrAddress[0], seaCargoDoc)
    // CARGO-33651 利通 反恐舱单-企泰报文取值修改
    CargoDocUtil.syncFreightTermForAms(newDoc, seaCargoDoc)
    //
    await CargoDocUtil.fillNvoccScacAndEfNvoccScac(newDoc)
    if (this.view.amsIsLink) {
      if (activeTabName === 'ams') {
        this.formatAddress(newDoc)
        newDoc.mbl = this.job.mbl
        this.fillCarrierEori(newDoc)
      }
    }
  }

  /**
   * 不区分大小写模糊匹配集合
   */
  getMatchedCollection(collection, text, data) {
    if (!text) {
      return ''
    }
    // 创建忽略大小写的正则表达式
    const regex = new RegExp(text, 'ig')
    for (const item of collection) {
      if (regex.test(item[data])) {
        return item.code
      }
    }
    return ''
  }

  /**
   *克隆新的Thailand cargoDoc对象
   */
  async cloneThailandCargoDoc(newDoc, seaCargoDoc) {
    newDoc.docType = CargoDocConsts.THAILAND
    // 处理反恐地址格式化
    if (!newDoc.afrAddress || newDoc.afrAddress.length === 0) {
      // 没有的话，根据去查后端加载出来AFR反恐地址
      await new SeaCargoDoc(newDoc).getAfrAddress().then(data => {
        if (!data[0]) {
          newDoc.afrAddress = []
          const addressForm = new AfrAddress().fillDefaultValue().getData()
          addressForm.cargoDocUuid = newDoc.uuid
          newDoc.afrAddress.push(addressForm)
        }
      })
    }
    const afrAddress = newDoc.afrAddress[0]
    for (const type of ['shipper', 'consignee', 'notify']) {
      afrAddress[type + 'Line1'] = seaCargoDoc[type + 'Line1']
      let text = seaCargoDoc[type + 'Line2']
      if (text) {
        text += '\n'
      }
      text += seaCargoDoc[type + 'Line3']
      if (text) {
        text += '\n'
      }
      text += seaCargoDoc[type + 'Line4']
      if (text) {
        text += '\n'
      }
      text += seaCargoDoc[type + 'Line5']
      if (text) {
        text += '\n'
      }
      text += seaCargoDoc[type + 'Line6']
      if (text) {
        text += '\n'
      }
      text += seaCargoDoc[type + 'Line7']
      let no = 2
      for (let i = 0; i < text.length; i += 255, ++no) {
        afrAddress[type + 'Line' + no] = text.substring(i, i + 255)
      }
      for (; no < 7; ++no) {
        afrAddress[type + 'Line' + no] = ''
      }
    }
    afrAddress.shipperCountry = 'TH'
    const lclSlave = this.job.masterFlag ? this.lclSlaveJobMap.get(seaCargoDoc.jobUuid) : this.job
    newDoc.hblNbr2 = seaCargoDoc.hblNbr2
    // 提单件数
    newDoc.quantity = seaCargoDoc.quantity
    // 包装
    newDoc.packing = seaCargoDoc.packing
    // 重量
    newDoc.weight = seaCargoDoc.weight
    // 体积
    newDoc.cubage = seaCargoDoc.cubage
    if (this.job.containerLoadType === 'FCL' || this.job.containerLoadType === 'BCF') {
      newDoc.containerStatus = '8'
    } else {
      newDoc.containerStatus = '9'
    }
    // 提单发货地
    if (lclSlave) {
      newDoc.dispatchingPlaceCode = lclSlave.dispatchingPlaceCode
      newDoc.dispatchingPlace = lclSlave.dispatchingPlaceCode
    }
    // 提单交货地
    newDoc.destinationPortCode = this.job.destinationPortCode
    newDoc.destinationPort = this.job.destinationPortCode
    newDoc.remarks = seaCargoDoc.mark
    newDoc.cargoEnglishName = seaCargoDoc.cargoEnglishName
    if (this.job.cargoType === 'GC') {
      newDoc.docCargoType = '1'
    } else if (this.job.cargoType === 'DG') {
      newDoc.docCargoType = '2'
    } else if (this.job.cargoType === 'LD' || this.job.cargoType === 'RF') {
      newDoc.docCargoType = '7'
    }
    /*     if (this.view.tabEns) {
      newDoc.mbl = this.removeMblPrefix()
    } else {
      newDoc.mbl = this.job.mbl
    } */
    newDoc.mbl = this.job.mbl
    newDoc.vessel = this.job.vessel
    const voyage = this.job.voyageFlight
    newDoc.voyageFlight = CargoDocUtil.replaceVoyage(voyage, true)
    newDoc.vesselIMO = this.job.vesselIMO
    newDoc.vesselCode = this.job.vesselCode
    newDoc.eta = this.job.eta
    newDoc.etd = this.job.etd
    // 提单起运港
    newDoc.loadingPortCode = this.job.loadingPortCode
    newDoc.loadingPort = this.job.loadingPortCode
    // 提单卸货港
    newDoc.dischargingPortCode = this.job.dischargingPortCode
    newDoc.dischargingPort = this.job.dischargingPortCode
    newDoc.berthDate = this.job.actualBerthPlanDate
    newDoc.shedNumber = this.job.yardCode
    newDoc.shipAgent = this.job.carrierAgentId
    if (newDoc.shipAgent) {
      await queryTitleByCpmIdx(newDoc.shipAgent).then(res => {
        if (res.data && res.data.length > 0) {
          for (const item of res.data) {
            if (item.defaultTitle) {
              newDoc.shipAgentTaxNo = item.taxAccount
            }
          }
        }
      })
    }
    newDoc.cargoMovement = 'O'
  }
  onCopy1() {
    if (this.view.tabAfr) {
      const afrAddress = this.afrForm.afrAddress[0]
      if (afrAddress) {
        this.syncAfrAddress('shipper', DocCommon.AFR_History, afrAddress)
        this.syncAfrAddress('consignee', DocCommon.AFR_History, afrAddress)
        this.syncAfrAddress('notify', DocCommon.AFR_History, afrAddress)
        this.syncAfrAddress('alsonotify', DocCommon.AFR_History, afrAddress)
      }
      this.afrForm.cargoEnglishName = DocCommon.AFR_History.englishCargoName || ''
      this.afrForm.mark = DocCommon.AFR_History.mark || ''
    } else {
      const afrAddress = this.form.afrAddress[0]
      if (afrAddress) {
        this.syncAfrAddress('shipper', DocCommon.AMS_History, afrAddress)
        this.syncAfrAddress('consignee', DocCommon.AMS_History, afrAddress)
        this.syncAfrAddress('notify', DocCommon.AMS_History, afrAddress)
        this.syncAfrAddress('alsonotify', DocCommon.AMS_History, afrAddress)
        if (this.view.activeTabName === 'ens') {
          this.syncAfrAddressEns('shipper', DocCommon.AMS_History, afrAddress)
          this.syncAfrAddressEns('consignee', DocCommon.AMS_History, afrAddress)
          this.syncAfrAddressEns('notify', DocCommon.AMS_History, afrAddress)
          this.syncBuyerSellerAfrAddress('seller', DocCommon.AMS_History, afrAddress)
          this.syncBuyerSellerAfrAddress('buyer', DocCommon.AMS_History, afrAddress)
        }
      }
      this.form.cargoEnglishName = DocCommon.AMS_History.englishCargoName || ''
      this.form.mark = DocCommon.AMS_History.mark || ''
    }
  }
  async onAfrSelectionChange(data) {
    // cargo六月份的逻辑修改导致
    // view.gdAMS2.dataProvider是ams状态列表
    // view.gdAMS2.selectedItem却是ams状态列表hblNbr2对应的cargoDoc对象
    // this.view.curAms对应view.gdAMS2.selectedItem  存的依旧是cargoDoc对象
    if (data) {
      if (data.hblNbr2 !== this.afrForm.hblNbr2) {
        // 初始化不同字段的值
        this.view.localData.importDifferentField = {}
      }
      this.view.curAfr = this.afrForm
      this.view.afr2.isSelected = true
      if (!this.afrForm.hblNbr2) {
        this.$message.info(this.view.$t('Message.HAWBAfrCannotBeNull'))
        return
      } else if (!this.checkHblNbr2(this.afrForm)) {
        this.$message.info(this.view.$t('Message.HAWBAfrCannotBeRepeated'))
        return
      }
      // SeaCargoDoc
      for (const doc of this.afrCargoDocs) {
        if (doc.hblNbr2 === data.hblNbr2 && doc.docType === 'AFR') {
          this.view.afrForm = doc
          this.view.curAfr = doc
        }
      }
      this.view.afrContainer.rowData = await new SeaCargoDoc(this.afrForm).getEdiContainer()
      if (this.afrForm.uuid) {
        // 查询isfPassenger
        await new SeaCargoDoc(this.afrForm).getIsfPassenger()
        // 查询反恐舱单地址
        await new SeaCargoDoc(this.afrForm).getAfrAddress().then(data => {
          if (!data[0]) {
            this.afrForm.afrAddress = []
            const afrAddress = new AfrAddress().fillDefaultValue().getData()
            afrAddress.cargoDocUuid = this.afrForm.uuid
            this.afrForm.afrAddress.push(afrAddress)
          }
        })
      } else {
        this.afrForm.isfPassenger = []
      }
      if (this.view.afrIsLink) {
        if (!this.afrForm.ensCargoInfo || this.afrForm.ensCargoInfo.length === 0) {
          this.afrForm.ensCargoInfo = []
          if (this.afrForm.uuid) {
            const cargoInfo = await getEnsCargoInfoByCargoDoc({ cargoDocUuid: this.afrForm.uuid }).then(res => res.data)
            if (cargoInfo && cargoInfo.length > 0) {
              cargoInfo.forEach((item, idx) => {
                item.serialNo = idx + 1
              })
              this.afrForm.ensCargoInfo = cargoInfo
            }
          }
        }
      }
    }
    if (this.view.afrIsLink) {
      if (!this.afrForm.ensCargoInfo || this.afrForm.ensCargoInfo.length === 0) {
        this.afrForm.ensCargoInfo = []
        const newCargoInfo = {
          weight: '',
          quantity: '',
          cubage: '',
          serialNo: 1
        }
        this.afrForm.ensCargoInfo.push(newCargoInfo)
      }
      if (!this.afrForm.atdCompleted) {
        if (new Date() >= new Date(this.job.atd)) {
          this.afrForm.atdCompleted = 1
        } else {
          this.afrForm.atdCompleted = 2
        }
      }
      if (this.view.$refs['afr']) {
        this.view.$refs['afr'].refreshList()
      }
    }
    this.afrForm.frob = this.afrForm.frob ? this.afrForm.frob : 'I'
  }
  async onThailandSelectionChange(event, data) {
    if (data === this.thailandForm) {
      return
    }
    const form = this.view.thailand2.rowData.find(p => p === this.thailandForm)
    if (form) {
      let isPass = true
      if (!form.hblNbr2) {
        this.$message.info(this.view.$t('Message.HAWBAfrCannotBeNull'))
        isPass = false
      } else if (!this.checkHblNbr2(form)) {
        this.$message.info(this.view.$t('Message.HAWBAfrCannotBeRepeated'))
        isPass = false
      }
      if (!isPass) {
        const nodes = event.api.rowModel.rowsToDisplay
        for (const node of nodes) {
          if (node.data === this.thailandForm) {
            event.api.setFocusedCell(node.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            break
          }
        }
        return
      }
    }
    const cargoDoc = this.view.thailand2.rowData.find(p => p === data)
    if (cargoDoc) {
      this.view.thailandContainer.rowData = await new SeaCargoDoc(cargoDoc).getEdiContainer()
      if (cargoDoc.uuid) {
        // 查询反恐舱单地址
        await new SeaCargoDoc(cargoDoc).getAfrAddress().then(data => {
          if (!data[0]) {
            cargoDoc.afrAddress = []
            const afrAddress = new AfrAddress().fillDefaultValue().getData()
            afrAddress.cargoDocUuid = cargoDoc.uuid
            cargoDoc.afrAddress.push(afrAddress)
          }
        })
      }
      cargoDoc.isfPassenger = []
    } else {
      this.view.thailandContainer.rowData = this.view.thailandContainer.rowData || []
    }
    this.thailandForm = data
  }
  onLastChange(params) {
    const row = params.data
    let preRowHblNo = ''
    if (!row.afrLast) {
      row.afrLast = true
    } else {
      for (const data of this.view.afr2.rowData) {
        if (data.hblNbr2 !== row.hblNbr2 && data.afrLast) {
          preRowHblNo = data.hblNbr2
          data.afrLast = false
        }
      }
    }
    for (const doc of this.afrCargoDocs) {
      if (doc.hblNbr2 === row.hblNbr2 && doc.docType === 'AFR') {
        doc.afrLast = true
      }
      if (preRowHblNo && doc.hblNbr2 === preRowHblNo && doc.docType === 'AFR') {
        doc.afrLast = false
      }
    }
    this.view.afr2.gridOptions.api.refreshCells({ force: true })
  }
  async onSelectionChange(data) {
    // cargo六月份的逻辑修改导致
    // view.gdAMS2.dataProvider是ams状态列表
    // view.gdAMS2.selectedItem却是ams状态列表hblNbr2对应的cargoDoc对象
    // this.view.curAms对应view.gdAMS2.selectedItem  存的依旧是cargoDoc对象
    if (data) {
      if (data.hblNbr2 !== this.form.hblNbr2) {
        // 初始化不同字段的值
        this.view.localData.importDifferentField = {}
      }
      this.view.curAms = this.form
      this.view.ams2.isSelected = true
      if (this.view.isEdit) {
        if (!this.form.hblNbr2) {
          this.$message.warning(this.view.$t('Message.HAWBCannotBeNull'))
          return
        } else if (!this.checkHblNbr2(this.form)) {
          this.$message.info(this.view.$t('Message.HAWBCannotBeRepeated'))
          return
        }
      }
      // SeaCargoDoc
      for (const doc of this.cargoDocs) {
        if (doc.hblNbr2 === data.hblNbr2 && doc.docType === 'AMS') {
          this.view.form = doc
          this.view.curAms = doc
        }
      }
      this.view.container.rowData = await new SeaCargoDoc(this.form).getEdiContainer()
      if (this.form.uuid) {
        // 查询isfPassenger
        await new SeaCargoDoc(this.form).getIsfPassenger()
        // 查询反恐舱单地址
        await new SeaCargoDoc(this.form).getAfrAddress().then(data => {
          if (!data[0]) {
            this.form.afrAddress = []
            const afrAddress = new AfrAddress().fillDefaultValue().getData()
            afrAddress.cargoDocUuid = this.form.uuid
            this.form.afrAddress.push(afrAddress)
          }
          // getAfrAddress中已经赋值给了this.form.afrAddress，所以这里判断下是否为null，如果为null就赋值true
          if (this.form.afrAddress[0].copyToSeller === '') {
            this.form.afrAddress[0].copyToSeller = true
          }
          if (this.form.afrAddress[0].copyToBuyer === '') {
            this.form.afrAddress[0].copyToBuyer = true
          }
        })
        // 初始化途径国
        this.form.routeCountryList = []
        if (this.form.routeCountry) {
          const rout = this.form.routeCountry.split('|')
          for (const item of rout) {
            this.form.routeCountryList.push({
              country: item
            })
          }
        }
        // 初始化舱单对应的申报信息
        this.form.ensDeclarationData = []
        if (this.form.uuid) {
          const ensDeclarationData = await getEnsByCargoDoc({ cargoDocUuid: this.form.uuid }).then(res => res.data)
          if (ensDeclarationData && ensDeclarationData.length > 0) {
            this.form.ensDeclarationData = ensDeclarationData
          }
        }
        // 初始化货物信息
        this.form.ensCargoInfo = []
        if (this.form.uuid) {
          const ensCargoInfo = await getEnsCargoInfoByCargoDoc({ cargoDocUuid: this.form.uuid }).then(res => res.data)
          if (ensCargoInfo && ensCargoInfo.length > 0) {
            ensCargoInfo.forEach((item, idx) => {
              item.serialNo = idx + 1
            })
            this.form.ensCargoInfo = ensCargoInfo

            // CARGO-49127 箱子的展示根据货物信息来的，所以这里新增一个属性作为关联品名的显示列
            this.synclinkedCargoSerialNumber()
          }

          if (this.view.$refs['ens'] && this.view.isNewWindowByENS) {
            this.view.$refs['ens'].updateTotals()
          }
        }

        if (this.view.$refs['ens']) {
          this.view.$refs['ens'].refreshList()
        }
      } else {
        this.form.isfPassenger = []
      }
    }
    // 如果没值，默认显示第一个选项
    // ams/isf、申报类型 申报账户 提单类型 发货类型
    this.AMSTypeRefreshHandler()
    this.form.paperlessInBondParticipant = this.form.paperlessInBondParticipant ? this.form.paperlessInBondParticipant : 1
    this.form.frob = this.form.frob ? this.form.frob : 'I'
    this.form.declarationType = this.form.declarationType ? this.form.declarationType : 'F15'
    this.form.chargesPaymentMethod = this.form.chargesPaymentMethod ? this.form.chargesPaymentMethod : this.view.isNewWindowByENS ? SystemConstants.AMS_ENS_PAYMENT_D.code : SystemConstants.AMS_ENS_PAYMENT_Y.code
    const declarantEoriData = []
    if (this.view.$store.getters.currentOffice && this.view.$store.getters.currentOffice.declarantEori) {
      const declarantEoriList = this.view.$store.getters.currentOffice.declarantEori.split('\n')
      if (declarantEoriList.length === 1) {
        this.form.declarantEori = this.form.declarantEori ? this.form.declarantEori : declarantEoriList[0]
      }
      for (const item of declarantEoriList) {
        declarantEoriData.push({ code: item })
      }
    }
    this.view.localData.declarantEoriList = declarantEoriData
    if (this.job.dischargingPortCode) {
      const declaringMemberCountry = this.job.dischargingPortCode.substring(0, 2).toUpperCase()
      if (this.view.isNewWindowByENS) {
        const etCountry = this.view.localData.ytCountry
        for (const item of etCountry) {
          if (item.code === declaringMemberCountry) {
            this.form.declaringMemberCountry = this.form.declaringMemberCountry ? this.form.declaringMemberCountry : declaringMemberCountry
            break
          }
        }
      } else {
        this.form.declaringMemberCountry = this.form.declaringMemberCountry ? this.form.declaringMemberCountry : declaringMemberCountry
      }
    }
    // emainAccount有匹配则处理，无匹配则不处理
    if (this.view.localData.eFreighsAmsList && this.form.emainAccount && this.form.emainAccount.trim()) {
      const index = this.view.localData.eFreighsAmsList.findIndex(el => el === this.form.emainAccount)
      if (index > -1) {
        this.view.localData.emainAccountStr = this.form.emainAccount
      }
    }
    if (this.view.localData.eFreighsAciList && this.form.emainAccountAci && this.form.emainAccountAci.trim()) {
      const index = this.view.localData.eFreighsAciList.findIndex(el => el === this.form.emainAccountAci)
      if (index > -1) {
        this.view.localData.emainAccountAciStr = this.form.emainAccountAci
      }
    }
    this.form.amsBlType = this.form.amsBlType ? this.form.amsBlType : AmsBLType.Ams_BL_Type[0].code
    this.form.shipmentTypeCode = this.form.shipmentTypeCode ? this.form.shipmentTypeCode : ShipmentTypeCode.Shipment_Type_Code[0].code
    await this.initSubLocLabel()

    // 初始化默认值
    this.initLoadEnsDefaultData()
  }

  initLoadEnsDefaultData() {
    // 初始化申报人信息
    if (!this.view.isNewWindowByENS) {
      return
    }

    // 处理船公司
    this.fillCarrierEori(this.form)

    // 处理付款方式 为空就填充
    if (!this.form.chargesPaymentMethod) {
      this.form.chargesPaymentMethod = SystemConstants.AMS_ENS_PAYMENT_D.code
    }

    let afrAddress = new AfrAddress().fillDefaultValue().getData()
    if (this.form.afrAddress && this.form.afrAddress.length) {
      afrAddress = this.form.afrAddress[0]
    } else {
      this.form.afrAddress = []
      afrAddress.cargoDocUuid = this.form.uuid || ''
      this.form.afrAddress.push(afrAddress)
    }

    // 申报人 默认选中权限设置，反恐舱单设置中维护的第一个EORI
    // 处理申报人信息
    if (this.view.localData.officeEoriList && this.view.localData.officeEoriList.length) {
      const officeEori = this.view.localData.officeEoriList[0]
      if (!this.form.declarantEori) {
        this.form.declarantEori = officeEori.eori
      }
      // 申报人也就是承运人相关赋值
      if (!afrAddress.carrierName) {
        afrAddress.carrierName = officeEori.name
      }
      if (!afrAddress.carrierAddress1) {
        afrAddress.carrierAddress1 = officeEori.address1
      }
      if (!afrAddress.carrierAddress2) {
        afrAddress.carrierAddress2 = officeEori.address2
      }
      if (!afrAddress.carrierStreetNo) {
        afrAddress.carrierStreetNo = officeEori.streetNo
      }
      if (!afrAddress.carrierPostalcode) {
        afrAddress.carrierPostalcode = officeEori.postalcode
      }
      if (!afrAddress.carrierEmail) {
        afrAddress.carrierEmail = officeEori.email
      }
      if (!afrAddress.carrierTel) {
        afrAddress.carrierTel = officeEori.tel
      }
      if (!afrAddress.carrierCity) {
        afrAddress.carrierCity = officeEori.city
      }
      if (!afrAddress.carrierCountry) {
        afrAddress.carrierCountry = officeEori.country
      }
    }

    // 收货人、发货人、卖家、买家  类型	默认选中Legal person | 法人
    if (!afrAddress.shipperTypeOfPerson) {
      afrAddress.shipperTypeOfPerson = '1'
    }
    if (!afrAddress.consigneeTypeOfPerson) {
      afrAddress.consigneeTypeOfPerson = '1'
    }
    if (!afrAddress.sellerTypeOfPerson) {
      afrAddress.sellerTypeOfPerson = '1'
    }
    if (!afrAddress.buyerTypeOfPerson) {
      afrAddress.buyerTypeOfPerson = '1'
    }
  }
  setSelectNode(index) {
    const selectedNode = this.view.ams2.gridApi.getModel().rowsToDisplay[index]
    if (selectedNode) {
      selectedNode.setSelected(true)
      this.view.curAms = this.form
      this.view.ams2.isSelected = true
    } else {
      this.view.curAms = null
      this.view.ams2.isSelected = false
    }
  }
  setSelectAfrNode(index) {
    const selectedNode = this.view.afr2.gridApi.getModel().rowsToDisplay[index]
    if (selectedNode) {
      selectedNode.setSelected(true)
      this.view.curAfr = this.afrForm
      this.view.afr2.isSelected = true
    } else {
      this.view.curAfr = null
      this.view.afr2.isSelected = false
    }
  }
  // AMSType刷新（由form赋值到AMSType）
  AMSTypeRefreshHandler() {
    if (this.form && this.form.uuid) {
      if (this.form.printParam1) {
        this.form.AMSType = 0
      } else if (this.form.printParam7) {
        this.form.AMSType = 2
      }
    }
    this.form.AMSType = this.form.AMSType ? this.form.AMSType : 0
    this.AMSTypeChangeHandler(this.form.AMSType)
  }
  // 刷新箱子的序号列
  synclinkedCargoSerialNumber() {
    if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
      // CARGO-49127 箱子的展示根据货物信息来的，所以这里新增一个属性作为关联品名的显示列
      if (this.view.container.rowData || this.view.container.rowData.length > 0) {
        for (const container of this.view.container.rowData) {
          if (container.linkedCargoInformationNo) {
            const linkedIndexes = this.form.ensCargoInfo
              .map((cargo, index) => {
                const containerNos = (String(cargo.correlativeContainerNo) || '').split(',').filter(Boolean)
                return containerNos.includes(container.containerNo) ? (index + 1) : null
              })
              .filter(index => index !== null)
            container.linkedCargoSerialNumber = linkedIndexes.join(' | ')
          } else {
            container.linkedCargoSerialNumber = ''
          }
        }
      }
    } else {
      // 说明没有箱子，将箱子的所有字段只为空
      if (this.view.container.rowData || this.view.container.rowData.length > 0) {
        this.view.container.rowData.forEach(item => {
          item.linkedCargoSerialNumber = ''
        })
      }
    }

    // 刷新箱子表格显示
    if (this.view.container?.gridApi) {
      this.view.container.gridApi.refreshCells({
        force: true,
        columns: ['linkedCargoSerialNumber']
      })
    }
  }

  // 填充完hscode后更新箱子
  synclinkedCargoSerialNumberByHsCode(params) {
    if (this.view.container.rowData || this.view.container.rowData.length > 0) {
      // 箱子的关联hscode存在并且包含旧值就更新
      for (const container of this.view.container.rowData) {
        // 箱子的关联hscode存在判断是否存在当前hscode，如果存在就更新，如果不存在就去掉
        if (container.linkedCargoInformationNo) {
          if (params.oldValue) {
            const hsCodes = container.linkedCargoInformationNo.split(';').filter(Boolean)
            const index = hsCodes.indexOf(params.oldValue)
            if (index !== -1) {
              if (params.newValue) {
                // 更新为新箱号
                hsCodes[index] = params.newValue
              } else {
                hsCodes.splice(index, 1)
              }
            }
            // 更新回逗号分隔的字符串
            container.linkedCargoInformationNo = hsCodes.join(';')
          }
        }
      }

      // 说明箱子的linkedCargoInformationNo 为空就需要处理hscode的correlativeContainerNo字段包含当前的containerNo, 如果包含处理箱子的linkedCargoInformationNo的值// 处理
      for (const container of this.view.container.rowData) {
        if (params.data.correlativeContainerNo) {
          const containerByCargoInfoList = params.data.correlativeContainerNo.split(',').filter(Boolean)
          const index = containerByCargoInfoList.indexOf(container.containerNo)
          if (index !== -1) {
            // 说明该货物勾选了该箱号
            if (params.newValue) {
              if (container.linkedCargoInformationNo) {
                const hsCodes2 = container.linkedCargoInformationNo.split(';').filter(Boolean)
                // 不存在就添加, 存在就不处理
                if (index === -1) {
                  hsCodes2.push(params.newValue)
                }
                // 更新回逗号分隔的字符串
                container.linkedCargoInformationNo = hsCodes2.join(';')
              } else {
                container.linkedCargoInformationNo = params.newValue
              }
            }
          }
        }
      }

      // 刷新箱子
      this.synclinkedCargoSerialNumber()
    }
  }

  /**
   * 同步船公司的eori
   */
  syncAmsCarrierEori() {
    // 根据job的信息船公司复制
    if (this.view.tabEns && this.view.isNewWindowByENS && this.job.carrierId && this.cargoDocs && this.cargoDocs.length && this.view.ams2.rowData && this.view.ams2.rowData.length) {
      // 判断当前的数据是否已经发送过，如果发送过就不再修改，发送过的概念为：只要发送状态不为null
      const shipCompanyInfo = this.findShipperByCarrierId(this.job.carrierId)
      if (shipCompanyInfo && shipCompanyInfo.carrierEori) {
        this.cargoDocs.forEach(item => {
          if (item.docType === CargoDocConsts.AMS) {
            // 在this.view.ams2.rowData查询判断该分单号的发送状态
            if (item.hblNbr2) {
              // 有分单好就判断发送状态是否为已发送过
              const findIndex = this.view.ams2.rowData.findIndex(data => data.docType === CargoDocConsts.AMS && data.hblNbr2 === item.hblNbr2 && (!data?.ENSSTATUS || data?.ENSSTATUS === '' || data?.ENSSTATUS === -1))
              if (findIndex !== -1) {
                item.carrierEori = shipCompanyInfo.carrierEori
              }
            } else {
              // 没有分单号默认未发送
              item.carrierEori = shipCompanyInfo.carrierEori
            }
          }
        })
      }
    }
  }

  async fillCarrierEori(cargoDoc) {
    // 根据job的信息船公司复制
    if (this.job.carrierId && !cargoDoc.carrierEori) {
      const shipCompanyInfo = await this.findShipperByCarrierId(this.job.carrierId)
      // 根据船公司查询合作伙伴信息
      if (this.view.tabAms) {
        cargoDoc.carrierEori = shipCompanyInfo && shipCompanyInfo.amsScacCode ? shipCompanyInfo.amsScacCode : ''
      } else if (this.view.tabEns) {
        cargoDoc.carrierEori = shipCompanyInfo && shipCompanyInfo.carrierEori ? shipCompanyInfo.carrierEori : ''
      } else if (this.view.tabAfr) {
        cargoDoc.carrierEori = shipCompanyInfo && shipCompanyInfo.afrScacCode ? shipCompanyInfo.afrScacCode : ''
      }
    }
  }

  async findShipperByCarrierId(carrierId) {
    if (carrierId && this.view.localData.shipCompanyInfos && this.view.localData.shipCompanyInfos.length) {
      let company = await companyCacheByCmpIdx(carrierId)
      company = company ? company.data : null
      let shipCompanyInfo = null
      if (company) {
        if (company.shipCompanyUuid) {
          await getByUuidShipCompany({ uuid: company.shipCompanyUuid }).then(resp => {
            if (resp.data) {
              shipCompanyInfo = resp.data
            }
          })
        }
        if (shipCompanyInfo) {
          return shipCompanyInfo
        }
        // 根据合作伙伴的信息在shipCompanyInfos匹配
        // shipCompanyInfo的三个字段: shipCompanyChineseName, shipCompanyEnglishName, shipCompanyCode
        // company的四个字段: shortName, cnShortName, chineseName, englishName
        shipCompanyInfo = this.view.localData.shipCompanyInfos.find(el => {
          // 中文名称匹配
          const chineseNameMatches = [
            company.shortName,
            company.cnShortName,
            company.chineseName,
            company.englishName
          ].includes(el.shipCompanyChineseName)

          // 英文名称匹配
          const englishNameMatches = [
            company.shortName,
            company.cnShortName,
            company.chineseName,
            company.englishName
          ].includes(el.shipCompanyEnglishName)

          // 公司代码匹配
          const companyCodeMatches = [
            company.shortName,
            company.cnShortName,
            company.chineseName,
            company.englishName
          ].includes(el.shipCompanyCode)

          // 任一匹配即可
          return chineseNameMatches || englishNameMatches || companyCodeMatches
        })
        if (shipCompanyInfo) {
          return shipCompanyInfo
        }
      }
    }
    return null
  }

  async onAddCargoDoc() {
    await this.fillModel()
    const cargoDoc = await CargoDocUtil.addAMS(this.job, true)
    cargoDoc.jobUuid = this.job.uuid
    const lastForm = this.form
    this.form = new SeaCargoDoc(cargoDoc).fillDefaultValue().getData()
    if (lastForm) {
      this.form.AMSType = lastForm.AMSType
    }
    const gdList = this.cargoDocs
    const hblList = []
    let hbl2
    if (gdList.length > 0) {
      for (const sea of gdList) {
        hblList.push(sea.hblNbr2)
      }
      hbl2 = this.form.hblNbr2 + this.hbl2Arr[gdList.length - 1]
      if (hblList.includes(hbl2)) {
        for (let i = 0; i < this.hbl2Arr.length; ++i) {
          const hblNo = this.form.hblNbr2 + this.hbl2Arr[i]
          if (!hblList.includes(hblNo)) {
            this.form.hblNbr2 = hblNo
            break
          }
        }
      } else {
        this.form.hblNbr2 = hbl2
      }
    }
    // this.onCopy4()
    this.form.goodsType = 0
    this.form.paperlessInBondParticipant = 1
    // 填充默认值
    if (this.view.isNewWindowByENS) {
      // 填充默认值
      this.fillEnsCheckBoxDefaultValue(this.form)
      // 格式化收发通信息
      this.convertAfrAddressByRule(this.form)
      // 同步收发通信息
      this.syncSellerAndBuyerInfoAfrAddress(this.form)
    }
    this.cargoDocs.push(this.form)
    if (hbl2 || this.form.hblNbr2) {
      const newDOC = {}
      newDOC.hblNbr2 = this.form.hblNbr2
      newDOC.EFSTATUS = -1
      newDOC.AMSSTATUS = -1
      newDOC.ISF5STATUS = -1
      newDOC.ISF10STATUS = -1
      newDOC.ENSSTATUS = -1
      newDOC.docType = CargoDocConsts.AMS
      this.amsDataList.push(newDOC)
    }
    this.view.ams2.rowData = this.amsDataList
    setTimeout(() => {
      this.setSelectNode(this.view.ams2.rowData.length - 1)
    }, 100)
    // 刷新amsType
    this.AMSTypeRefreshHandler()
    // 列表选择
    await this.onSelectionChange(this.view.ams2.rowData[this.view.ams2.rowData.length - 1])
    this.view.container.rowData = await new SeaCargoDoc(this.form).getEdiContainer()
  }
  async onAddAfrCargoDoc() {
    const cargoDoc = await CargoDocUtil.addAFR(this.job, true)
    cargoDoc.jobUuid = this.job.uuid
    this.afrForm = new SeaCargoDoc(cargoDoc).fillDefaultValue().getData()
    const gdList = this.afrCargoDocs
    const hblList = []
    let hbl2
    if (gdList.length > 0) {
      for (const sea of gdList) {
        hblList.push(sea.hblNbr2)
      }
      hbl2 = this.afrForm.hblNbr2 + this.hbl2Arr[gdList.length - 1]
      if (hblList.includes(hbl2)) {
        for (let i = 0; i < this.hbl2Arr.length; ++i) {
          const hblNo = this.afrForm.hblNbr2 + this.hbl2Arr[i]
          if (!hblList.includes(hblNo)) {
            this.afrForm.hblNbr2 = hblNo
            break
          }
        }
      } else {
        this.afrForm.hblNbr2 = hbl2
      }
      this.afrForm.afrLast = false
    } else {
      this.afrForm.afrLast = true
    }
    // this.onCopy4()
    this.afrForm.destinationAgentDoc = this.job.destinationAgent
    this.afrForm.countryOrigin = 'CN'
    this.afrForm.vesselCode = this.job.vesselCode
    this.afrCargoDocs.push(this.afrForm)
    if (hbl2) {
      const newDOC = {}
      newDOC.jobNo = this.job.jobNo
      newDOC.hblNbr2 = this.afrForm.hblNbr2
      newDOC.afrStatus = -1
      newDOC.afrLast = false
      this.afrDataList.push(newDOC)
    }
    this.view.afr2.rowData = this.afrDataList
    if (this.view.afr2.rowData && this.view.afr2.rowData.length) {
      setTimeout(() => {
        this.setSelectAfrNode(this.view.afr2.rowData.length - 1)
      }, 100)
      // 列表选择
      await this.onAfrSelectionChange(this.view.afr2.rowData[this.view.afr2.rowData.length - 1])
    }
    this.view.afrContainer.rowData = await new SeaCargoDoc(this.afrForm).getEdiContainer()
  }
  loadAfr() {
    if (!this.afrDataList || this.afrDataList.length === 0) {
      const newDOC = {}
      newDOC.jobNo = this.job.jobNo
      newDOC.hblNbr2 = this.afrForm.hblNbr2
      newDOC.afrStatus = -1
      newDOC.afrLast = true
      this.afrDataList.push(newDOC)
    }
    this.view.afr2.rowData = this.afrDataList
  }
  loadAms() {
    if (!this.amsDataList || this.amsDataList.length === 0) {
      const newDOC = {}
      newDOC.hblNbr2 = this.form.hblNbr2
      newDOC.EFSTATUS = -1
      newDOC.AMSSTATUS = -1
      newDOC.ISF5STATUS = -1
      newDOC.ISF10STATUS = -1
      newDOC.ENSSTATUS = -1
      this.amsDataList.push(newDOC)
    }
    this.view.ams2.rowData = this.amsDataList
  }
  async fillModel() {
    if (this.view.$refs['isf']) {
      if (this.view.$refs['isf'].$refs['tabBookingISF05'] && this.view.form) {
        this.view.$refs['isf'].$refs['tabBookingISF05'].fillModel()
      }
      if (this.view.$refs['isf'].$refs['tabBookingISF10'] && this.view.form) {
        this.view.$refs['isf'].$refs['tabBookingISF10'].fillModel()
      }
    }
  }
  onRemoveCargoDoc() {
    const selectedRows = this.view.tabAfr ? this.view.afr2.gridApi.getSelectedRows() : this.view.ams2.gridApi.getSelectedRows()
    const row = selectedRows.length ? selectedRows[0] : null
    if (row) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + row.hblNbr2 + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(async() => {
        if (this.view.tabAfr) {
          await this.onRemoveAfrConfirmed(row)
        } else {
          await this.onRemoveConfirmed(row)
        }
      }).catch(() => { })
    } else {
      this.$message.info(this.view.tabAfr ? this.view.$t('Message.PleaseSelectTheHBLNO') : this.view.$t('Message.PleaseSelectTheAMSNO'))
    }
  }
  onRemoveCargoDocAi() {
    const selectedRows = this.view.tabAfr ? this.view.afr2.gridApi.getSelectedRows() : this.view.ams2.gridApi.getSelectedRows()
    const row = selectedRows.length ? selectedRows[0] : null
    if (row) {
      this.$confirm(
        this.view.$t('Message.SureDeleteHbl'),
        this.view.$t('Message.Tip'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(async() => {
        if (this.view.tabAfr) {
          await this.onRemoveAfrConfirmed(row)
        } else {
          await this.onRemoveConfirmed(row)
        }
      }).catch(() => { })
    } else {
      this.$message.info(this.view.tabAfr ? this.view.$t('Message.PleaseSelectTheHBLNO') : this.view.$t('Message.PleaseSelectTheAMSNO'))
    }
  }
  onRemoveThailandCargoDoc() {
    const row = this.view.thailand2.selectedNode ? this.view.thailand2.selectedNode.data : null
    if (row) {
      this.$confirm(
        this.view.$t('Message.AreYouSureYouWantToDelete1') + row.hblNbr2 + this.view.$t('Message.AreYouSureYouWantToDelete2'),
        this.view.$t('Message.ConfirmDelete'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          type: 'warning'
        }
      ).then(async() => {
        await this.onRemoveThailandConfirmed(row)
      }).catch(() => { })
    } else {
      this.$message.info(this.view.$t('Message.PleaseSelectTheHBLNO'))
    }
  }
  setNameOfCountry(p) {
    const country = getObjectByCache(TYPE_NAMES.basic_data_Country, 'code', p ? p.value : this.afrForm.countryOrigin)
    if (country) {
      this.view.localData.nameOfCountry = country.name
    }
  }
  /**
   * confirmed remove
   */
  async onRemoveConfirmed(row) {
    // 查找对应cargoDoc，有uuid则标记为删除，无uuid则直接删除
    const docIndex = this.cargoDocs.findIndex(doc => doc.hblNbr2 === row.hblNbr2 && doc.docType === 'AMS')
    if (docIndex > -1) {
      const doc = this.cargoDocs[docIndex]
      if (doc.uuid) {
        doc.deleted = true
      } else {
        this.cargoDocs.splice(docIndex, 1)
      }
      // 更改当前选择的cargoDoc
      const amsList = this.cargoDocs.filter(doc => !doc.deleted && doc.docType === 'AMS')
      const list = (amsList && amsList.length > 0) ? amsList : this.cargoDocs.filter(doc => !doc.deleted && doc.docType === 'HBL')
      if (list && list.length > 0) {
        this.form = list[0]
      } else {
        this.form = { AMSType: 0, frob: 'I' }
        this.form['afrAddress'] = []
        const afrAddress = new AfrAddress().fillDefaultValue().getData()
        afrAddress.cargoDocUuid = this.form.uuid
        this.form.afrAddress.push(afrAddress)
      }
    }
    // 删除列表对应的行
    const index = this.amsDataList.findIndex(ams => ams.hblNbr2 === row.hblNbr2)
    if (index > -1) {
      this.amsDataList.splice(index, 1)
    }
    this.view.ams2.rowData = this.amsDataList
    setTimeout(async() => {
      // 加载当前cargoDoc的装箱信息
      const index = this.amsDataList.findIndex(ams => ams.hblNbr2 === this.form.hblNbr2)
      this.setSelectNode(index)
      this.view.container.rowData = await new SeaCargoDoc(this.form).getEdiContainer()
    }, 100)
  }
  async onRemoveAfrConfirmed(row) {
    // 查找对应cargoDoc，有uuid则标记为删除，无uuid则直接删除
    const docIndex = this.afrCargoDocs.findIndex(doc => doc.hblNbr2 === row.hblNbr2 && doc.docType === 'AFR')
    if (docIndex > -1) {
      const doc = this.afrCargoDocs[docIndex]
      if (doc.uuid) {
        doc.deleted = true
      } else {
        this.afrCargoDocs.splice(docIndex, 1)
      }
      // 更改当前选择的cargoDoc
      const afrList = this.afrCargoDocs.filter(doc => !doc.deleted && doc.docType === 'AFR')
      const list = (afrList && afrList.length > 0) ? afrList : this.afrCargoDocs.filter(doc => !doc.deleted && doc.docType === 'HBL')
      if (list && list.length > 0) {
        this.afrForm = list[0]
      } else {
        this.afrForm = { AMSType: 0, frob: 'I' }
        this.afrForm['afrAddress'] = []
        const afrAddress = new AfrAddress().fillDefaultValue().getData()
        afrAddress.cargoDocUuid = this.afrForm.uuid
        this.afrForm.afrAddress.push(afrAddress)
      }
    }
    // 删除列表对应的行
    const index = this.afrDataList.findIndex(afr => afr.hblNbr2 === row.hblNbr2)
    if (index > -1) {
      this.afrDataList.splice(index, 1)
    }
    this.view.afr2.rowData = this.afrDataList
    setTimeout(async() => {
      // 加载当前cargoDoc的装箱信息
      const index = this.afrDataList.findIndex(afr => afr.hblNbr2 === this.afrForm.hblNbr2)
      this.setSelectAfrNode(index)
      this.view.afrContainer.rowData = await new SeaCargoDoc(this.afrForm).getEdiContainer()
    }, 100)
    if (this.view.afr2.rowData && this.view.afr2.rowData.length > 0) {
      const afrLastCount = this.view.afr2.rowData.filter(p => p.afrLast).length
      if (afrLastCount === 0) {
        const lastAfr = this.view.afr2.rowData[this.view.afr2.rowData.length - 1]
        lastAfr.afrLast = true
        const lastDoc = this.afrCargoDocs.find(p => p.hblNbr2 === lastAfr.hblNbr2)
        if (lastDoc) {
          lastDoc.afrLast = true
        }
      }
    }
  }
  async onRemoveThailandConfirmed(row) {
    // 查找对应cargoDoc，有uuid则标记为删除，无uuid则直接删除
    const docIndex = this.thailandCargoDocs.findIndex(p => p === row)
    if (docIndex > -1) {
      const doc = this.thailandCargoDocs[docIndex]
      if (doc.uuid) {
        doc.deleted = true
      } else {
        this.thailandCargoDocs.splice(docIndex, 1)
      }
    }
    this.view.thailand2.rowData = this.thailandCargoDocs.filter(p => !p.deleted)
    if (this.view.thailand2.rowData.length > 0) {
      const afrLastCount = this.view.thailand2.rowData.filter(p => p.afrLast).length
      if (afrLastCount === 0) {
        const lastAfr = this.view.thailand2.rowData[this.view.thailand2.rowData.length - 1]
        lastAfr.afrLast = true
      }
      setTimeout(() => {
        this.view.thailand2.gridApi.setFocusedCell(0, this.view.thailand2.gridApi.columnController.getAllDisplayedColumns()[0])
      }, 100)
    } else {
      this.thailandForm = new SeaCargoDoc().fillDefaultValue().getData()
      this.thailandForm.docType = CargoDocConsts.THAILAND
      this.view.thailandContainer.rowData = []
    }
  }
  /**
   * 清空收发通
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = ''
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = ''
        break
      default:
        break
    }
  }
  send(type, index) {
    if (!this.view.form) {
      return
    }
    switch (type) {
      case 'AMS':
        if (this.view.amsIsLink) {
          this.linkSendAms(index)
          break
        }
        if (this.view.amsIsOther) {
          this.toSendOther(type, index)
          break
        }
        if (this.view.isJs) {
          this.jsSendAMS(index)
          break
        }
        this.sendAMS(index, type)
        break
      case 'ISF10':
        this.getISF(10, index)
        break
      case 'ISF05':
        this.getISF(5, index)
        break
      case 'ISF':
        this.toSendOther(type, index)
        break
      case 'ACI':
        if (this.view.amsIsOther) {
          this.toSendOther(type, index)
          break
        }
        if (this.view.isJs) {
          this.jsSendACI(index)
          break
        }
        this.sendAMS(index, type)
        break
      case 'EF':
        if (this.view.amsIsOther) {
          this.toSendOther(type, index)
          break
        }
        this.sendAMS(index, type)
        break
      case 'AFR':
        if (this.view.afrIsLink) {
          if (index === 2) {
            this.view.showDeleteReasonDialog()
            break
          }
          this.linkSendAfr(index)
          break
        }
        if (this.view.afrIsOther) {
          this.toSendOther(type, index)
          break
        }
        if (this.view.isJs) {
          this.toJsSendAFR(index)
          break
        }
        this.sendAFR(index, type)
        break
      case 'ENS':
        if (this.view.ensIsOther) {
          this.toSendOther(type, index)
          break
        }
        this.sendENS(index, type)
        break
    }
    this.form.currentIndex = index
    this.view.currentType = type
    this.view.currentIndex = index
  }
  async sendAFR(index) {
    let valid = true
    const msgArr = []
    const efreightAFRSendingMode = this.config.get('EfreightAFRSendingMode') === '1'
    if (efreightAFRSendingMode && this.job.cargoType === 'DG') {
      this.$message.warning(this.view.$t('SeaExport.AfrEfreightDgTip'))
      return
    }
    for (const doc of this.afrCargoDocs) {
      if (!doc.mbl) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'MB/L NO'))
      }
      if (!doc.vessel) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Vessel'))
      }
      if (!doc.voyageFlight) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Voyage'))
      }
      if (!doc.etd) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'ETD'))
      }
      if (!doc.hblNbr2 || (doc.hblNbr2 && doc.hblNbr2.length > 31)) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'HB/L NO') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '31'))
      }
      if (!doc.packing) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.MappingValueNotEmpty'), 'Unit Type'))
      }
      if (!doc.dispatchingPlaceCode) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Receipt (code)'))
      }
      if (!doc.dispatchingPlace) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Receipt (name)'))
      }
      if (!doc.loadingPortCode) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Loading (code)'))
      }
      if (!doc.loadingPort) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Loading (name)'))
      }
      if (!doc.dischargingPortCode) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Discharge (code)'))
      }
      if (!doc.dischargingPort) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Discharge (name)'))
      }
      if (!doc.destinationPortCode) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Delivery (code)'))
      }
      if (!doc.destinationPort) {
        if (valid) {
          valid = false
        }
        msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Place of Delivery (name)'))
      }
      const curContainer = await new SeaCargoDoc(doc).getEdiContainer()
      if (curContainer && curContainer.length > 0) {
        for (const container of curContainer) {
          if (!container.containerNo || (container.containerNo && container.containerNo.length > 14)) {
            if (valid) {
              valid = false
            }
            msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Container No') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '14'))
          }
          if (!container.cargoName || (container.cargoName && container.cargoName.length > 300)) {
            if (valid) {
              valid = false
            }
            msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Goods') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '300'))
          }
          if (!container.mark || (container.mark && container.mark.length > 300)) {
            if (valid) {
              valid = false
            }
            msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Marks') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '300'))
          }
          if (!container.hsCodeContainer || (container.hsCodeContainer && container.hsCodeContainer.length > 8)) {
            if (valid) {
              valid = false
            }
            msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'HS Code') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '6'))
          }
        }
      }
      const afr = this.afrCargoDocs.find(afr => afr.hblNbr2 === doc.hblNbr2)
      if (afr && afr.afrAddress && afr.afrAddress.length > 0) {
        const afrAddress = afr.afrAddress[0]
        if (!afrAddress.shipperLine1 || (afrAddress.shipperLine1 && afrAddress.shipperLine1.length > 70)) {
          if (valid) {
            valid = false
          }
          msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'NAME') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '70'))
        }
        if (!afrAddress.shipperLine3 || (afrAddress.shipperLine3 && afrAddress.shipperLine3.length > 50)) {
          if (valid) {
            valid = false
          }
          msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Address1') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '50'))
        }
        if (!afrAddress.shipperCountry || (afrAddress.shipperCountry && afrAddress.shipperCountry.length > 2)) {
          if (valid) {
            valid = false
          }
          msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'Country') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '2'))
        }
        if (!afrAddress.shipperCity || (afrAddress.shipperCity && afrAddress.shipperCity.length > 25)) {
          if (valid) {
            valid = false
          }
          msgArr.push(StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotEmpty'), 'City') + ',' + StrUtils.substitute(this.view.$t('SeaExport.AfrFieldNotAccess'), '25'))
        }
      }
    }
    if (!valid) {
      this.$message.warning({ dangerouslyUseHTMLString: true, message: msgArr.join(' <br/> ') })
      return
    }
    const params = {
      departmentCode: this.view.$store.getters.currentDept.code,
      jobUuid: this.job.uuid,
      officeId: this.view.$store.getters.currentOfficeId,
      index: index
    }
    const loading = getLoading()
    getAfrEFreight(params).then(resp => {
      if (resp.data) {
        if (resp.data.isSuccess) {
          this.view.afrXmlDialog.visible = true
          this.view.afrXmlDialog.content = resp.data.text || ''
        } else {
          const text = resp.data.text
          if (text && text.indexOf('\n') !== -1) {
            const textArr = text.split('\n')
            this.$message.warning({ dangerouslyUseHTMLString: true, message: textArr.join(' <br/> ') })
          } else {
            this.$message.warning(text)
          }
        }
      }
    }).finally(() => {
      loading.close()
    })
  }

  async linkSendAfr(index, reasonCode, reasonDescription) {
    // 发送前的校验
    if (!this.linkAfrCheck()) {
      return
    }
    // 校验是否开通计费
    let bsData
    await checkBsItemOpened(SystemConstants.TYPE_AFR).then(res => {
      bsData = res.data
    })
    if (!bsData || bsData === -1) {
      // 未开通
      this.$message.warning(this.view.$t('CargoMsg.Cargo_UnopenedService'))
      return
    } else if (bsData <= 0) {
      // 余额不足
      this.$message.warning(this.view.$t('CargoMsg.Cargo_CustomsActivatedTip2'))
      return
    }
    const loading = getLoading()
    const params = {}
    params.key = this.afrForm.uuid
    params.currentOfficeId = this.view.$store.getters.currentOfficeId
    params.currentDepartmentCode = this.view.$store.getters.currentDept.code
    params.index = index
    params.jobNo = this.view.job.jobNo
    params.sendType = this.getSendType()
    params.deletionCode = reasonCode
    params.deletionReason = reasonDescription
    seaCargoDocApi.getAFR(params).then(resp => {
      if (resp.data.isSuccess) {
        this.$message.success(this.view.$t('CargoMsg.Cargo_SendSuccess'))
        this.loadSendStatus()
      } else {
        if (resp.data.data) {
          const message = resp.data.data.replaceAll('\\r\\n', '<br>')
          this.$message.error({ dangerouslyUseHTMLString: true, message: message })
        } else {
          this.$message.error(this.view.$t('SeaExport.sendFailed'))
        }
      }
    }).finally(() => {
      loading.close()
    })
  }

  async sendENS(index) {
    // 总校验 发F17的时候必须保证主单号跟分单号一致
    if (this.form.declarationType === 'F17' && this.view.isNewWindowByENS) {
      if (this.form.mbl !== this.form.hblNbr2) {
        this.$message.warning(this.view.$t('CargoMsg.Cargo_F17Verify'))
        return
      }
    }
    // 如果是link则走link的校验逻辑
    if (this.view.ensIsLink) {
      // 校验是否开通计费
      const loading = getLoading()
      let bsData
      await checkBsItemOpened(SystemConstants.TYPE_ENS).then(res => {
        bsData = res.data
      }).finally(() => {
        loading.close()
      })
      if (!bsData || bsData === -1) {
        // 未开通
        this.$message.warning(this.view.$t('CargoMsg.Cargo_UnopenedService'))
        return
      } else if (bsData <= 0) {
        // 余额不足
        this.$message.warning(this.view.$t('CargoMsg.Cargo_CustomsActivatedTip2'))
        return
      }
    } else {
      // 先整体校验上次发送是否有回执，如果上次发送过，但是回执还没回来，则不允许本次发送，发送仅保存除外
      if (index !== SAVE.code) {
        const params = {
          jobUuid: this.job.uuid,
          index: index,
          hblNbr2: this.form.hblNbr2
        }
        let checkSendEns = false
        const loading = getLoading()
        await seaCargoDocApi.checkSendEns(params).then(resp => {
          checkSendEns = resp.data
        }).finally(() => {
          loading.close()
        })
        if (!checkSendEns) {
          this.$message.error(this.view.$t('SeaExport.WaitingForReceipt'))
          return
        }
      }
    }
    if (!this.view.isNewWindowByENS) {
      // 不等于 F16 F17 时才校验货物和箱子相关的信息
      if (this.form.declarationType !== 'F16' && this.form.declarationType !== 'F17') {
        if (this.checkCorrelativeNoRepeat()) {
          return
        }
        if (!this.checkEnsHsCode()) {
          this.$message.error(this.view.$t('SeaExport.EnsHsCodeNotMatch'))
          return
        }
      }
    }
    // 不等于 F16 F17 时才校验货物和箱子相关的信息
    if (this.form.declarationType !== 'F16' && this.form.declarationType !== 'F17' && this.view.isNewWindowByENS) {
      // 校验箱子 和 货物信息 关联性， 字段说明：注意箱子的 linkedCargoInformationNo 字段保存的是货物信息的hsCode信息，数据类型是";"分割的字符串， 货物的 correlativeContainerNo 保存的是箱子的箱号信息，数据类型是","分割的字符串
      // 1，箱子的 linkedCargoInformationNo 和货物的 correlativeContainerNo 必须有值。
      // 2，箱子的 linkedCargoInformationNo 分割后的 hsCode 在货物信息中必须存在否在报错，错误信息为格式为：箱号XXX关联的hsCodeXXX不存在
      // 3，货物的 correlativeContainerNo 分割后的 containerNo 在箱子信息中必须存在否在报错，错误信息为格式为：货物XXX关联的箱号XXX不存在
      // 校验箱子和货物信息的关联性
      if (!this.form.ensCargoInfo?.length || !this.view.container?.rowData?.length) {
        this.$message.error(this.view.$t('SeaExport.ContainerInfo') + ',' + this.view.$t('SeaExport.CargoInfo') + this.view.$t('SeaExport.CannotBeEmpty'))
        return
      }

      // 校验货物的关联箱号
      for (const cargo of this.form.ensCargoInfo) {
        if (!cargo.correlativeContainerNo) {
          this.$message.error('correlativeContainerNo' + this.view.$t('SeaExport.CannotBeEmpty'))
          return
        }

        const containerNos = cargo.correlativeContainerNo.split(',').filter(Boolean)
        for (const containerNo of containerNos) {
          if (!this.view.container.rowData.some(container => container.containerNo === containerNo)) {
            this.$message.error(this.view.$t('SeaExport.EnsHsCodeNotMatch'))
            return
          }
        }
      }

      // 校验箱子的关联货物
      for (const container of this.view.container.rowData) {
        if (!container.linkedCargoInformationNo) {
          this.$message.error('linkedCargoInformationNo' + this.view.$t('SeaExport.CannotBeEmpty'))
          return
        }

        const hsCodes = container.linkedCargoInformationNo.split(';').filter(Boolean)
        for (const hsCode of hsCodes) {
          if (!this.form.ensCargoInfo.some(cargo => cargo.hsCode === hsCode)) {
            this.$message.error(this.view.$t('SeaExport.EnsHsCodeNotMatch'))
            return
          }
        }
      }
    }
    if (this.view.ensIsYitong) {
      this.preShippingHandler('ENS', index)
      return
    }
    if (this.view.ensIsTradetech) {
      const filter = {
        jobUuid: this.view.job.uuid,
        pageNum: 1,
        pageSize: 10,
        jobNo: this.view.job.jobNo
      }
      let prompt = false
      let dataList = []
      const loading = getLoading4Cxt()
      await seaCargoDocApi.queryTradetechAMSReceiptInfo(filter).then(res => {
        if (res.data) {
          dataList = res.data.list
        }
      }).finally(() => {
        loading.close()
      })
      if (dataList && dataList.length > 0) {
        const firstElement = dataList[0]
        if (index !== ORIGINAL.code && (firstElement.status.includes('R07') || firstElement.status.includes('N99'))) {
          prompt = true
          this.$message.warning(this.view.$t('SeaExport.OnlyOriginalSend'))
        }
        if (!(index === CORRECT.code || index === DELETE.code || index === DELETE_CUSTOMS.code || index === DELETE_ALL.code) && ['R01', 'N04', 'N07', 'N03', 'Q01', 'Q02', 'N10', 'N07', 'N01'].some(status => firstElement.status.includes(status))) {
          prompt = true
          this.$message.warning(this.view.$t('SeaExport.OnlyAddAndDeleteSend'))
        }
        if ((index === CORRECT.code || index === DELETE.code || index === DELETE_CUSTOMS.code || index === DELETE_ALL.code) && firstElement.status.includes('Rejected')) {
          prompt = true
          this.$message.warning(this.view.$t('SeaExport.NoSuccessAddAndDeleteNotSend'))
        }
      }
      if (prompt) {
        return
      }
      if (!this.trEnscheck()) {
        return
      }
    }
    if (this.view.ensIsEFreight) {
      if (!this.efEnscheck()) {
        return
      }
    }
    if (this.view.ensIsLink) {
      if (!this.linkEnsCheck()) {
        return
      }
    }
    const loading = getLoading()
    const params = {}
    params.key = this.form.uuid
    params.currentOfficeId = this.view.$store.getters.currentOfficeId
    params.index = index
    params.jobNo = this.view.job.jobNo
    params.sendType = index === SAVE.code ? 'SaveENS' : this.getSendType()
    seaCargoDocApi.getENS(params).then(resp => {
      if (resp.data) {
        if (this.view.ensIsLink) {
          if (resp.data.isSuccess) {
            this.$message.success(this.view.$t('CargoMsg.Cargo_SendSuccess'))
            this.loadSendStatus()
          } else {
            if (resp.data.data) {
              const message = resp.data.data.replaceAll('\\r\\n', '<br>')
              this.$message.error({ dangerouslyUseHTMLString: true, message: message })
            } else {
              this.$message.error(this.view.$t('SeaExport.sendFailed'))
            }
          }
          return
        }
        if (resp.data.isSuccess) {
          this.view.ensKey = resp.data.key
          this.view.amsXmlDialog.visible = true
          this.view.ensIndex = index
          this.view.amsXmlDialog.content = resp.data.text || ''
        } else {
          if (resp.data.text) {
            this.$message.error(resp.data.text)
            return
          }
          const errors = resp.data.errors
          if (errors && errors.length > 0) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: errors.join(' <br/> ') })
          } else {
            this.$message.warning(this.view.$t('CargoMsg.Cargo_SendFail'))
          }
        }
      }
    }).finally(() => {
      loading.close()
    })
  }
  async loadSendStatus() {
    await seaCargoDocApi.querySendStatus({ jobUuid: this.view.job.uuid }).then(async resp => {
      await this.querySendStatusResultHandler(resp)
    })
  }
  preShippingHandler(title, index) {
    this.view.globalVar.ediType = EdiType.ENS.code
    const loading = getLoading()
    this.view.selectorDialog.title = title
    this.view.selectorDialog.visible = true
    this.view.globalVar.editStatus = index
    getEDITemplate({ templateType: EdiType.ENS.code }).then(result => {
      this.view.selectorDialog.rowData = result.data
      this.view.selectorDialog.title = title
      this.view.selectorDialog.visible = true
    }).finally(() => {
      loading.close()
    })
  }
  checkCorrelativeNoRepeat() {
    // 校验Correlative No是否有填写重复
    if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
      const seen = new Set()
      for (const cargoInfo of this.form.ensCargoInfo) {
        if (!cargoInfo.correlativeNo) {
          this.$message.error('Correlative No' + this.view.$t('SeaExport.CannotBeEmpty'))
          return true
        }
        if (seen.has(cargoInfo.correlativeNo)) {
          this.$message.error(this.view.$t('SeaExport.EnsCorrelativeNoRepeat'))
          return true
        }
        seen.add(cargoInfo.correlativeNo)
      }
    }
    return false
  }
  checkEnsHsCode() {
    // 再校验货物是否跟箱子都匹配是是否跟装箱信息匹配
    if (this.view.container.rowData && this.view.container.rowData.length > 0) {
      const list = []
      for (const container of this.view.container.rowData) {
        if (container.linkedCargoInformationNo) {
          // 用分号拆分
          list.push.apply(list, container.linkedCargoInformationNo.split(';'))
        } else {
          this.$message.error(this.view.$t('SeaExport.LinkedCargoInformationNoNotNull'))
          return false
        }
      }
      if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
        for (const cargoInfo of this.form.ensCargoInfo) {
          if (!list.includes(cargoInfo.correlativeNo + '')) {
            return false
          }
        }
        return true
      }
    }
    return false
  }
  sendENSxml(index) {
    const params = {}
    params.key = this.form.uuid
    params.amsCheck = this.view.amsCheck
    params.currentOfficeId = this.view.$store.getters.currentOfficeId
    params.currentDepartmentCode = this.view.$store.getters.currentDept.code
    params.index = index
    params.jobNo = this.view.job.jobNo
    params.sendXml = this.view.amsXmlDialog.content
    params.ensKey = this.view.ensKey
    const loading = getLoading()
    seaCargoDocApi.sendENSXml(params).then(resp => {
      this.view.amsXmlDialog.visible = false
      if (resp.data && resp.data.isSuccess) {
        this.$message.success(this.view.$t('CargoMsg.Cargo_SendSuccess'))
      } else {
        const message = resp.data.data.replaceAll('\\r\\n', '<br>')
        this.$message.error({ dangerouslyUseHTMLString: true, message: message })
      }
      // this.sendeAMSResultHandler(resp)
    }).finally(() => loading.close())
  }
  /**
   * 一飞发送ENS字段校验
   */
  efEnscheck() {
    const checkList = []
    const isF16F17 = this.form.declarationType === 'F16' || this.form.declarationType === 'F17'
    const isF14 = this.form.declarationType === 'F14'
    if (!this.form.containerLoadType) {
      checkList.push({ field: 'Consignment Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.chargesPaymentMethod) {
      checkList.push({ field: 'Charges Payment Method', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!isF16F17) {
      if (!this.form.vessel) {
        checkList.push({ field: 'Vessel', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (this.form.vessel.length > 35) {
        checkList.push({ field: 'Vessel', errorDescription: this.view.$t('SeaExport.maxLength', ['35']) })
      }
      if (!this.form.voyageFlight) {
        checkList.push({ field: 'Voyage', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (this.form.voyageFlight.length > 5) {
        checkList.push({ field: 'Voyage', errorDescription: this.view.$t('SeaExport.maxLength', ['5']) })
      }
      if (!this.form.vesselIMO) {
        checkList.push({ field: 'IMO', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (this.form.vesselIMO.length > 7) {
        checkList.push({ field: 'IMO', errorDescription: this.view.$t('SeaExport.maxLength', ['7']) })
      }
      if (!this.form.dispatchingPlaceCode) {
        checkList.push({ field: 'Place of Receipt', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!this.form.dispatchingPlace) {
        checkList.push({ field: 'Place of Receipt Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!this.afrForm.destinationPortCode) {
        checkList.push({ field: 'Place of Delivery', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!this.afrForm.destinationPort) {
        checkList.push({ field: 'Place of Delivery Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!this.form.routeCountry) {
        checkList.push({ field: 'RouteCountry', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (this.form.coloadInSelfFilingIndicator) {
        if (this.form.ensDeclarationData && this.form.ensDeclarationData.length > 0) {
          for (const declarationData of this.form.ensDeclarationData) {
            if (!declarationData.supplementaryDeclarant) {
              checkList.push({ field: 'SupplementaryDeclarant', errorDescription: this.view.$t('SeaExport.Required') })
            }
            if (!declarationData.eori) {
              checkList.push({ field: 'Eori', errorDescription: this.view.$t('SeaExport.Required') })
            }
            if (!declarationData.blType) {
              checkList.push({ field: 'BlType', errorDescription: this.view.$t('SeaExport.Required') })
            }
          }
        } else {
          checkList.push({ field: 'ColoadInSelfFilingIndicator', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    }
    if (!this.form.hblNbr2) {
      checkList.push({ field: 'ENS NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.etd) {
      checkList.push({ field: 'ETD', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.eta) {
      checkList.push({ field: 'ETA', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPortCode) {
      checkList.push({ field: 'Place of Loading', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPort) {
      checkList.push({ field: 'Place of Loading Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.dischargingPortCode) {
      checkList.push({ field: 'Place of Discharge', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPort) {
      checkList.push({ field: 'Place of Loading Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // ens 收发通地址信息
    if (!isF16F17) {
      if (this.form.afrAddress && this.form.afrAddress.length > 0) {
        const address = this.form.afrAddress[0]
        if (!address.shipperLine1) {
          checkList.push({ field: 'Shipper Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperTypeOfPerson) {
          checkList.push({ field: 'Shipper Type Of Person', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperLine3) {
          checkList.push({ field: 'Shipper Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperStreetNo) {
          checkList.push({ field: 'Shipper Street No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperPostalcode) {
          checkList.push({ field: 'Shipper Zip', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperContactName) {
          checkList.push({ field: 'Shipper Contact Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperTel) {
          checkList.push({ field: 'Shipper Tel', errorDescription: this.view.$t('SeaExport.Required') })
        } else {
          const tel = address.shipperTel.split('-')
          if (tel.length !== 2) {
            checkList.push({ field: 'Shipper Tel', errorDescription: this.view.$t('SeaExport.TelSeparate') })
          } else {
            if (tel[0].length > 4 || tel[1].length > 20) {
              checkList.push({ field: 'Shipper Tel', errorDescription: this.view.$t('SeaExport.PhoneTooLong') })
            }
          }
        }
        if (!address.shipperCity) {
          checkList.push({ field: 'Shipper City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperCountry) {
          checkList.push({ field: 'Shipper Country', errorDescription: this.view.$t('SeaExport.Required') })
        }

        if (!address.consigneeLine1) {
          checkList.push({ field: 'Consignee Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeLine3) {
          checkList.push({ field: 'Consignee Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneePostalcode) {
          checkList.push({ field: 'Consignee Zip', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeContactName) {
          checkList.push({ field: 'Consignee Consignee Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeStreetNo) {
          checkList.push({ field: 'Consignee Street No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeTel) {
          checkList.push({ field: 'Consignee Tel', errorDescription: this.view.$t('SeaExport.Required') })
        } else {
          const tel = address.consigneeTel.split('-')
          if (tel.length !== 2) {
            checkList.push({ field: 'Consignee Tel', errorDescription: this.view.$t('SeaExport.TelSeparate') })
          } else {
            if (tel[0].length > 4 || tel[1].length > 20) {
              checkList.push({ field: 'Consignee Tel', errorDescription: this.view.$t('SeaExport.PhoneTooLong') })
            }
          }
        }
        if (!address.consigneeCity) {
          checkList.push({ field: 'Consignee City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeCountry) {
          checkList.push({ field: 'Consignee Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
      } else {
        checkList.push({ field: 'Customer Information', errorDescription: this.view.$t('SeaExport.Required') })
      }
    }
    // ens 买卖方地址信息
    if (!isF14) {
      if (this.form.afrAddress && this.form.afrAddress.length > 0) {
        const address = this.form.afrAddress[0]
        const isImport = this.form.frob === 'I'
        if (isImport || this.isAllNuLL(address.sellerName, address.sellerAddress1, address.sellerAddress1, address.sellerStreetNo, address.sellerCountry, address.sellerCity, address.sellerPostalcode, address.sellerProvince, address.sellerEmail, address.sellerTel, address.sellerContactName, address.sellerEori)) {
          if (!address.sellerName) {
            checkList.push({ field: 'Seller Name', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.sellerTypeOfPerson) {
            checkList.push({ field: 'Seller Type Of Person', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.sellerAddress1) {
            checkList.push({ field: 'Seller Address1', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.sellerStreetNo) {
            checkList.push({ field: 'Seller Street No', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.sellerPostalcode) {
            checkList.push({ field: 'Seller ZIP', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.sellerContactName) {
            checkList.push({ field: 'Seller Contact Name', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.sellerTel) {
            checkList.push({ field: 'Seller Tel', errorDescription: this.view.$t('SeaExport.Required') })
          } else {
            const tel = address.sellerTel.split('-')
            if (tel.length !== 2) {
              checkList.push({ field: 'Seller Tel', errorDescription: this.view.$t('SeaExport.TelSeparate') })
            } else {
              if (tel[0].length > 4 || tel[1].length > 20) {
                checkList.push({ field: 'Seller Tel', errorDescription: this.view.$t('SeaExport.PhoneTooLong') })
              }
            }
          }
          if (!address.sellerCity) {
            checkList.push({ field: 'Seller City', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.sellerCountry) {
            checkList.push({ field: 'Seller Country', errorDescription: this.view.$t('SeaExport.Required') })
          }
        }
        if (isImport || this.isAllNuLL(address.buyerName, address.buyerAddress1, address.buyerAddress1, address.buyerStreetNo, address.buyerCountry, address.buyerCity, address.buyerPostalcode, address.buyerProvince, address.buyerEmail, address.buyerTel, address.buyerContactName, address.buyerEori)) {
          if (!address.buyerName) {
            checkList.push({ field: 'Buyer Name', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.buyerTypeOfPerson) {
            checkList.push({ field: 'Buyer Type Of Person', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.buyerAddress1) {
            checkList.push({ field: 'Buyer Address1', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.buyerStreetNo) {
            checkList.push({ field: 'Buyer Street No', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.buyerPostalcode) {
            checkList.push({ field: 'Buyer ZIP', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.buyerContactName) {
            checkList.push({ field: 'Buyer Contact Name', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.buyerTel) {
            checkList.push({ field: 'Buyer Tel', errorDescription: this.view.$t('SeaExport.Required') })
          } else {
            const tel = address.buyerTel.split('-')
            if (tel.length !== 2) {
              checkList.push({ field: 'Buyer Tel', errorDescription: this.view.$t('SeaExport.TelSeparate') })
            } else {
              if (tel[0].length > 4 || tel[1].length > 20) {
                checkList.push({ field: 'Buyer Tel', errorDescription: this.view.$t('SeaExport.PhoneTooLong') })
              }
            }
          }
          if (!address.buyerCity) {
            checkList.push({ field: 'Buyer City', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!address.buyerCountry) {
            checkList.push({ field: 'Buyer Country', errorDescription: this.view.$t('SeaExport.Required') })
          }
        }
      } else {
        checkList.push({ field: 'Seller AND Buyer', errorDescription: this.view.$t('SeaExport.Required') })
      }
    }
    // 货物信息数据
    if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
      for (const cargo of this.form.ensCargoInfo) {
        if (!cargo.hsCode && !checkList.some(obj => obj.field === 'HS CODE')) {
          checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Required') })
        } else if (cargo.hsCode.length !== 6) {
          checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Only6') })
        }
        if (!cargo.cargoEnglishName && !checkList.some(obj => obj.field === 'Description')) {
          checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!cargo.mark && !checkList.some(obj => obj.field === 'Marking')) {
          checkList.push({ field: 'Marking', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!cargo.packing && !checkList.some(obj => obj.field === 'Unit Type')) {
          checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!cargo.quantity && !checkList.some(obj => obj.field === 'Quantity')) {
          checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!cargo.weight && !checkList.some(obj => obj.field === 'Gross Weight')) {
          checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!cargo.cubage && !checkList.some(obj => obj.field === 'Volume')) {
          checkList.push({ field: 'Volume', errorDescription: this.view.$t('SeaExport.Required') })
        }
        // goodsType等于1时为危险品才校验一下必填字段
        if (this.form.goodsType === 1) {
          if (!cargo.undgCode && !checkList.some(obj => obj.field === 'hazardous code')) {
            checkList.push({ field: 'UN Danger Code', errorDescription: this.view.$t('SeaExport.Required') })
          }
        }
        // goodsType等于2时为危险品才校验一下必填字段
        if (this.form.goodsType === 2) {
          if (!cargo.cusCode && !checkList.some(obj => obj.field === 'CUS CODE')) {
            checkList.push({ field: 'CUS CODE', errorDescription: this.view.$t('SeaExport.Required') })
          }
        }
        if (!cargo.cargoEnglishName && !checkList.some(obj => obj.field === 'Description')) {
          checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    } else {
      checkList.push({ field: 'Cargo Information', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 装箱信息数据
    if (this.view.container.rowData && this.view.container.rowData.length > 0) {
      for (const container of this.view.container.rowData) {
        if (!container.eqCode && !checkList.some(obj => obj.field === 'Container Type')) {
          checkList.push({ field: 'Container Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.containerOwnershipCode && !checkList.some(obj => obj.field === 'Container Owner')) {
          checkList.push({ field: 'Container Owner', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.containerNo && !checkList.some(obj => obj.field === 'Container No')) {
          checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.linkedCargoInformationNo && !checkList.some(obj => obj.field === 'Linked Cargo Information No')) {
          checkList.push({ field: 'Linked Cargo Information No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.sealNo && !checkList.some(obj => obj.field === 'Seal No')) {
          checkList.push({ field: 'Seal No', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    } else {
      checkList.push({ field: 'Container Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (checkList.length > 0) {
      this.view.$refs['ens'].openCheckTip(checkList)
      return false
    }
    return true
  }

  /**
   * link发送ENS字段校验
   */
  linkEnsCheck() {
    const checkList = []
    const declarationType = this.form.declarationType
    // 基本信息校验
    if (!this.form.hblNbr2) {
      checkList.push({ field: 'ENS No', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!declarationType) {
      checkList.push({ field: 'Filing Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.carrierEori) {
      checkList.push({ field: 'Carrier', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.declarantEori) {
      checkList.push({ field: 'Declarant', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.declaringMemberCountry) {
      checkList.push({ field: 'Memberstate', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.frob) {
      checkList.push({ field: 'Declare Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.chargesPaymentMethod) {
      checkList.push({ field: 'Payment Method', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPortCode) {
      checkList.push({ field: 'Place of Loading', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.dischargingPortCode) {
      checkList.push({ field: 'Place of Discharge', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 地址信息校验
    if (this.form.afrAddress && this.form.afrAddress.length > 0) {
      const address = this.form.afrAddress[0]
      if (declarationType !== 'F14') {
        if (!address.sellerName) {
          checkList.push({ type: 'Seller', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerAddress1) {
          checkList.push({ type: 'Seller', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerStreetNo) {
          checkList.push({ type: 'Seller', field: 'No.', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerPostalcode) {
          checkList.push({ type: 'Seller', field: 'ZIP', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerCity) {
          checkList.push({ type: 'Seller', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerCountry) {
          checkList.push({ type: 'Seller', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerTypeOfPerson) {
          checkList.push({ type: 'Seller', field: 'Type', errorDescription: this.view.$t('SeaExport.Required') })
        }

        if (!address.buyerName) {
          checkList.push({ type: 'Buyer', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerAddress1) {
          checkList.push({ type: 'Buyer', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerStreetNo) {
          checkList.push({ type: 'Buyer', field: 'No.', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerPostalcode) {
          checkList.push({ type: 'Buyer', field: 'ZIP', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerCity) {
          checkList.push({ type: 'Buyer', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerCountry) {
          checkList.push({ type: 'Buyer', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerTypeOfPerson) {
          checkList.push({ type: 'Buyer', field: 'Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }

      if (declarationType !== 'F16' && declarationType !== 'F17') {
        if (!address.shipperLine1) {
          checkList.push({ type: 'Shipper', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperLine3) {
          checkList.push({ type: 'Shipper', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperStreetNo) {
          checkList.push({ type: 'Shipper', field: 'No.', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperPostalcode) {
          checkList.push({ type: 'Shipper', field: 'ZIP', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperCity) {
          checkList.push({ type: 'Shipper', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperCountry) {
          checkList.push({ type: 'Shipper', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.shipperTypeOfPerson) {
          checkList.push({ type: 'Shipper', field: 'Type', errorDescription: this.view.$t('SeaExport.Required') })
        }

        if (!address.consigneeLine1) {
          checkList.push({ type: 'Consignee', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeLine3) {
          checkList.push({ type: 'Consignee', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeStreetNo) {
          checkList.push({ type: 'Consignee', field: 'No.', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneePostalcode) {
          checkList.push({ type: 'Consignee', field: 'ZIP', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeCity) {
          checkList.push({ type: 'Consignee', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeCountry) {
          checkList.push({ type: 'Consignee', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeTypeOfPerson) {
          checkList.push({ type: 'Consignee', field: 'Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    }

    if (declarationType !== 'F16' && declarationType !== 'F17') {
      // 装箱信息校验
      if (this.view.container.rowData && this.view.container.rowData.length > 0) {
        this.view.container.rowData.forEach((container) => {
          if (!container.containerNo) {
            checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!container.eqSize) {
            checkList.push({ field: 'Container Size', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!container.eqType) {
            checkList.push({ field: 'Container Type', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!container.linkedCargoSerialNumber) {
            checkList.push({ field: 'Linked cargo', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!container.containerOwnershipCode) {
            checkList.push({ field: 'Container owner', errorDescription: this.view.$t('SeaExport.Required') })
          }
        })
      } else {
        checkList.push({ field: 'Container Information', errorDescription: this.view.$t('SeaExport.Required') })
      }

      // 货物信息校验
      if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
        this.form.ensCargoInfo.forEach((cargo) => {
          if (!cargo.hsCode) {
            checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Required') })
          } else if (cargo.hsCode.length !== 6) {
            checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Only6') })
          }
          if (!cargo.quantity) {
            checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!cargo.packing) {
            checkList.push({ field: 'unit type', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!cargo.weight) {
            checkList.push({ field: 'Gross weight', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!cargo.mark) {
            checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.Required') })
          }
          if (!cargo.cargoEnglishName) {
            checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.Required') })
          }
        })
      } else {
        checkList.push({ field: 'Cargo Information', errorDescription: this.view.$t('SeaExport.Required') })
      }
    }

    if (checkList.length > 0) {
      this.view.$refs['ens'].openCheckTip(checkList)
      return false
    }
    return true
  }

  // 判断传入的字符串是否全部为空
  isAllNuLL(...strs) {
    for (const str of strs) {
      if (str) {
        return true
      }
    }
    return false
  }
  /**
   * 启泰发送ENS字段校验
   */
  trEnscheck() {
    const checkList = []
    /* this.ensMblCheck(checkList) */
    if (!this.form.containerLoadType) {
      checkList.push({ field: 'Consignment Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.chargesPaymentMethod) {
      checkList.push({ field: 'Charges Payment Method', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.frob) {
      checkList.push({ field: 'Declare Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPortCode) {
      checkList.push({ field: 'Place of Loading', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPort) {
      checkList.push({ field: 'Place of Loading Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.dischargingPortCode) {
      checkList.push({ field: 'Place of Discharge', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPort) {
      checkList.push({ field: 'Place of Loading Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.hblNbr2) {
      checkList.push({ field: 'ENS NO', errorDescription: this.view.$t('SeaExport.Required') })
    } else if (this.form.hblNbr2.length > 18) {
      checkList.push({ field: 'ENS NO', errorDescription: this.view.$t('SeaExport.maxLength', ['18']) })
    }
    if (!this.form.mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    } else if (this.form.mbl.length > 25) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.maxLength', ['25']) })
    }
    if (!this.form.declarantEori) {
      checkList.push({ field: 'Declarant EORI', errorDescription: this.view.$t('SeaExport.Required') })
    } else if (this.form.declarantEori.length !== 17) {
      checkList.push({ field: 'Declarant EORI', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['17']) })
    }
    if (this.form.voyageFlight.length > 10) {
      checkList.push({ field: 'Voyage', errorDescription: this.view.$t('SeaExport.maxLength', ['10']) })
    }
    if (this.form.vesselIMO.length > 7) {
      checkList.push({ field: 'IMO', errorDescription: this.view.$t('SeaExport.maxLength', ['7']) })
    }
    if (this.form.freightTermHBL) {
      const freightTermHBLArr = this.form.freightTermHBL.split('-')
      if (this.form.dischargingPortCode !== this.form.destinationPortCode && freightTermHBLArr[1] === 'CY') {
        checkList.push({ field: 'Deliv.Mode', errorDescription: this.view.$t('SeaExport.FreightTermConflict') })
      }
      if (this.form.loadingPortCode !== this.form.dispatchingPlaceCode && freightTermHBLArr[0] === 'CY') {
        checkList.push({ field: 'Deliv.Mode', errorDescription: this.view.$t('SeaExport.FreightTermConflict2') })
      }
    }
    if (!this.form.firstPortOfCallCode) {
      checkList.push({ field: 'First Port of Call', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (this.form.lastAbroadProd) {
      const validPrefixes = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'CH', 'NO', 'XI']
      const portCode = this.form.lastAbroadProd.substring(0, 2)
      if (validPrefixes.includes(portCode)) {
        checkList.push({
          field: 'Last Foreign Port',
          errorDescription: this.view.$t('SeaExport.NeedFillPortBeforeEnteringEU')
        })
      }
    }

    // ens 收发通地址信息
    if (this.form.afrAddress && this.form.afrAddress.length > 0) {
      const address = this.form.afrAddress[0]
      const isImport = this.form.frob === 'I'
      if (!address.shipperLine1.trim()) {
        checkList.push({ type: 'Shipper', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (address.shipperLine1.trim().length > 40) {
        checkList.push({ type: 'Shipper', field: 'Name', errorDescription: this.view.$t('SeaExport.maxLength', ['40']) })
      }
      if (!address.shipperEori.trim() && address.shipperTypeOfPerson !== '1' && isImport && this.isEuropeanUnion(address.shipperCountry)) {
        checkList.push({ type: 'Shipper', field: 'EORI', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.shipperEori.trim().length > 17) {
        checkList.push({ type: 'Shipper', field: 'EORI', errorDescription: this.view.$t('SeaExport.maxLength', ['17']) })
      }
      if (!address.shipperProvince.trim() && (address.shipperCountry === 'CA' || address.shipperCountry === 'US')) {
        checkList.push({ type: 'Shipper', field: 'State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.shipperProvince.trim().length > 2) {
        checkList.push({ type: 'Shipper', field: 'State', errorDescription: this.view.$t('SeaExport.maxLength', ['2']) })
      }
      if (address.shipperContactName.trim().length > 25) {
        checkList.push({ type: 'Shipper', field: 'Contact Name', errorDescription: this.view.$t('SeaExport.maxLength', ['25']) })
      }
      if (!address.shipperTypeOfPerson.trim()) {
        checkList.push({ type: 'Shipper', field: 'Type Of Person', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperLine3.trim()) {
        checkList.push({ type: 'Shipper', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (address.shipperLine3.trim().length > 50) {
        checkList.push({ type: 'Shipper', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
      }
      if (!address.shipperPostalcode.trim()) {
        checkList.push({ type: 'Shipper', field: 'Zip', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (address.shipperPostalcode.trim().length > 10) {
        checkList.push({ type: 'Shipper', field: 'Zip', errorDescription: this.view.$t('SeaExport.maxLength', ['10']) })
      }
      if (!address.shipperEmail.trim()) {
        checkList.push({ type: 'Shipper', field: 'Email', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (address.shipperEmail.trim().length > 50) {
        checkList.push({ type: 'Shipper', field: 'Email', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
      }
      if (!address.shipperTel.trim()) {
        checkList.push({ type: 'Shipper', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (address.shipperTel.trim().length > 23) {
        checkList.push({ type: 'Shipper', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['23']) })
      }
      if (!address.shipperCity.trim()) {
        checkList.push({ type: 'Shipper', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
      } else if (address.shipperCity.trim().length < 3 || address.shipperCity.trim().length > 26) {
        checkList.push({ type: 'Shipper', field: 'City', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['3-26']) })
      }
      if (!address.shipperCountry.trim()) {
        checkList.push({ type: 'Shipper', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
      }

      // 如果name包含 to order 则以下字段不必填
      if (!this.containsIgnoreCase(address.consigneeLine1, 'to order')) {
        if (!address.consigneeLine1.trim()) {
          checkList.push({ type: 'Consignee', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeLine3.trim()) {
          checkList.push({ type: 'Consignee', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeCity.trim()) {
          checkList.push({ type: 'Consignee', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeCountry) {
          checkList.push({ type: 'Consignee', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeTel.trim()) {
          checkList.push({ type: 'Consignee', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.consigneeEmail.trim()) {
          checkList.push({ type: 'Consignee', field: 'Email', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
      if (address.consigneeLine1.trim().length > 40) {
        checkList.push({ type: 'Consignee', field: 'Name', errorDescription: this.view.$t('SeaExport.maxLength', ['40']) })
      }
      if (!address.consigneeEori.trim() && address.consigneeTypeOfPerson !== '1' && isImport && this.isEuropeanUnion(address.consigneeCountry)) {
        checkList.push({ type: 'Consignee', field: 'EORI', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.consigneeEori.trim().length > 17) {
        checkList.push({ type: 'Consignee', field: 'EORI', errorDescription: this.view.$t('SeaExport.maxLength', ['17']) })
      }
      if (!address.consigneeProvince.trim() && (address.consigneeCountry === 'CA' || address.consigneeCountry === 'US')) {
        checkList.push({ type: 'Consignee', field: 'State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.consigneeProvince.trim().length > 2) {
        checkList.push({ type: 'Consignee', field: 'State', errorDescription: this.view.$t('SeaExport.maxLength', ['2']) })
      }
      if (address.consigneeContactName.trim().length > 25) {
        checkList.push({ type: 'Consignee', field: 'Contact Name', errorDescription: this.view.$t('SeaExport.maxLength', ['25']) })
      }
      if (address.consigneeEmail.trim().length > 50) {
        checkList.push({ type: 'Consignee', field: 'Email', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
      }
      if (address.consigneeTel.trim().length > 23) {
        checkList.push({ type: 'Consignee', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['23']) })
      }
      if (address.consigneeLine3.trim() && address.consigneeLine3.trim().length > 50) {
        checkList.push({ type: 'Consignee', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
      }
      if (address.consigneeCity.trim() && (address.consigneeCity.trim().length < 3 || address.consigneeCity.trim().length > 26)) {
        checkList.push({ type: 'Consignee', field: 'City', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['3-26']) })
      }
      if (address.consigneePostalcode.trim().length > 10) {
        checkList.push({ type: 'Consignee', field: 'Zip', errorDescription: this.view.$t('SeaExport.maxLength', ['10']) })
      }

      // 如果通知人name = same as consignee （不区分大小写）并且 收货人name 不包含 to order 则不用校验通知人必填
      // 收货人如果name包含 to order 则以下字段必填 如果不包含 to order 但是 必填字段有一个填了 且 通知人name 不是 same as consignee 下字段必填
      if (this.containsIgnoreCase(address.consigneeLine1, 'to order') ||
        (!this.containsIgnoreCase(address.consigneeLine1, 'to order') && !(address.notifyLine1.trim().toLowerCase() === 'same as consignee') &&
          (address.notifyLine1.trim() || address.notifyLine3.trim() && address.notifyCity.trim() || address.notifyCountry && address.notifyTel.trim() || address.notifyEmail.trim()))) {
        if (!address.notifyLine1.trim()) {
          checkList.push({ type: 'Notify', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.notifyLine3.trim()) {
          checkList.push({ type: 'Notify', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.notifyCity.trim()) {
          checkList.push({ type: 'Notify', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.notifyCountry) {
          checkList.push({ type: 'Notify', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.notifyTel.trim()) {
          checkList.push({ type: 'Notify', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.notifyEmail.trim()) {
          checkList.push({ type: 'Notify', field: 'Email', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
      if (address.notifyLine1.trim().length > 40) {
        checkList.push({ type: 'Notify', field: 'Name', errorDescription: this.view.$t('SeaExport.maxLength', ['40']) })
      }
      if (!address.notifyEori.trim() && address.notifyTypeOfPerson !== '1' && isImport && this.isEuropeanUnion(address.notifyCountry)) {
        checkList.push({ type: 'Notify', field: 'EORI', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.notifyEori.trim().length > 17) {
        checkList.push({ type: 'Notify', field: 'EORI', errorDescription: this.view.$t('SeaExport.maxLength', ['17']) })
      }
      if (!address.notifyProvince.trim() && (address.notifyCountry === 'CA' || address.notifyCountry === 'US')) {
        checkList.push({ type: 'Notify', field: 'State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.notifyProvince.trim().length > 2) {
        checkList.push({ type: 'Notify', field: 'State', errorDescription: this.view.$t('SeaExport.maxLength', ['2']) })
      }
      if (address.notifyContactName.trim().length > 25) {
        checkList.push({ type: 'Notify', field: 'Contact Name', errorDescription: this.view.$t('SeaExport.maxLength', ['25']) })
      }
      if (address.notifyEmail.trim().length > 50) {
        checkList.push({ type: 'Notify', field: 'Email', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
      }
      if (address.notifyTel.trim().length > 23) {
        checkList.push({ type: 'Notify', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['23']) })
      }
      if (address.notifyLine3.trim() && address.notifyLine3.trim().length > 50) {
        checkList.push({ type: 'Notify', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
      }
      if (address.notifyCity.trim() && (address.notifyCity.trim().length < 3 || address.notifyCity.trim().length > 26)) {
        checkList.push({ type: 'Notify', field: 'City', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['3-26']) })
      }
      if (address.notifyPostalcode.trim() && address.notifyPostalcode.trim().length > 10) {
        checkList.push({ type: 'Notify', field: 'Zip', errorDescription: this.view.$t('SeaExport.maxLength', ['10']) })
      }
      // 选择 Import 必填项
      if (isImport) {
        if (!address.sellerName.trim()) {
          checkList.push({ type: 'Seller', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerEmail.trim()) {
          checkList.push({ type: 'Seller', field: 'Email', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerTel.trim()) {
          checkList.push({ type: 'Seller', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerCity.trim()) {
          checkList.push({ type: 'Seller', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerCountry.trim()) {
          checkList.push({ type: 'Seller', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.sellerEori.trim() && address.sellerTypeOfPerson !== '1' && this.isEuropeanUnion(address.sellerCountry)) {
          checkList.push({ type: 'Seller', field: 'Eori', errorDescription: this.view.$t('SeaExport.Required') })
        }

        if (address.sellerName.trim().length > 70) {
          checkList.push({ type: 'Seller', field: 'Name', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
        if (address.sellerAddress1.trim().length > 70) {
          checkList.push({ type: 'Seller', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
        if (address.sellerEori.trim().length > 17) {
          checkList.push({ type: 'Seller', field: 'Eori', errorDescription: this.view.$t('SeaExport.maxLength', ['17']) })
        }
        if (address.sellerCity.trim() && (address.sellerCity.trim().length < 3 || address.sellerCity.trim().length > 26)) {
          checkList.push({ type: 'Seller', field: 'City', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['3-26']) })
        }
        if (address.sellerProvince.trim().length > 17) {
          checkList.push({ type: 'Seller', field: 'State', errorDescription: this.view.$t('SeaExport.maxLength', ['17']) })
        }
        if (address.sellerPostalcode.trim().length > 10) {
          checkList.push({ type: 'Seller', field: 'Zip', errorDescription: this.view.$t('SeaExport.maxLength', ['10']) })
        }
        if (address.sellerContactName.trim().length > 25) {
          checkList.push({ type: 'Seller', field: 'Contact Name', errorDescription: this.view.$t('SeaExport.maxLength', ['25']) })
        }
        if (address.sellerEmail.trim().length > 50) {
          checkList.push({ type: 'Seller', field: 'Email', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
        }
        if (address.sellerTel.trim().length > 23) {
          checkList.push({ type: 'Seller', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['23']) })
        }

        if (!address.buyerName.trim()) {
          checkList.push({ type: 'Buyer', field: 'Name', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerEmail.trim()) {
          checkList.push({ type: 'Buyer', field: 'Email', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerTel.trim()) {
          checkList.push({ type: 'Buyer', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerCity.trim()) {
          checkList.push({ type: 'Buyer', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerCountry.trim()) {
          checkList.push({ type: 'Buyer', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!address.buyerEori.trim() && address.buyerTypeOfPerson !== '1' && this.isEuropeanUnion(address.buyerCountry)) {
          checkList.push({ type: 'Buyer', field: 'Eori', errorDescription: this.view.$t('SeaExport.Required') })
        }

        if (address.buyerName.trim().length > 70) {
          checkList.push({ type: 'Buyer', field: 'Name', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
        if (address.buyerAddress1.trim().length > 70) {
          checkList.push({ type: 'Buyer', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
        if (address.buyerEori.trim().length > 17) {
          checkList.push({ type: 'Buyer', field: 'Eori', errorDescription: this.view.$t('SeaExport.maxLength', ['17']) })
        }
        if (address.buyerCity.trim() && (address.buyerCity.trim().length < 3 || address.sellerCity.trim().length > 26)) {
          checkList.push({ type: 'Buyer', field: 'City', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['3-26']) })
        }
        if (address.buyerProvince.trim().length > 17) {
          checkList.push({ type: 'Buyer', field: 'State', errorDescription: this.view.$t('SeaExport.maxLength', ['17']) })
        }
        if (address.buyerPostalcode.trim().length > 10) {
          checkList.push({ type: 'Buyer', field: 'Zip', errorDescription: this.view.$t('SeaExport.maxLength', ['10']) })
        }
        if (address.buyerContactName.trim().length > 25) {
          checkList.push({ type: 'Buyer', field: 'Contact Name', errorDescription: this.view.$t('SeaExport.maxLength', ['25']) })
        }
        if (address.buyerEmail.trim().length > 50) {
          checkList.push({ type: 'Buyer', field: 'Email', errorDescription: this.view.$t('SeaExport.maxLength', ['50']) })
        }
        if (address.buyerTel.trim().length > 23) {
          checkList.push({ type: 'Buyer', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['23']) })
        }
      }
    } else {
      checkList.push({ field: 'Customer Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 货物信息数据
    if (this.form.ensCargoInfo && this.form.ensCargoInfo.length > 0) {
      for (const cargo of this.form.ensCargoInfo) {
        if (!cargo.hsCode) {
          checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Required') })
        } else if (cargo.hsCode.length !== 6 || !NumberUtils.isNumberStr(cargo.hsCode)) {
          checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Only6') })
        }
        if (!cargo.weight) {
          checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
        }
        // 去掉小数点后长度是否大于十位
        if (cargo.weight) {
          const numStr = cargo.weight.toString()
          const integerPart = numStr.replace('.', '')
          if (integerPart.length > 10) {
            checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.maxLength', ['10']) })
          }
        }
        if (!cargo.packing) {
          checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!cargo.quantity) {
          checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (cargo.quantity && (cargo.quantity + '').length > 7) {
          checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.maxLength', ['7']) })
        }
        if (cargo.cubage) {
          const numStr = cargo.cubage.toString()
          const integerPart = numStr.replace('.', '')
          if (integerPart.length > 6 && !checkList.some(obj => obj.field === 'Volume')) {
            checkList.push({ field: 'Volume', errorDescription: this.view.$t('SeaExport.maxLength', ['6']) })
          }
        }
        if (cargo.mark.length > 45) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.maxLength', ['45']) })
        }
        // goodsType等于1时为危险品才校验一下必填字段
        if (this.form.goodsType === 1) {
          if (!cargo.undgCode) {
            checkList.push({ field: 'UN Danger Code', errorDescription: this.view.$t('SeaExport.Required') })
          }
        }
        // goodsType等于2时为危险品才校验一下必填字段
        if (this.form.goodsType === 2) {
          if (!cargo.cusCode) {
            checkList.push({ field: 'CUS CODE', errorDescription: this.view.$t('SeaExport.Required') })
          }
        }
      }
    } else {
      checkList.push({ field: 'Cargo Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 装箱信息数据
    if (this.view.container.rowData && this.view.container.rowData.length > 0) {
      for (const container of this.view.container.rowData) {
        if (!container.containerNo && !checkList.some(obj => obj.field === 'Container No')) {
          checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.cargoName && !checkList.some(obj => obj.field === 'Container No')) {
          checkList.push({ field: 'Commodity Decription', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.mark && !checkList.some(obj => obj.field === 'Container No')) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.linkedCargoInformationNo && !checkList.some(obj => obj.field === 'Linked Cargo Information No')) {
          checkList.push({ field: 'Linked Cargo Information No', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    } else {
      checkList.push({ field: 'Container Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (checkList.length > 0) {
      this.view.$refs['ens'].openCheckTip(checkList)
      return false
    }
    return true
  }

  /**
   * Link AMS字段校验
   */
  linkAmsCheck() {
    const checkList = []
    // 船名航次校验
    if (!this.job.vessel) {
      checkList.push({ field: this.view.$t('SeaExport.Vessel'), errorDescription: this.view.$t('SeaExport.VesselNotNull') })
    }
    if (!this.job.voyageFlight) {
      checkList.push({ field: this.view.$t('SeaExport.Voyage'), errorDescription: this.view.$t('SeaExport.VoyageNotNull') })
    }
    // eta 校验
    if (!this.job.eta) {
      checkList.push({ field: 'ETA', errorDescription: this.view.$t('SeaExport.EtaNotNull') })
    }
    // mbl 去掉 this.form.nvoccScac前缀
    const mbl = deletePrefix(this.form.mbl, this.form.nvoccScac)
    // hbl 去掉 this.form.nvoccScac前缀
    const hbl = deletePrefix(this.form.hblNbr2, this.form.nvoccScac)
    // MBL主单号校验
    if (!mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // HB/L NO校验
    if (!hbl) {
      checkList.push({ field: 'HB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    } else {
      // 合规字符校验：只能输入大写字母，数字，短横杠，斜杠
      const hblPattern = /^[A-Z0-9\-/]*$/
      if (!hblPattern.test(hbl)) {
        checkList.push({ field: 'HB/L NO', errorDescription: this.view.$t('SeaExport.HblCheck') })
      }
      // 最大长度校验
      if (hbl.length > 12) {
        checkList.push({ field: 'HB/L NO', errorDescription: this.view.$t('SeaExport.maxLength', ['12']) })
      }
    }
    // 无船承运人SCAC校验
    if (!this.form.nvoccScac) {
      checkList.push({ field: 'SCAC CODE', errorDescription: this.view.$t('SeaExport.Required') })
    } else if (this.form.nvoccScac.length > 4) {
      checkList.push({ field: 'SCAC CODE', errorDescription: this.view.$t('SeaExport.maxLength', ['4']) })
    }
    // 船公司校验
    if (!this.form.carrierEori) {
      checkList.push({ field: 'Carrier', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 运输类型校验
    if (!this.form.frob) {
      checkList.push({ field: 'Declare Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 起运港校验
    if (!this.form.loadingPortCode) {
      checkList.push({ field: 'Place of Loading', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 目的港校验（当运输类型选择Import时，判断必填）
    if (this.form.frob === 'I' && !this.form.dischargingPortCode) {
      checkList.push({ field: 'Place of Discharge', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 抵美前最后港口校验
    if (!this.form.lastAbroadProd) {
      checkList.push({ field: 'Last Foreign Port', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 抵美第一港口校验（当运输类型选择FROB时，判断必填）
    if (this.form.frob === 'F' && !this.form.firstPortOfCallCode) {
      checkList.push({ field: 'First Port of Call', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // 船籍校验
    if (!this.form.nationalityCodeofVessel) {
      checkList.push({ field: 'VesselFlag', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 收发通信息校验
    if (this.form.afrAddress && this.form.afrAddress.length > 0) {
      const address = this.form.afrAddress[0]
      // 发货人信息校验
      if (!address.shipperLine1) {
        checkList.push({ type: 'Shipper', field: 'name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperLine3) {
        checkList.push({ type: 'Shipper', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 州/省校验（非必填，不为空时需填写2位）
      if (address.shipperProvince && address.shipperProvince.length !== 2) {
        checkList.push({ type: 'Shipper', field: 'State', errorDescription: this.view.$t('SeaExport.MustBe2') })
      }
      // 邮编校验（非必填，字符3-15位）
      if (address.shipperPostalcode && (address.shipperPostalcode.length < 3 || address.shipperPostalcode.length > 15)) {
        checkList.push({ type: 'Shipper', field: 'ZIP', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['3-15']) })
      }
      // 城市校验
      if (address.shipperCity && address.shipperCity.length > 30) {
        checkList.push({ type: 'Shipper', field: 'City', errorDescription: this.view.$t('SeaExport.maxLength', ['30']) })
      }
      // 州代码、国家代码、邮政编码任一填写时，城市必填
      if ((address.shipperProvince || address.shipperCountry || address.shipperPostalcode) && !address.shipperCity) {
        checkList.push({ type: 'Shipper', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 收货人信息校验
      if (!address.consigneeLine1) {
        checkList.push({ type: 'Consignee', field: 'name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeLine3) {
        checkList.push({ type: 'Consignee', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.consigneeProvince && address.consigneeProvince.length !== 2) {
        checkList.push({ type: 'Consignee', field: 'State', errorDescription: this.view.$t('SeaExport.MustBe2') })
      }
      if (address.consigneePostalcode && (address.consigneePostalcode.length < 3 || address.consigneePostalcode.length > 15)) {
        checkList.push({ type: 'Consignee', field: 'ZIP', errorDescription: this.view.$t('SeaExport.PleaseEnterLength', ['3-15']) })
      }
      if (address.consigneeCity && address.consigneeCity.length > 30) {
        checkList.push({ type: 'Consignee', field: 'City', errorDescription: this.view.$t('SeaExport.maxLength', ['30']) })
      }
      if ((address.consigneeProvince || address.consigneeCountry || address.consigneePostalcode) && !address.consigneeCity) {
        checkList.push({ type: 'Consignee', field: 'City', errorDescription: this.view.$t('SeaExport.Required') })
      }
    }

    // 装箱信息校验
    if (this.view.container && this.view.container.rowData && this.view.container.rowData.length > 0) {
      for (const container of this.view.container.rowData) {
        if (container.deleted) continue

        // 箱号校验
        if (!container.containerNo) {
          checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
        } else {
          // 11个字符，大写字母和数字的组合，第四位必须是字母U
          const containerPattern = /^[A-Z0-9]{11}$/
          if (!containerPattern.test(container.containerNo)) {
            checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.MustBe11') })
          } else if (container.containerNo.charAt(3) !== 'U') {
            checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.MustBeU') })
          }
        }
        // 件数校验
        if (!container.quantity) {
          checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
        }
        // 包装单位校验
        if (!container.packing) {
          checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        // 毛重校验
        if (!container.weight) {
          checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
        }
        // 唛头校验
        if (!container.mark) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.Required') })
        } else if (container.mark && container.mark.length > 180) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.maxLength', ['180']) })
        }
        // 品名校验
        if (!container.cargoName) {
          checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.Required') })
        } else if (container.cargoName && container.cargoName.length > 180) {
          checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.maxLength', ['180']) })
        }
        // 危险品代码校验（非必填）
        if (container.undgNumber && container.undgNumber.length !== 4) {
          checkList.push({ field: 'UN CODE', errorDescription: this.view.$t('SeaExport.MustBe4') })
        }
      }
    } else {
      checkList.push({ field: 'House Container Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (checkList.length > 0) {
      this.view.$refs['ams'].openCheckTip(checkList)
      return false
    }
    return true
  }

  /**
   * Link AFR字段校验
   */
  linkAfrCheck() {
    const checkList = []

    // 分单号校验
    const hblNbr2 = this.afrForm.hblNbr2
    if (!hblNbr2) {
      checkList.push({ field: 'HB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    } else {
      // 合规字符校验：只能输入大写字母，数字，短横杠，斜杠
      const hblPattern = /^[A-Z0-9\-/]*$/
      if (!hblPattern.test(hblNbr2)) {
        checkList.push({ field: 'HB/L NO', errorDescription: this.view.$t('SeaExport.HblCheck') })
      }
      // 最大长度校验 - 12位
      if (hblNbr2.length > 12) {
        checkList.push({ field: 'HB/L NO', errorDescription: this.view.$t('SeaExport.maxLength', ['12']) })
      }
    }
    // 船名航次校验
    if (!this.job.vessel) {
      checkList.push({ field: this.view.$t('SeaExport.Vessel'), errorDescription: this.view.$t('SeaExport.VesselNotNull') })
    }
    if (!this.job.voyageFlight) {
      checkList.push({ field: this.view.$t('SeaExport.Voyage'), errorDescription: this.view.$t('SeaExport.VoyageNotNull') })
    }
    // eta 校验
    if (!this.job.eta) {
      checkList.push({ field: 'ETA', errorDescription: this.view.$t('SeaExport.EtaNotNull') })
    }
    // 无船承运人Code校验
    if (!this.afrForm.nvoccScac) {
      checkList.push({ field: 'SCAC CODE', errorDescription: this.view.$t('SeaExport.Required') })
    } else if (this.afrForm.nvoccScac.length !== 4) {
      checkList.push({ field: 'SCAC CODE', errorDescription: this.view.$t('SeaExport.MustBe4') })
    }

    // 船公司校验 - 检查是否取到SCAC_CODE的值
    if (!this.afrForm.carrierEori) {
      checkList.push({ field: 'Carrier', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // MBL主单号校验
    if (!this.afrForm.mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    } else if (this.afrForm.mbl.length > 31) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.maxLength', ['31']) })
    }

    // 发送离港通知校验
    if (!this.afrForm.atdCompleted) {
      checkList.push({ field: 'Issue Departure Notice', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 起运港校验
    if (!this.afrForm.loadingPortCode) {
      checkList.push({ field: 'Place of Loading', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 发货地校验
    if (!this.afrForm.dispatchingPlaceCode) {
      checkList.push({ field: 'Place of Receipt', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 卸货地校验
    if (!this.afrForm.dischargingPortCode) {
      checkList.push({ field: 'Place of Discharge', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 交货地校验
    if (!this.afrForm.destinationPortCode) {
      checkList.push({ field: 'Place of Delivery', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 船舶呼号校验
    if (!this.afrForm.vesselCode) {
      checkList.push({ field: 'VesselCallSign', errorDescription: this.view.$t('SeaExport.Required') })
    } else {
      // 1-9 位大写字母或数字
      const vesselCallSignPattern = /^[A-Z0-9]{1,9}$/
      if (!vesselCallSignPattern.test(this.afrForm.vesselCode)) {
        checkList.push({ field: 'VesselCallSign', errorDescription: this.view.$t('SeaExport.VesselCallSignCheck') })
      }
    }

    // 收发通信息校验
    if (this.afrForm.afrAddress && this.afrForm.afrAddress.length > 0) {
      const address = this.afrForm.afrAddress[0]

      // 发货人信息校验
      if (!address.shipperLine1) {
        checkList.push({ type: 'Shipper', field: 'name', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const namePattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!namePattern.test(address.shipperLine1)) {
          checkList.push({ type: 'Shipper', field: 'name', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.shipperLine1.length > 70) {
          checkList.push({ type: 'Shipper', field: 'name', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      if (!address.shipperLine3) {
        checkList.push({ type: 'Shipper', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const address1Pattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!address1Pattern.test(address.shipperLine3)) {
          checkList.push({ type: 'Shipper', field: 'Address1', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.shipperLine3.length > 70) {
          checkList.push({ type: 'Shipper', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      // 发货人地址2校验（非必填）
      if (address.shipperLine4) {
        const address2Pattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!address2Pattern.test(address.shipperLine4)) {
          checkList.push({ type: 'Shipper', field: 'Address2', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.shipperLine4.length > 70) {
          checkList.push({ type: 'Shipper', field: 'Address2', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      // 发货人邮编校验（非必填）
      if (address.shipperPostalcode && address.shipperPostalcode.length > 9) {
        checkList.push({ type: 'Shipper', field: 'ZIP', errorDescription: this.view.$t('SeaExport.maxLength', ['9']) })
      }
      // 发货人国家校验
      if (!address.shipperCountry) {
        checkList.push({ type: 'Shipper', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 发货人电话校验（必填）
      if (!address.shipperTel) {
        checkList.push({ type: 'Shipper', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const telPattern = /^\d*$/
        if (!telPattern.test(address.shipperTel)) {
          checkList.push({ type: 'Shipper', field: 'Tel', errorDescription: this.view.$t('SeaExport.PhoneFormat') })
        }
        if (address.shipperTel.length > 14) {
          checkList.push({ type: 'Shipper', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['14']) })
        }
      }

      // 收货人信息校验
      if (!address.consigneeLine1) {
        checkList.push({ type: 'Consignee', field: 'name', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const namePattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!namePattern.test(address.consigneeLine1)) {
          checkList.push({ type: 'Consignee', field: 'name', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.consigneeLine1.length > 70) {
          checkList.push({ type: 'Consignee', field: 'name', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      if (!address.consigneeLine3) {
        checkList.push({ type: 'Consignee', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const address1Pattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!address1Pattern.test(address.consigneeLine3)) {
          checkList.push({ type: 'Consignee', field: 'Address1', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.consigneeLine3.length > 70) {
          checkList.push({ type: 'Consignee', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      // 收货人地址2校验（非必填）
      if (address.consigneeLine4) {
        const address2Pattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!address2Pattern.test(address.consigneeLine4)) {
          checkList.push({ type: 'Consignee', field: 'Address2', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.consigneeLine4.length > 70) {
          checkList.push({ type: 'Consignee', field: 'Address2', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      // 收货人邮编校验（非必填）
      if (address.consigneePostalcode && address.consigneePostalcode.length > 9) {
        checkList.push({ type: 'Consignee', field: 'ZIP', errorDescription: this.view.$t('SeaExport.maxLength', ['9']) })
      }
      // 收货人国家校验
      if (!address.consigneeCountry) {
        checkList.push({ type: 'Consignee', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 收货人电话校验（必填）
      if (!address.consigneeTel) {
        checkList.push({ type: 'Consignee', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const telPattern = /^\d*$/
        if (!telPattern.test(address.consigneeTel)) {
          checkList.push({ type: 'Consignee', field: 'Tel', errorDescription: this.view.$t('SeaExport.PhoneFormat') })
        }
        if (address.consigneeTel.length > 14) {
          checkList.push({ type: 'Consignee', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['14']) })
        }
      }

      // 通知人信息校验（非必填，但如果有值需要校验格式和长度）
      if (!address.notifyLine1) {
        checkList.push({ type: 'Notify', field: 'name', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const namePattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!namePattern.test(address.notifyLine1)) {
          checkList.push({ type: 'Notify', field: 'name', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.notifyLine1.length > 70) {
          checkList.push({ type: 'Notify', field: 'name', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      if (!address.notifyLine3) {
        checkList.push({ type: 'Notify', field: 'Address1', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const address1Pattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!address1Pattern.test(address.notifyLine3)) {
          checkList.push({ type: 'Notify', field: 'Address1', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.notifyLine3.length > 70) {
          checkList.push({ type: 'Notify', field: 'Address1', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      // 通知人地址2校验（非必填）
      if (address.notifyLine4) {
        const address2Pattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!address2Pattern.test(address.notifyLine4)) {
          checkList.push({ type: 'Notify', field: 'Address2', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (address.notifyLine4.length > 70) {
          checkList.push({ type: 'Notify', field: 'Address2', errorDescription: this.view.$t('SeaExport.maxLength', ['70']) })
        }
      }
      // 通知人邮编校验（非必填）
      if (address.notifyPostalcode && address.notifyPostalcode.length > 9) {
        checkList.push({ type: 'Notify', field: 'ZIP', errorDescription: this.view.$t('SeaExport.maxLength', ['9']) })
      }
      // 通知人国家校验
      if (!address.notifyCountry) {
        checkList.push({ type: 'Notify', field: 'Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 通知人电话校验（必填）
      if (!address.notifyTel) {
        checkList.push({ type: 'Notify', field: 'Tel', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const telPattern = /^\d*$/
        if (!telPattern.test(address.notifyTel)) {
          checkList.push({ type: 'Notify', field: 'Tel', errorDescription: this.view.$t('SeaExport.PhoneFormat') })
        }
        if (address.notifyTel.length > 14) {
          checkList.push({ type: 'Notify', field: 'Tel', errorDescription: this.view.$t('SeaExport.maxLength', ['14']) })
        }
      }
    }

    // 箱子信息校验
    if (this.view.afrContainer && this.view.afrContainer.rowData && this.view.afrContainer.rowData.length > 0) {
      for (const container of this.view.afrContainer.rowData) {
        if (container.deleted) continue

        // 箱号校验
        if (!container.containerNo) {
          checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
        } else {
          // 11个字符，大写字母和数字的组合，第四位必须是字母U
          const containerPattern = /^[A-Z0-9]{11}$/
          if (!containerPattern.test(container.containerNo)) {
            checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.MustBe11') })
          } else if (container.containerNo.charAt(3) !== 'U') {
            checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.MustBeU') })
          }
        }

        // 箱型校验
        if (!container.eqType) {
          checkList.push({ field: 'Container Type', errorDescription: this.view.$t('SeaExport.Required') })
        }

        // 箱量校验
        if (!container.eqSize) {
          checkList.push({ field: 'Container Size', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    } else {
      checkList.push({ field: 'House Container Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (this.afrForm.ensCargoInfo && this.afrForm.ensCargoInfo.length === 1) {
      const cargoInfo = this.afrForm.ensCargoInfo[0]
      // HS CODE校验
      if (!cargoInfo.hsCode) {
        checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        // 6位数字
        const hsCodePattern = /^\d{6}$/
        if (!hsCodePattern.test(cargoInfo.hsCode)) {
          checkList.push({ field: 'HS CODE', errorDescription: this.view.$t('SeaExport.Only6') })
        }
      }

      // 件数校验
      if (!cargoInfo.quantity) {
        checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
      }

      // 包装单位校验
      if (!cargoInfo.packing) {
        checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
      }

      // 毛重校验
      if (!cargoInfo.weight) {
        checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
      }

      // 唛头校验（非必填，有值时校验格式和长度）
      if (!cargoInfo.mark) {
        checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const markPattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!markPattern.test(cargoInfo.mark)) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (cargoInfo.mark.length > 140) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.maxLength', ['140']) })
        }
      }

      // 品名校验（非必填，有值时校验格式和长度）
      if (!cargoInfo.cargoEnglishName) {
        checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.Required') })
      } else {
        const cargoNamePattern = /^[a-zA-Z0-9"\-/,: '_"+]*$/
        if (!cargoNamePattern.test(cargoInfo.cargoEnglishName)) {
          checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.MarksFormat') })
        }
        if (cargoInfo.cargoEnglishName.length > 350) {
          checkList.push({ field: 'Description', errorDescription: this.view.$t('SeaExport.maxLength', ['350']) })
        }
      }

      // 危险品代码校验（非必填，有值时校验长度）
      if (cargoInfo.undgCode && cargoInfo.undgCode.length !== 4) {
        checkList.push({ field: 'UN CODE', errorDescription: this.view.$t('SeaExport.MustBe4') })
      }

      // 危险品分类校验（非必填，有值时校验长度）
      if (cargoInfo.dangerClass && cargoInfo.dangerClass.length > 4) {
        checkList.push({ field: 'Danger Class', errorDescription: this.view.$t('SeaExport.maxLength', ['4']) })
      }

      // 特殊货物编码校验（非必填，有值时校验长度）
      if (cargoInfo.spcCode && cargoInfo.spcCode.length !== 3) {
        checkList.push({ field: 'SPC CODE', errorDescription: this.view.$t('SeaExport.MustBe3') })
      }
    } else if (this.afrForm.ensCargoInfo && this.afrForm.ensCargoInfo.length > 1) {
      checkList.push({ field: 'Cargo Information', errorDescription: this.view.$t('SeaExport.OneCargoInfo') })
    } else {
      checkList.push({ field: 'Cargo Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (checkList.length > 0) {
      this.view.$refs['afr'].openCheckTip(checkList)
      return false
    }
    return true
  }
  /**
   * 判断国家是否在欧盟清单中
   */
  isEuropeanUnion(country) {
    if (this.view.localData.ytCountry && this.view.localData.ytCountry.length > 0) {
      for (const item of this.view.localData.ytCountry) {
        if (country === item.code) {
          return true
        }
      }
    }
    return false
  }

  /**
   * 判断字符串中是否包含另一个字符串 不区分大小写
   * @param str 字符串
   * @param searchStr 被包含的字符串
   */
  containsIgnoreCase(str, searchStr) {
    if (!str) {
      return false
    }
    return str.toLowerCase().includes(searchStr.toLowerCase())
  }

  /**
   * 验证发送 ens 时，mbl的前缀是否 跟船司的要求相匹配
   */
  ensMblCheck(checkList) {
    const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.carrierId)
    if (company && this.form.mbl) {
      if (this.matchCarrier(company, 'MSC')) {
        if (!this.form.mbl.startsWith('MEDU', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.NeedPrefix', ['MEDU']) })
        }
      } else if (this.matchCarrier(company, 'ONE')) {
        if (!this.form.mbl.startsWith('ONEY', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.NeedPrefix', ['ONEY']) })
        }
      } else if (this.matchCarrier(company, 'HPL')) {
        if (!this.form.mbl.startsWith('HLCU', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.NeedPrefix', ['HLCU']) })
        }
      } else if (this.matchCarrier(company, 'COSCO')) {
        if (this.form.mbl.startsWith('COSU', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.RemoveThePrefix', ['COSU']) })
        }
      } else if (this.matchCarrier(company, 'YML')) {
        if (this.form.mbl.startsWith('YMJA', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.RemoveThePrefix', ['YMJA']) })
        }
      } else if (this.matchCarrier(company, 'OOCL')) {
        if (this.form.mbl.startsWith('OOLU', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.RemoveThePrefix', ['OOLU']) })
        }
      } else if (this.matchCarrier(company, 'EMC')) {
        if (this.form.mbl.startsWith('EGLV', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.RemoveThePrefix', ['EGLV']) })
        }
      } else if (this.matchCarrier(company, 'MSK')) {
        if (this.form.mbl.startsWith('MAEU', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.RemoveThePrefix', ['MAEU']) })
        }
      } else if (this.matchCarrier(company, 'CMA')) {
        if (this.form.mbl.startsWith('CMDU', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.RemoveThePrefix', ['CMDU']) })
        }
      } else if (this.matchCarrier(company, 'HMM')) {
        if (this.form.mbl.startsWith('HDMU', 0)) {
          checkList.push({ field: 'MBL', errorDescription: this.view.$t('SeaExport.RemoveThePrefix', ['HDMU']) })
        }
      }
    }
  }

  /**
   * ens 同步时 一下船司需要去掉对应的前缀
   */
  removeMblPrefix() {
    const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.carrierId)
    if (company && this.form.mbl) {
      if (this.matchCarrier(company, 'COSCO')) {
        if (this.form.mbl.startsWith('COSU', 0)) {
          return this.form.mbl.slice(4)
        }
      } else if (this.matchCarrier(company, 'YML')) {
        if (this.form.mbl.startsWith('YMJA', 0)) {
          return this.form.mbl.slice(4)
        }
      } else if (this.matchCarrier(company, 'OOCL')) {
        if (this.form.mbl.startsWith('OOLU', 0)) {
          return this.form.mbl.slice(4)
        }
      } else if (this.matchCarrier(company, 'EMC')) {
        if (this.form.mbl.startsWith('EGLV', 0)) {
          return this.form.mbl.slice(4)
        }
      } else if (this.matchCarrier(company, 'MSK')) {
        if (this.form.mbl.startsWith('MAEU', 0)) {
          return this.form.mbl.slice(4)
        }
      } else if (this.matchCarrier(company, 'CMA')) {
        if (this.form.mbl.startsWith('CMDU', 0)) {
          return this.form.mbl.slice(4)
        }
      } else if (this.matchCarrier(company, 'HMM')) {
        if (this.form.mbl.startsWith('HDMU', 0)) {
          return this.form.mbl.slice(4)
        }
      }
    } else {
      return this.form.mbl
    }
  }
  /**
   * 通过code去匹配船司书否符合 匹配值 （代码、简称、中文名称、英文名称）
   */
  matchCarrier(company, code) {
    if (company) {
      if (company.code === code || company.shortName === code || company.name === code || company.englishName === code) {
        return true
      }
    }
    return false
  }

  async sendAfrEFreightXml() {
    const params = {
      departmentCode: this.view.$store.getters.currentDept.code,
      jobUuid: this.job.uuid,
      officeId: this.view.$store.getters.currentOfficeId,
      editStatus: 8,
      sendXml: this.view.afrXmlDialog.content
    }
    const loading = getLoading()
    sendAfrEFreightXml(params).then(resp => {
      if (resp.data) {
        this.view.afrXmlDialog.visible = false
        if (resp.data.text === '') {
          this.$message.success(this.view.$t('Message.SuccessfullySent'))
        } else {
          this.$message.info(resp.data.text)
        }
        this.view.onShow(this.job, true)
      }
    }).finally(() => {
      loading.close()
    })
  }
  downloadTxtFile() {
    const data = this.view.afrXmlDialog.content
    const blob = new Blob([data], { type: 'text/plain' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'AfrReportXml.txt')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  /**
   * 发送AMS
   */
  async sendAMS(index, type) {
    // 校验AMSCompanyCode 是否为空，为空不允许发送
    if (!this.AMSCompanyCodeFlag) {
      this.$message.warning(this.view.$t('Message.AMSCodeCannotBeNull'))
      return
    }
    // 如果是EF校验MBL NO的长度
    if (this.view.amsInterfaceName === 'eFreight') {
      if (this.view.form.mbl && this.view.form.mbl.length > 16) {
        this.$message.warning(this.view.$t('Message.MblNoIsOverLength'))
        return
      }
      let houseNo = this.view.form.hblNbr2
      if (houseNo) {
        const nvoccScac = this.view.form.nvoccScac
        if (nvoccScac && houseNo.startsWith(nvoccScac)) {
          houseNo = houseNo.substring(nvoccScac.length)
        }
      }
      if (houseNo && houseNo.length > 12) {
        this.$message.warning(this.view.$t('Message.AmsNoIsOverLength'))
        return
      }
    }
    if (this.form) {
      const amsInterfaceName = this.config.get('AMSInterfaceName')
      if (type === 'AMS' && (amsInterfaceName === 'tradetech' || amsInterfaceName === 'eFreight' || amsInterfaceName === 'decarts')) {
        if (this.form.voyageFlight && this.form.voyageFlight.length > 5) {
          this.$message.warning(this.view.$t('CargoMsg.Cargo_VoyageFlightLengthTooltip'))
          return
        }
      }
      // 如果接收方是eFreight，则校验分单号不能超过12位
      if (this.config.get('AMSInterfaceName') === 'eFreight' && this.job) {
        const hblCargoDoc = new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.HBL, false)
        if (hblCargoDoc && hblCargoDoc.hblNbr2 && hblCargoDoc.hblNbr2.length > 12) {
          this.$message.warning(this.view.$t('Message.HblNoMoreThanTwelve'))
          return
        }
      }
      // CARGO-8720
      if (this.view.localData.eFreighs != null && this.view.localData.eFreighs.length > 2 && (this.view.form.emainAccount == null || this.view.form.emainAccount.trim() === '')) {
        this.$message.warning(this.view.$t('SeaExport.PleaseSelectAccount'))
        return
      }
      if (Number(this.config.get('AmsOriginAgentCode')) === 1) {
        const d = this.view.$store.getters.currentDept.code
        if (d == null || d === '') {
          this.$message.warning(this.view.$t('SeaExport.PleaseOfYourCurrentFirst'))
          return
        }
      }
      const addressForm = this.form.afrAddress[0]
      if (['eFreight', 'tradetech', 'decarts'].indexOf(this.view.amsInterfaceName) !== -1) {
        if ((['US', 'CA'].indexOf(addressForm.notifyCountry.toUpperCase()) !== -1 && !addressForm.notifyPostalcode) ||
        (['US', 'CA'].indexOf(addressForm.consigneeCountry.toUpperCase()) !== -1 && !addressForm.consigneePostalcode) ||
        (['US', 'CA'].indexOf(addressForm.shipperCountry.toUpperCase()) !== -1 && !addressForm.shipperPostalcode)) {
          this.$message.warning(this.view.$t('SeaExport.PleaseZipForSend'))
          return
        }
      }
      if (this.view.form.packing === '') {
        this.$message.warning(this.view.$t('Message.UnitTypeNotNull'))
        return
      }
      if (this.view.amsInterfaceName === 'tradetech' && this.view.form.frob === 'F' && !this.view.form.etaFirstPortOfCall) {
        this.$message.warning(this.view.$t('SeaExport.ETAFirstPortOfCallNotNull'))
        return
      }
      if (addressForm) {
        const nameMaxChar = this.view.activeTabName !== 'eManifest' && this.view.amsInterfaceName !== 'eFreight' ? 35 : 70
        const addrMaxChar = this.view.activeTabName !== 'eManifest' && this.view.amsInterfaceName !== 'eFreight' ? 35 : 50
        if (!this.checkIsOverLength(addressForm.shipperLine1, 'Shipper Name', nameMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.shipperLine3, 'Shipper Address1', addrMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.shipperLine4, 'Shipper Address2', addrMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.consigneeLine1, 'Consignee Name', nameMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.consigneeLine3, 'Consignee Address1', addrMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.consigneeLine4, 'Consignee Address2', addrMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.notifyLine1, 'NotifyParty Name', nameMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.notifyLine3, 'NotifyParty Address1', addrMaxChar)) {
          return
        }
        if (!this.checkIsOverLength(addressForm.notifyLine4, 'NotifyParty Address2', addrMaxChar)) {
          return
        }
      }
      const isTradetech = (this.config.get('AMSInterfaceName') === 'tradetech')
      // CARGO-32892 企泰AMS报文调整：【企泰反恐舱单】报文需要对 【反恐舱单-AMS NO】字符数量限制
      if (isTradetech && type === 'AMS') {
        if (this.form.hblNbr2 && this.form.hblNbr2.length > 12) {
          const isOk = await this.view.$confirm(this.view.$t('CargoMsg.Cargo_AmsNoLengthTooltip'), this.view.$t('common.tips.prompt'), {
            confirmButtonText: this.view.$t('common.btn.ok'),
            cancelButtonText: this.view.$t('common.btn.cancel'),
            type: 'info'
          }).then(() => true).catch(() => false)
          if (!isOk) {
            return
          }
        }
        if (this.form.voyageFlight) {
          // if (this.form.voyageFlight.length > 5) {
          //   const isOk = await this.view.$confirm(this.view.$t('CargoMsg.Cargo_VoyageFlightLengthTooltip'), this.view.$t('common.tips.prompt'), {
          //     confirmButtonText: this.view.$t('common.btn.ok'),
          //     cancelButtonText: this.view.$t('common.btn.cancel'),
          //     type: 'info'
          //   }).then(() => true).catch(() => false)
          //   if (!isOk) {
          //     return
          //   }
          // }
          const specialChars = '`!@#$%^&*()_+-=[]{};\':"\\|,.<>\/?~'
          if (Array.from(specialChars).find(item => this.form.voyageFlight.indexOf(item) !== -1)) {
            const isOk = await this.view.$confirm(this.view.$t('CargoMsg.Cargo_VoyageFlightSpecialCharactersTooltip'), this.view.$t('common.tips.prompt'), {
              confirmButtonText: this.view.$t('common.btn.ok'),
              cancelButtonText: this.view.$t('common.btn.cancel'),
              type: 'info'
            }).then(() => true).catch(() => false)
            if (!isOk) {
              return
            }
          }
        }
      }
      // CARGO-33651 利通 反恐舱单-企泰报文取值修改
      if (isTradetech && this.form.freightTermHBL) {
        if (this.form.freightTermHBL === SystemConstants.DOOR_DOOR.code && (!this.form.dispatchingPlaceCode || !this.form.destinationPortCode)) {
          this.$message.warning(this.view.$t('CargoMsg.Cargo_CheckFreightTermOne', [SystemConstants.DOOR_DOOR.chineseName, 'Place of Receipt', 'Place of Delivery']))
          return
        }
        if ((this.form.freightTermHBL === SystemConstants.CY_DOOR.code || this.form.freightTermHBL === SystemConstants.CFS_DOOR.code) && !this.form.destinationPortCode) {
          this.$message.warning(this.view.$t('CargoMsg.Cargo_CheckFreightTermTwo', ['-/DOOR', 'Place of Delivery']))
          return
        }
        if ((this.form.freightTermHBL === SystemConstants.DOOR_CFS.code || this.form.freightTermHBL === SystemConstants.DOOR_CY.code) && !this.form.dispatchingPlaceCode) {
          this.$message.warning(this.view.$t('CargoMsg.Cargo_CheckFreightTermTwo', ['DOOR/-', 'Place of Receipt']))
          return
        }
      }
      // [2, 3, 4]表示AMS Delete
      if (this.view.isTradetech && [2, 3, 4].indexOf(index) !== -1) {
        if (this.amsDataList && this.amsDataList.length > 0) {
          const ams = this.amsDataList.find(p => p.hblNbr2 === this.form.hblNbr2)
          // ['Accepted', '1Y', '3Z']表示已接受的状态
          if (ams && ['ACCEPTED', '1Y', '3Z'].indexOf(ams.tradetechAmsReceiptStatus) === -1) {
            this.$message.warning(this.view.$t('SeaExport.AMSDeleteTips'))
            return
          }
        }
      }
      const loading = getLoading()
      const params = {}
      params.key = this.form.uuid
      params.amsCheck = this.view.amsCheck
      params.currentOfficeId = this.view.$store.getters.currentOfficeId
      params.currentDepartmentCode = this.view.$store.getters.currentDept.code
      params.index = index
      params.jobNo = this.view.job.jobNo
      params.sendType = this.getSendType()
      seaCargoDocApi.getAMS(params).then(resp => {
        if (resp.data) {
          if (resp.data.isSuccess) {
            this.view.amsXmlDialog.visible = true
            this.view.amsXmlDialog.content = resp.data.text || ''
          } else {
            const text = resp.data.text
            if (text && text.indexOf('\n') !== -1) {
              const textArr = text.split('\n')
              this.$message.warning({ dangerouslyUseHTMLString: true, message: textArr.join(' <br/> ') })
            } else {
              this.$message.warning(text)
            }
          }
        }
      }).finally(() => {
        loading.close()
      })
    } else {
      this.$message.warning(this.view.$t('Message.PleaseSelectTheAMSNO'))
    }
  }

  async linkSendAms(index) {
    // 发送前的校验
    if (!this.linkAmsCheck()) {
      return
    }
    // 校验是否开通计费
    let bsData
    await checkBsItemOpened(SystemConstants.TYPE_AMS).then(res => {
      bsData = res.data
    })
    if (!bsData || bsData === -1) {
      // 未开通
      this.$message.warning(this.view.$t('CargoMsg.Cargo_UnopenedService'))
      return
    } else if (bsData <= 0) {
      // 余额不足
      this.$message.warning(this.view.$t('CargoMsg.Cargo_CustomsActivatedTip2'))
      return
    }
    const loading = getLoading()
    const params = {}
    params.key = this.form.uuid
    params.amsCheck = this.view.amsCheck
    params.currentOfficeId = this.view.$store.getters.currentOfficeId
    params.currentDepartmentCode = this.view.$store.getters.currentDept.code
    params.index = index
    params.jobNo = this.view.job.jobNo
    params.sendType = this.getSendType()
    seaCargoDocApi.getAMS(params).then(resp => {
      if (resp.data.isSuccess) {
        this.$message.success(this.view.$t('CargoMsg.Cargo_SendSuccess'))
        this.loadSendStatus()
      } else {
        if (resp.data.data) {
          let message = resp.data.data.replaceAll('\\r\\n', '<br>')
          if (message === 'Pending status prohibits transmission.') {
            message = this.view.$t('SeaExport.LinkSendAmsError')
          }
          this.$message.error({ dangerouslyUseHTMLString: true, message: message })
        } else {
          this.$message.error(this.view.$t('SeaExport.sendFailed'))
        }
      }
    }).finally(() => {
      loading.close()
    })
  }
  /**
   * 劲升发送AMS
   */
  jsSendAMS(index) {
    const loading = getLoading()
    if (this.jsAmsCheck()) {
      const params = this.form
      params.containers = this.view.container.rowData
      params.txtCarrierScAc = this.view.localData.txtCarrierScAc
      params.jobUuid = this.view.job.uuid
      params.jobNo = this.view.job.jobNo
      params.seDocUuid = this.form.uuid
      params.tenantId = this.form.tenantId
      // 0原始 1更正 1删除
      params.actionCode = index
      // 劲升通道发送AMS
      seaCargoDocApi.jsSendAms(params).then(res => {
        if (res.ok) {
          if (res.data === 'success') {
            this.$message.success(this.view.$t('SeaExport.SentSuccessfully'))
            // 刷新 Others 提单状态
            seaCargoDocApi.querySendStatus({ jobUuid: this.view.job.uuid }).then(async resp => {
              await this.querySendStatusResultHandler(resp)
            })
          } else if (res.data === 'waiting receipt') {
            this.$message.error(this.view.$t('SeaExport.WaitingReceipt'))
          } else if (res.data === 'not operable') {
            this.$message.error(this.view.$t('SeaExport.NotOperable'))
          } else {
            this.$message.error(this.view.$t('SeaExport.sendFailed'))
          }
        }
      }).finally(() => {
        loading.close()
      })
    } else {
      loading.close()
    }
  }
  /**
   * 劲升发送ACI
   */
  jsSendACI(index) {
    const loading = getLoading()
    if (this.jsAciCheck()) {
      const params = this.form
      params.containers = this.view.container.rowData
      params.jobUuid = this.view.job.uuid
      params.jobNo = this.view.job.jobNo
      params.afrAddressList = params.afrAddress
      // 发送类型
      params.messageFunction = index
      // 劲升通道发送ACI
      seaCargoDocApi.jsSendAci(params).then(res => {
        if (res.ok) {
          if (res.data === 'success') {
            this.$message.success(this.view.$t('SeaExport.SentSuccessfully'))
            // 刷新 Others 提单状态
            seaCargoDocApi.querySendStatus({ jobUuid: this.view.job.uuid }).then(async resp => {
              await this.querySendStatusResultHandler(resp)
            })
          } else if (res.data === 'error') {
            this.$message.error(this.view.$t('SeaExport.sendFailed'))
          } else if (res.data === 'waiting receipt') {
            this.$message.error(this.view.$t('SeaExport.WaitingReceipt'))
          } else if (res.data === 'not operable') {
            this.$message.error(this.view.$t('SeaExport.NotOperable'))
          } else {
            // this.$message.error(this.view.$t('SeaExport.sendFailed'))
            this.view.$refs['aci'].openCheckTip(res.data)
          }
        }
      }).finally(() => {
        loading.close()
      })
    } else {
      loading.close()
    }
  }

  toJsSendAFR(index) {
    if (index === 0 || index === 1 || index === 5) {
      this.jsSendAFR(index)
    } else if (index === 2) {
      this.view.jsAfrDeleteDialog.visible = true
    }
  }

  /**
   * 发送 Other 类型反恐舱单
   */
  toSendOther(type, index) {
    if (type === 'AFR') {
      this.view.globalVar.ediType = EdiType.AFR_EDI_TYPE.code
    } else if (type === 'ENS') {
      this.view.globalVar.ediType = EdiType.ENS_OTHER.code
    } else if (type === 'EF') {
      this.view.globalVar.ediType = EdiType.E_MANIFEST.code
    } else if (type === 'AMS') {
      this.view.globalVar.ediType = EdiType.AMS.code
    } else if (type === 'ACI') {
      this.view.globalVar.ediType = EdiType.ACI.code
    } else if (type === 'ISF') {
      this.view.globalVar.ediType = EdiType.ISF.code
    } else {
      return
    }
    const loading = getLoading()
    this.view.selectorDialog.title = type
    this.view.selectorDialog.visible = true
    this.view.globalVar.editStatus = index
    getEDITemplate({ templateType: this.view.globalVar.ediType }).then(result => {
      this.view.selectorDialog.rowData = result.data
      this.view.selectorDialog.title = type
      this.view.selectorDialog.visible = true
    }).finally(() => {
      loading.close()
    })
  }

  /**
   * 劲升发送AFR
   */
  jsSendAFR(index) {
    const loading = getLoading()
    if (this.jsAfrCheck()) {
      const params = this.afrForm
      params.containers = this.view.afrContainer.rowData
      params.txtCarrierScAc = this.view.localData.afrCarrierScAc
      params.jobUuid = this.view.job.uuid
      params.afrAddressList = params.afrAddress
      params.jobNo = this.view.job.jobNo
      if (index === 2) {
        params.deletionCode = this.view.jsAfrDeleteDialog.deletionCode
        params.deletionReason = this.view.jsAfrDeleteDialog.deletionReason
      }
      // 晚申按原始类型算
      if (index === 5) {
        params.functionTypeCode = 0
        params.lateApplication = true
      } else {
        params.functionTypeCode = index
      }
      seaCargoDocApi.jsSendAfr(params).then(res => {
        if (res.ok) {
          if (res.data === 'success') {
            this.$message.success(this.view.$t('SeaExport.SentSuccessfully'))
            // 刷新 Others 提单状态
            seaCargoDocApi.querySendStatus({ jobUuid: this.view.job.uuid }).then(async resp => {
              await this.querySendStatusResultHandler(resp)
            })
          } else if (res.data === 'error') {
            this.$message.error(this.view.$t('SeaExport.sendFailed'))
          } else if (res.data === 'not operable') {
            this.$message.error(this.view.$t('SeaExport.NotOperable'))
          } else {
            // this.$message.error(this.view.$t('SeaExport.sendFailed'))
            this.view.$refs['afr'].openCheckTip(res.data)
          }
        }
      }).finally(() => {
        loading.close()
      })
    } else {
      loading.close()
    }
    this.view.jsAfrDeleteDialog.deletionCode = '1'
  }
  /**
   * 劲升发送AMS字段校验
   */
  jsAmsCheck() {
    const checkList = []
    if (!this.form.hblNbr2) {
      checkList.push({ field: 'AMS NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.vessel) {
      checkList.push({ field: 'Vessel', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.voyageFlight) {
      checkList.push({ field: 'Voyage', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.eta) {
      checkList.push({ field: 'ETA', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.view.localData.txtCarrierScAc) {
      checkList.push({ field: 'Carrier SCAC', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPortCode) {
      checkList.push({ field: 'Place of Loading', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.loadingPort) {
      checkList.push({ field: 'Place of Loading Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.dischargingPortCode) {
      checkList.push({ field: 'Place of Discharge', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.lastAbroadProd) {
      checkList.push({ field: 'Last Foreign Port', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.quantity) {
      checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.packing) {
      checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.weight) {
      checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.cubage) {
      checkList.push({ field: 'Volume', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // ams 收发通地址信息
    if (this.form.afrAddress && this.form.afrAddress.length > 0) {
      const address = this.form.afrAddress[0]
      if (!address.shipperLine1) {
        checkList.push({ field: 'Shipper Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperLine3) {
        checkList.push({ field: 'Shipper Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeLine1) {
        checkList.push({ field: 'Consignee Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeLine3) {
        checkList.push({ field: 'Consignee Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyLine1) {
        checkList.push({ field: 'Notify Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyLine3) {
        checkList.push({ field: 'Notify Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
    } else {
      checkList.push({ field: 'Customer Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (!this.form.nationalityCodeofVessel) {
      checkList.push({ field: 'Vessel country flag', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.nvoccScac) {
      checkList.push({ field: 'Nvocc SCAC', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.frob) {
      checkList.push({ field: 'Declare Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.paperlessInBondParticipant) {
      checkList.push({ field: 'paperless_in_bond_participant', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // goodsType等于1时为危险品才校验一下必填字段
    if (this.form.goodsType === 1 && !this.form.hazardousCode) {
      checkList.push({ field: 'Hazardous code', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (this.form.goodsType === 1 && !this.form.flashPointTemp) {
      checkList.push({ field: 'Flashpoint', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 装箱信息数据
    if (this.view.container.rowData && this.view.container.rowData.length > 0) {
      for (const container of this.view.container.rowData) {
        if (!container.eqSize && !checkList.some(obj => obj.field === 'Container Size')) {
          checkList.push({ field: 'Container Size', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.sealNo || container.sealNo.length <= 2 && !checkList.some(obj => obj.field === 'Seal No')) {
          checkList.push({ field: 'Seal No', errorDescription: this.view.$t('SeaExport.InputTwoAbove') })
        }
        if (!container.eqType && !checkList.some(obj => obj.field === 'Container Type')) {
          checkList.push({ field: 'Container Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.cargoName && !checkList.some(obj => obj.field === 'Goods')) {
          checkList.push({ field: 'Goods', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.mark && !checkList.some(obj => obj.field === 'Marks')) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.quantity && !checkList.some(obj => obj.field === 'Quantity')) {
          checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.containerNo && !checkList.some(obj => obj.field === 'Container No')) {
          checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.packing && !checkList.some(obj => obj.field === 'Unit Type')) {
          checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.weight && !checkList.some(obj => obj.field === 'Gross Weight')) {
          checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.cubage && !checkList.some(obj => obj.field === 'Volume')) {
          checkList.push({ field: 'Volume', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    } else {
      checkList.push({ field: 'Container Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (checkList.length > 0) {
      this.view.$refs['ams'].openCheckTip(checkList)
      return false
    }
    return true
  }

  /**
   * 劲升发送ACI字段校验
   */
  jsAciCheck() {
    const checkList = []
    if (!this.form.hblNbr2) {
      checkList.push({ field: 'ACI NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.voyageFlight) {
      checkList.push({ field: 'Voyage', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.dischargingPort) {
      checkList.push({ field: 'Place of Discharge Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.cargoDestinationCountry) {
      checkList.push({ field: 'DestinationCountry', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.cargoDestinationCity) {
      checkList.push({ field: 'DestinationCity', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.cargoEnglishName) {
      checkList.push({ field: 'Commodity Decription', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.frob) {
      checkList.push({ field: 'Declare Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.form.efNvoccScac) {
      checkList.push({ field: 'Nvocc SCAC', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // aci 收发通地址信息
    if (this.form.afrAddress && this.form.afrAddress.length > 0) {
      const address = this.form.afrAddress[0]
      // 收发通信息
      if (!address.shipperLine1) {
        checkList.push({ field: 'Shipper Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperLine3) {
        checkList.push({ field: 'Shipper Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperCountry) {
        checkList.push({ field: 'Shipper Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 国家非US、CA不传输字段State
      if ((address.shipperCountry === 'US' || address.shipperCountry === 'US') && !address.shipperProvince) {
        checkList.push({ field: 'Shipper State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperCity) {
        checkList.push({ field: 'Shipper City', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperPostalcode && (address.shipperCountry === 'CA' || address.shipperCountry === 'US')) {
        checkList.push({ field: 'Shipper Zip', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeLine1) {
        checkList.push({ field: 'Consignee Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeLine3) {
        checkList.push({ field: 'Consignee Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeCountry) {
        checkList.push({ field: 'Consignee Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 国家非US、CA不传输字段State
      if ((address.consigneeCountry === 'US' || address.consigneeCountry === 'US') && !address.consigneeProvince) {
        checkList.push({ field: 'Consignee State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeCity) {
        checkList.push({ field: 'Consignee City', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneePostalcode && (address.consigneeCountry === 'CA' || address.consigneeCountry === 'US')) {
        checkList.push({ field: 'Consignee Zip', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyLine1) {
        checkList.push({ field: 'Notify Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyLine3) {
        checkList.push({ field: 'Notify Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyCountry) {
        checkList.push({ field: 'Notify Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      // 国家非US、CA不传输字段State
      if ((address.notifyCountry === 'US' || address.notifyCountry === 'US') && !address.notifyProvince) {
        checkList.push({ field: 'Notify State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyCity) {
        checkList.push({ field: 'Notify City', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyPostalcode && (address.notifyCountry === 'CA' || address.notifyCountry === 'US')) {
        checkList.push({ field: 'Notify Zip', errorDescription: this.view.$t('SeaExport.Required') })
      }
    } else {
      checkList.push({ field: 'Customer Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // goodsType等于1时为危险品才校验一下必填字段
    if (this.form.goodsType === 1 && !this.form.undgCode) {
      checkList.push({ field: 'Hazardous code', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 装箱信息数据
    if (this.view.container.rowData && this.view.container.rowData.length > 0) {
      for (const container of this.view.container.rowData) {
        if (!container.mark && !checkList.some(obj => obj.field === 'Marks')) {
          checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.quantity && !checkList.some(obj => obj.field === 'Quantity')) {
          checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.containerNo && !checkList.some(obj => obj.field === 'Container No')) {
          checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.packing && !checkList.some(obj => obj.field === 'Unit Type')) {
          checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.weight && !checkList.some(obj => obj.field === 'Gross Weight')) {
          checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.cubage && !checkList.some(obj => obj.field === 'Volume')) {
          checkList.push({ field: 'Volume', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    } else {
      checkList.push({ field: 'Container Information', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (checkList.length > 0) {
      this.view.$refs['aci'].openCheckTip(checkList)
      return false
    }
    return true
  }

  /**
   * 劲升发送AFR字段校验
   */
  jsAfrCheck() {
    const checkList = []
    if (!this.afrForm.nvoccScac) {
      checkList.push({ field: 'Nvocc SCAC', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.reporterID) {
      checkList.push({ field: 'Sender Account', errorDescription: this.view.$t('SeaExport.AccountIsNotNull') })
    }
    if (!this.afrForm.reporterPassword) {
      checkList.push({ field: 'Sender Account Password', errorDescription: this.view.$t('SeaExport.PasswordIsNotNull') })
    }
    if (!this.afrForm.hblNbr2) {
      checkList.push({ field: 'HBL NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.mbl) {
      checkList.push({ field: 'MB/L NO', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.vessel) {
      checkList.push({ field: 'Vessel', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.vesselCode) {
      checkList.push({ field: 'Vessel Code', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.voyageFlight) {
      checkList.push({ field: 'Voyage', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.nationalityCodeofVessel) {
      checkList.push({ field: 'Vessel country flag', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.view.localData.txtCarrierScAc) {
      checkList.push({ field: 'Carrier SCAC', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.etd) {
      checkList.push({ field: 'ETD', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.eta) {
      checkList.push({ field: 'ETA', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.loadingPortCode) {
      checkList.push({ field: 'Place of Loading', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.loadingPort) {
      checkList.push({ field: 'Place of Loading Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.dischargingPortCode) {
      checkList.push({ field: 'Place of Discharge', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.destinationPortCode) {
      checkList.push({ field: 'Place of Delivery', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.destinationPort) {
      checkList.push({ field: 'Place of Delivery Name', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.countryOrigin) {
      checkList.push({ field: 'County of Origin', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.quantity) {
      checkList.push({ field: 'Quantity', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.packing) {
      checkList.push({ field: 'Unit Type', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.weight) {
      checkList.push({ field: 'Gross Weight', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.cubage) {
      checkList.push({ field: 'Volume', errorDescription: this.view.$t('SeaExport.Required') })
    }
    // goodsType等于1时为危险品才校验一下必填字段
    if (this.afrForm.goodsType === 1) {
      if (!this.afrForm.hazardousCode) {
        checkList.push({ field: 'Hazardous code', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!this.afrForm.imdgClass) {
        checkList.push({ field: 'IMDG Class', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!this.afrForm.unNo) {
        checkList.push({ field: 'UN No', errorDescription: this.view.$t('SeaExport.Required') })
      }
    }
    if (!this.afrForm.cargoEnglishName) {
      checkList.push({ field: 'Commodity Decription', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (!this.afrForm.mark) {
      checkList.push({ field: 'Marks', errorDescription: this.view.$t('SeaExport.Required') })
    }

    if (this.afrForm.afrAddress && this.afrForm.afrAddress.length > 0) {
      const address = this.afrForm.afrAddress[0]
      // 收发通信息
      if (!address.shipperLine1) {
        checkList.push({ field: 'Shipper Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperLine3) {
        checkList.push({ field: 'Shipper Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperCountry) {
        checkList.push({ field: 'Shipper Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperCity) {
        checkList.push({ field: 'Shipper City', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.shipperCountry !== 'CN' && !address.shipperProvince) {
        checkList.push({ field: 'Shipper State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperPostalcode) {
        checkList.push({ field: 'Shipper Zip', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.shipperTel) {
        checkList.push({ field: 'Shipper Tel', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeLine1) {
        checkList.push({ field: 'Consignee Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeLine3) {
        checkList.push({ field: 'Consignee Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeCountry) {
        checkList.push({ field: 'Consignee Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeCity) {
        checkList.push({ field: 'Consignee City', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.consigneeCountry !== 'CN' && !address.consigneeProvince) {
        checkList.push({ field: 'Consignee State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneePostalcode) {
        checkList.push({ field: 'Consignee Zip', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.consigneeTel) {
        checkList.push({ field: 'Consignee Tel', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyLine1) {
        checkList.push({ field: 'Notify Name', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyLine3) {
        checkList.push({ field: 'Notify Address1', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyCountry) {
        checkList.push({ field: 'Notify Country', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyCity) {
        checkList.push({ field: 'Notify City', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (address.notifyCountry !== 'CN' && !address.notifyProvince) {
        checkList.push({ field: 'Notify State', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyPostalcode) {
        checkList.push({ field: 'Notify Zip', errorDescription: this.view.$t('SeaExport.Required') })
      }
      if (!address.notifyTel) {
        checkList.push({ field: 'Notify Tel', errorDescription: this.view.$t('SeaExport.Required') })
      }
    } else {
      checkList.push({ field: 'Customer Information', errorDescription: this.view.$t('SeaExport.Required') })
    }

    // 装箱信息数据
    if (this.view.afrContainer.rowData && this.view.afrContainer.rowData.length > 0) {
      for (const container of this.view.afrContainer.rowData) {
        if (!container.eqSize && !checkList.some(obj => obj.field === 'Container Size')) {
          checkList.push({ field: 'Container Size', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.eqHeight && !checkList.some(obj => obj.field === 'Container Height')) {
          checkList.push({ field: 'Container Height', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.eqType && !checkList.some(obj => obj.field === 'Container Type')) {
          checkList.push({ field: 'Container Type', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.containerNo && !checkList.some(obj => obj.field === 'Container No')) {
          checkList.push({ field: 'Container No', errorDescription: this.view.$t('SeaExport.Required') })
        }
        if (!container.containerOwnershipCode && !checkList.some(obj => obj.field === 'Container Owner')) {
          checkList.push({ field: 'Container Owner', errorDescription: this.view.$t('SeaExport.Required') })
        }
      }
    } else {
      checkList.push({ field: 'House Container Information', errorDescription: this.view.$t('SeaExport.Required') })
    }
    if (checkList.length > 0) {
      this.view.$refs['afr'].openCheckTip(checkList)
      return false
    }
    return true
  }
  /**
   * 验证字符数超长
   * @param name
   * @param num
   * @returns {boolean}
   */
  checkIsOverLength(field, name, num) {
    if (field && field.length > num) {
      this.$message.warning(this.view.$t('Message.IsOverLengthTip', [name, num]))
      return false
    }
    return true
  }
  getSendType() {
    switch (this.view.activeTabName) {
      case 'ams':
        return 'SendAMS'
      case 'isf':
        return 'SendISF'
      case 'aci':
        return 'SendACI'
      case 'eManifest':
        return 'SendEF'
      case 'afr':
        return 'SendAFR'
      case 'ens':
        return 'SendENS'
    }
  }
  sendeAMSResultHandler(resp) {
    const result = resp.data
    if (result === '' || result === 'SUCCESS') {
      this.$message.success(this.view.$t('Message.SuccessfullySent'))
    } else if (result === 'FAILED') {
      this.$message.error(this.view.$t('Message.SendFailed'))
    } else {
      this.$message({
        duration: 3000,
        dangerouslyUseHTMLString: true,
        message: result.replaceAll('\n', '<br /><br />'),
        type: 'error'
      })
    }
    const loading = getLoading()
    this.view.onShow(this.job, true).finally(() => loading.close())
    // seaCargoDocApi.querySendStatus({ jobNo: this.view.job.jobNo }).then(resp => {
    //   this.querySendStatusResultHandler(resp)
    // })
  }
  async querySendStatusResultHandler(resp) {
    const amsDataList = []
    const afrDataList = []
    let seaCargoMap = {}
    let lclSlavesMap = {}
    if (this.job.masterFlag) {
      lclSlavesMap = this.job.lclSlaves.reduce((acc, cur) => {
        acc[cur.uuid] = cur.jobNo
        return acc
      }, {})
      const jobUuidList = this.job.lclSlaves.map(p => p.uuid)
      jobUuidList.push(this.job.uuid)
      await loadLclJobSeaCargoDocList(jobUuidList).then(resp => {
        let seaCargoDoc = resp.data || []
        seaCargoDoc = seaCargoDoc.filter(item => item.docType === CargoDocConsts.HBL || item.docType === CargoDocConsts.HBL2)
        seaCargoMap = seaCargoDoc.reduce((acc, cur) => {
          acc[cur.hblNbr2] = cur.jobUuid
          return acc
        }, {})
      })
    }
    for (const item of resp.data) {
      if (item.docType === 'AMS') {
        amsDataList.push(item)
      } else if (item.docType === 'AFR') {
        if (!this.view.afrIsLink && this.afrCargoDocs && this.afrCargoDocs.length > 0) {
          const afr = this.afrCargoDocs.find(afr => afr.hblNbr2 === item.hblNbr2)
          if (afr) {
            if (this.job.masterFlag) {
              if (seaCargoMap[afr.hblNbr2]) {
                item.jobNo = lclSlavesMap[seaCargoMap[afr.hblNbr2]]
              }
            }
            if (!item.jobNo) {
              item.jobNo = this.job.jobNo
            }
            item.afrLast = afr.afrLast
            item.afrReceiptStatus = afr.afrReceiptStatus
          }
        }
        afrDataList.push(item)
      }
    }
    if (resp.data && resp.data.length > 0) {
      this.job.afrSendState = resp.data[0].afrSendState
    }
    this.amsDataList = amsDataList
    this.view.ams2.rowData = this.amsDataList
    this.afrDataList = afrDataList
    this.view.afr2.rowData = this.afrDataList
  }
  /**
   * 发送ISF
   */
  sendISF(isfType, index) {
    const doc = this.view.form
    if (doc) {
      let flag = (isfType === 10) ? this.checkIsf10Model() : this.checkIsf05Model()
      if (Number(this.config.get('AmsOriginAgentCode')) === 1) {
        const d = this.view.$store.getters.currentDept.code
        if (flag && (d == null || d === '')) {
          this.$message.info(this.view.$t('SeaExport.PleaseOfYourCurrentFirst'))
          flag = false
        }
      }
      if (flag) {
        const amsCheck = this.view.amsCheck
        const params = {}
        params.key = this.form.uuid
        params.amsCheck = amsCheck
        params.currentOfficeId = this.view.$store.getters.currentOfficeId
        params.currentDepartmentCode = this.view.$store.getters.currentDept.code
        params.index = index
        params.jobNo = this.view.job.jobNo
        params.isfType = isfType
        const loading = getLoading()
        seaCargoDocApi.sendISF(params).then(resp => {
          loading.close()
          this.sendeAMSResultHandler(resp)
        }).finally(() => loading.close())
      }
    } else {
      this.$message.info(this.view.$t('Message.PleaseSelectTheAMSNO'))
    }
  }
  // 校验 ISF 10 数据
  checkIsf10Model() {
    if (StrUtils.isEmpty(this.form.hblNbr2)) {
      this.$message.warning(this.view.$t('SeaExport.CustomerNumberCannotBeEmpty'))
      return false
    }
    if (StrUtils.isEmpty(this.form.mbl)) {
      this.$message.warning(this.view.$t('SeaExport.CustomerNOCannotBeEmpty'))
      return false
    }
    return true
  }
  checkIsf05Model() {
    if (StrUtils.isEmpty(this.form.hblNbr2)) {
      this.view.$message.warning(this.view.$t('SeaExport.CustomerNumberCannotBeEmpty'))
      return false
    }
    if (StrUtils.isEmpty(this.form.mbl)) {
      this.view.$message.warning(this.view.$t('SeaExport.CustomerNOCannotBeEmpty'))
      return false
    }
    if (StrUtils.isEmpty(this.form.dischargingPort)) {
      this.view.$message.warning(this.view.$t('SeaExport.CustomerPortCannotBeEmpty'))
      return false
    }
    if (StrUtils.isEmpty(this.form.destinationPort)) {
      this.view.$message.warning(this.view.$t('SeaExport.CustomerDeliveryCannotBeEmpty'))
      return false
    }
    return true
  }
  /**
   * 查询发送AMS状态
   */
  queryAMS() {
    if (this.view.tabAfr) {
      this.$message.info(this.view.$t('SeaExport.stayTuned'))
      return
    }
    const amsCode = this.config.get('AMSCompanyCode')
    const appKey = this.config.get('eFreightAppKey')
    const doc = this.form
    if (doc) {
      let url
      const type = this.form.AMSType
      const isAms = this.view.activeTabName === 'ams' || this.view.activeTabName === 'isf'
      const scac = isAms ? doc.nvoccScac : doc.efNvoccScac
      if (type === 2) {
        url = 'http://edi.gsf24.cn/aci.aspx?CustomerCode=' + amsCode + '&scac=' + scac + '&AppKey=' + appKey + '&hbl=' + doc.hblNbr2
      } else {
        url = 'http://edi.gsf24.cn/ams.aspx?CustomerCode=' + amsCode + '&scac=' + scac + '&AppKey=' + appKey + '&hbl=' + doc.hblNbr2
      }
      window.open(url)
    } else {
      this.$message.info(this.$t('Message.PleaseSelectTheAMSNO'))
    }
  }
  /**
   * 查看AMS日志记录
   */
  queryAMSLogClickHandler() {
    const doc = this.form
    if (doc && doc.hblNbr2) {
      ediApi.queryAMSLogByAmsNo({ amsNo: doc.hblNbr2 }).then(res => {
        this.view.amsLogViewTitleDialog.rowData = res.data
        this.view.amsLogViewTitleDialog.visible = true
      })
    } else {
      this.$message.info(this.view.$t('Message.PleaseSelectTheAMSNO'))
    }
  }
  /**
   * 查看AMS回执信息
   */
  queryAMSReceiptInfoClickHandler() {
    if (this.view.isJs) {
      if (this.view.tabAfr) {
        const loading = getLoading()
        seaCargoDocApi.jsViewReceipts({ jobNo: this.job.jobNo, hblNbr2: this.afrForm.hblNbr2, type: 'AFR' }).then(res => {
          this.view.$refs.afr.queryReceipt(res.data)
        }).finally(() => {
          loading.close()
        })
        return
      }
      if (this.view.tabAms) {
        const loading = getLoading()
        seaCargoDocApi.jsViewReceipts({ jobNo: this.job.jobNo, hblNbr2: this.form.hblNbr2, type: 'AMS' }).then(res => {
          this.view.$refs.ams.queryReceipt(res.data)
        }).finally(() => {
          loading.close()
        })
        return
      }
      if (this.view.tabAci) {
        const loading = getLoading()
        seaCargoDocApi.jsViewReceipts({ jobNo: this.job.jobNo, hblNbr2: this.form.hblNbr2, type: 'ACI' }).then(res => {
          this.view.$refs.aci.queryReceipt(res.data)
        }).finally(() => {
          loading.close()
        })
        return
      }
    }
    if (this.view.tabEns) {
      if (this.view.ensIsTradetech) {
        const filter = {
          jobUuid: this.view.job.uuid,
          pageNum: 1,
          pageSize: 10,
          jobNo: this.view.job.jobNo
        }
        const loading = getLoading4Cxt()
        seaCargoDocApi.queryTradetechAMSReceiptInfo(filter).then(res => {
          if (res.data) {
            this.view.tradetechReceiptInfoDialog.rowData = res.data.list
            this.view.tradetechReceiptInfoDialog.filter.total = Number(res.data.total)
            this.view.tradetechReceiptInfoDialog.filter.pageSize = res.data.pageSize
            this.view.tradetechReceiptInfoDialog.filter.pageCount = res.data.pages
            this.view.tradetechReceiptInfoDialog.filter.pageNum = res.data.pageNum
            this.view.tradetechReceiptInfoDialog.visible = true
          }
        }).finally(() => {
          loading.close()
        })
      } else {
        seaCargoDocApi.queryAMSReceiptInfoByAmsNo({ jobUuid: this.job.uuid }).then(res => {
          this.view.receiptInfoDialog.rowData = res.data
          this.view.receiptInfoDialog.visible = true
        })
      }
      return
    }
    if (this.view.tabAfr) {
      this.$message.info(this.view.$t('SeaExport.stayTuned'))
      return
    }
    const doc = this.form
    if (!doc || !doc.hblNbr2) {
      this.$message.info(this.view.$t('Message.PleaseSelectTheAMSNO'))
      return
    }
    if (this.view.isTradetech && this.view.deleteAMS) {
      const filter = {
        jobUuid: this.view.job.uuid,
        pageNum: 1,
        pageSize: 10,
        jobNo: this.view.job.jobNo
      }
      const loading = getLoading4Cxt()
      seaCargoDocApi.queryTradetechAMSReceiptInfo(filter).then(res => {
        if (res.data) {
          this.view.tradetechReceiptInfoDialog.rowData = res.data.list
          this.view.tradetechReceiptInfoDialog.filter.total = Number(res.data.total)
          this.view.tradetechReceiptInfoDialog.filter.pageSize = res.data.pageSize
          this.view.tradetechReceiptInfoDialog.filter.pageCount = res.data.pages
          this.view.tradetechReceiptInfoDialog.filter.pageNum = res.data.pageNum
          this.view.tradetechReceiptInfoDialog.visible = true
        }
      }).finally(() => {
        loading.close()
      })
    } else {
      seaCargoDocApi.queryAMSReceiptInfoByAmsNo({ jobUuid: this.job.uuid }).then(res => {
        this.view.receiptInfoDialog.rowData = res.data
        this.view.receiptInfoDialog.visible = true
      })
    }
  }

  /**
   * 查看劲升AMS校验错误信息
   */
  queryJsAmsErrorMessage() {
    const loading = getLoading()
    seaCargoDocApi.jsAmsValidation({ jobUuid: this.view.job.uuid, hblNbr2: this.form.hblNbr2 }).then(res => {
      if (res.ok) {
        if (res.data === 'success') {
          this.$message.success(this.view.$t('SeaExport.SentSuccessfully'))
        } else if (res.data === 'not sent') {
          this.$message.warning(this.view.$t('SeaExport.NoSendingRecord'))
        } else if (res.data === 'fail') {
          this.$message.error(this.view.$t('SeaExport.GetExceptions'))
        } else {
          this.view.$refs['ams'].openCheckTip(res.data)
        }
      }
    }).finally(() => {
      loading.close()
    })
  }

  tradetechQueryByPage(filter) {
    const loading = getLoading4Cxt()
    seaCargoDocApi.queryTradetechAMSReceiptInfo(filter).then(res => {
      this.view.tradetechReceiptInfoDialog.rowData = res.data.list
      this.view.tradetechReceiptInfoDialog.filter.total = Number(res.data.total)
      this.view.tradetechReceiptInfoDialog.filter.pageSize = res.data.pageSize
      this.view.tradetechReceiptInfoDialog.filter.pageCount = res.data.pages
      this.view.tradetechReceiptInfoDialog.filter.pageNum = res.data.pageNum
    }).finally(() => {
      loading.close()
    })
  }
  getNoTitle(isCn, tabName) {
    if (tabName === 'ams') {
      return isCn ? this.view.$t('SeaExport.AMSNumber') : 'AMS NO'
    }
    if (tabName === 'afr') {
      return isCn ? this.view.$t('SeaExport.AFRNumber') : 'AFR NO'
    }
    if (tabName === 'aci') {
      return isCn ? this.view.$t('SeaExport.ACINumber') : 'ACI NO'
    }
    if (tabName === 'eManifest') {
      return isCn ? this.view.$t('SeaExport.EManifestNumber') : 'eManifest NO'
    }
    if (tabName === 'ens') {
      return isCn ? this.view.$t('SeaExport.ENSNumber') : 'ENS NO'
    }
    return isCn ? this.view.$t('SeaExport.AMSNumber') : 'AMS NO'
  }

  getNoType(tabName) {
    if (tabName === 'ams') {
      return 'AMS'
    }
    if (tabName === 'afr') {
      return 'AFR'
    }
    if (tabName === 'aci') {
      return 'ACI'
    }
    if (tabName === 'eManifest') {
      return 'eManifest'
    }
    if (tabName === 'ens') {
      return 'ENS'
    }
    if (tabName === 'isf') {
      return 'ISF'
    }
    return ''
  }
  /**
   * select
   * 如果 newType 是true 则取非装箱信息页签的 直接取 item 的数据
   */
  async usageSelectCallBackFunc(usages, newType) {
    const seaCargoDoc = await new SeaExportJob(this.job).getCargoDoc()
    const sourceCargoDoc = []
    for (const item of seaCargoDoc) {
      if (!item.hblNbr2 || item.deleted) continue
      if (item.docType === CargoDocConsts.HBL || item.docType === CargoDocConsts.HBL2) {
        sourceCargoDoc.push(item)
      }
    }
    const cargoDoc = sourceCargoDoc.filter(p => p.hblNbr2 === this.form.hblNbr2)
    for (const item of usages) {
      if (!this.existContainerUsage(item, newType)) {
        const ec = new EDIContainer().fillDefaultValue().getData()
        ec.deleted = false
        ec.containerNo = (this.job.masterFlag || newType) ? item.containerNo : item.container.containerNo
        ec.sealNo = (this.job.masterFlag || newType) ? item.sealNo : item.container.sealNo
        ec.eqType = (this.job.masterFlag || newType) ? item.eqType : item.container.eqType
        ec.eqSize = (this.job.masterFlag || newType) ? item.eqSize : item.container.eqSize
        ec.quantity = Number(item.quantity)
        ec.weight = Number(item.weight)
        ec.cubage = Number(item.cubage)
        ec.mark = item.mark
        ec.cargoName = item.cargoName
        ec.cargoDocUuid = this.view.tabAfr ? this.afrForm.uuid : this.form.uuid
        ec.containerUsageUuid = null
        if (this.view.isJs) {
          const activeTabName = this.view.activeTabName
          if (activeTabName === 'ams') {
            if (item.container.eqType === 'RF') {
              ec.eqCode = SystemConstants.JS_AFR_CZ.code
            } else if (item.container.eqType === 'OT' && item.container.eqSize === '20') {
              ec.eqCode = SystemConstants.JS_AFR_20.code
            } else if (item.container.eqType === 'OT' && item.container.eqSize === '40') {
              ec.eqCode = SystemConstants.JS_AFR_40.code
            } else if ((item.container.eqType === 'GP' || item.container.eqType === 'HQ' || item.container.eqType === 'HC') && item.container.eqSize === '20') {
              ec.eqCode = SystemConstants.JS_AFR_2B.code
            } else if ((item.container.eqType === 'GP' || item.container.eqType === 'HQ' || item.container.eqType === 'HC') && item.container.eqSize === '40') {
              ec.eqCode = SystemConstants.JS_AFR_4B.code
            } else {
              ec.eqCode = SystemConstants.JS_AFR_CN.code
            }
            if (item.packing) {
              ec.packing = item.packing
            } else if (cargoDoc) {
              ec.packing = cargoDoc[0].packing
            }
          } else if (activeTabName === 'afr') {
            const tempContainer = this.job.masterFlag ? item : item.container
            if (tempContainer.eqType === 'RF' || tempContainer.eqType === 'REEFER') {
              ec.eqType = SystemConstants.JS_AFR_RT.code
            } else if (tempContainer.eqType === 'OT') {
              ec.eqType = SystemConstants.JS_AFR_UT.code
            } else if (tempContainer.eqType === 'FR') {
              ec.eqType = SystemConstants.JS_AFR_PF.code
            } else if (tempContainer.eqType === 'PC') {
              ec.eqType = SystemConstants.JS_AFR_PL.code
            } else if (tempContainer.eqType === 'TK') {
              ec.eqType = SystemConstants.JS_AFR_TN.code
            } else if (tempContainer.eqType === 'GP' || tempContainer.eqType === 'HC' || tempContainer.eqType === 'HQ') {
              ec.eqType = SystemConstants.JS_AFR_GP.code
            } else {
              ec.eqType = SystemConstants.JS_AFR_SN.code
            }
            let isSoc = item.soc
            if (this.job.masterFlag) {
              isSoc = item.containerAscription && item.containerAscription === SeaExportConstants.CONTAINER_ASCRIPTION_SOC_STATE.code
            }
            if (isSoc) {
              ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_1.code
            } else {
              ec.containerOwnershipCode = SystemConstants.JS_AFR_CONTAINER_OWNER_2.code
            }
            if (tempContainer.eqType === 'HQ' || tempContainer.eqType === 'HC') {
              ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_5.code
            } else {
              ec.eqHeight = SystemConstants.JS_AFR_HEIGHT_2.code
            }
          } else if (activeTabName === 'aci') {
            if (item.packing) {
              ec.packing = item.packing
            } else if (cargoDoc) {
              ec.packing = cargoDoc[0].packing
            }
          }
        }
        if (this.view.tabEns) {
          if (this.view.isNewWindowByENS) {
            // 处理箱号的问题，不满足要进行处理
            if (ec.containerNo) {
              const valueContainerNo = this.ensConvertContainerNoHandler(ec.containerNo)
              if (ec.containerNo !== valueContainerNo) {
                ec.containerNo = valueContainerNo
              }
            }
            if (item.soc) {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_2_AI.code
            } else {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_1_AI.code
            }
          } else {
            if (item.soc) {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_1.code
            } else {
              ec.containerOwnershipCode = SystemConstants.EF_ENS_CONTAINER_OWNER_2.code
            }
          }
          const containerSize = SystemConstants.EF_ENS_CONTAINER_MAP.get(item.container.eqSize + item.container.eqType)
          if (containerSize) {
            ec.eqCode = containerSize
          }
        }
        if (this.view.tabAfr) {
          ec.hsCodeContainer = this.afrForm.hsCode
          this.view.afrContainer.rowData.push(ec)
        } else {
          this.view.container.rowData.push(ec)
        }
      }
    }
    if (this.form.docType === CargoDocConsts.AMS) {
      this.refreshEdiGrid()
    } else if (this.afrForm.docType === CargoDocConsts.AFR) {
      await this.refreshAfrEdiGrid()
    }
  }

  ensConvertContainerNoHandler(value) {
    if (!value) return value
    // 转大写并过滤不合规字符
    let valueContainerNo = value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 11)

    // 检查第4位是否为U
    if (valueContainerNo.length >= 4 && valueContainerNo[3] !== 'U') {
      valueContainerNo = valueContainerNo.slice(0, 3) + 'U' + valueContainerNo.slice(4)
    }

    // 补全或截断到11位
    if (valueContainerNo.length < 11) {
      valueContainerNo = valueContainerNo.padEnd(11, '0')
    } else {
      valueContainerNo = valueContainerNo.slice(0, 11)
    }

    return valueContainerNo
  }

  convertAfrAddressByRule(cargoDoc) {
    if (!cargoDoc || !cargoDoc.afrAddress || !cargoDoc.afrAddress.length) {
      return
    }

    const afrAddress = cargoDoc.afrAddress[0]

    const afrAddressFieldList = ['shipperLine1', 'shipperLine3', 'shipperLine4', 'shipperStreetNo', 'shipperPostalcode', 'shipperCountry', 'shipperCity', 'shipperTel',
      'shipperEmail', 'shipperTypeOfPerson', 'shipperEori', 'consigneeLine1', 'consigneeLine3', 'consigneeLine4', 'consigneeStreetNo', 'consigneePostalcode', 'consigneeCountry',
      'consigneeCity', 'consigneeTel', 'consigneeEmail', 'consigneeTypeOfPerson', 'consigneeEori', 'sellerName', 'sellerAddress1', 'sellerAddress2', 'sellerStreetNo',
      'sellerPostalcode', 'sellerCity', 'sellerCountry', 'sellerTel', 'sellerEmail', 'sellerTypeOfPerson', 'sellerEori', 'buyerName', 'buyerAddress1', 'buyerAddress2',
      'buyerStreetNo', 'buyerPostalcode', 'buyerCountry', 'buyerCity', 'buyerTel', 'buyerEmail', 'buyerContactName', 'buyerTypeOfPerson', 'buyerEori']

    afrAddressFieldList.forEach(item => {
      this.validInput(afrAddress, item)
    })
  }
  validInput(addressForm, field) {
    // 如果字段值为空，直接返回
    if (!addressForm[field]) return

    // 验证规则配置
    const validationRules = {
      // 名称和地址字段规则
      nameAndAddress: {
        fields: [
          'shipperLine1', 'shipperLine3', 'shipperLine4',
          'consigneeLine1', 'consigneeLine3', 'consigneeLine4',
          'sellerName', 'sellerAddress1', 'sellerAddress2',
          'buyerName', 'buyerAddress1', 'buyerAddress2'
        ],
        pattern: /[^a-zA-Z0-9"\-/,: '_"+]/g,
        maxLength: 70,
        transform: value => value
      },

      // 街道号和邮编规则
      streetNoAndPostal: {
        fields: [
          'shipperStreetNo', 'shipperPostalcode',
          'consigneeStreetNo', 'consigneePostalcode',
          'sellerStreetNo', 'sellerPostalcode',
          'buyerStreetNo', 'buyerPostalcode'
        ],
        pattern: /[^A-Z0-9 /-]/g,
        maxLength: 10,
        transform: value => value.toUpperCase()
      },

      // 城市规则
      city: {
        fields: [
          'shipperCity', 'consigneeCity',
          'sellerCity', 'buyerCity'
        ],
        pattern: /[^A-Z0-9 /-]/g,
        maxLength: 35,
        transform: value => value.toUpperCase()
      },

      // 电话规则
      telephone: {
        fields: [
          'shipperTel', 'consigneeTel',
          'sellerTel', 'buyerTel'
        ],
        pattern: /[^+\d \-]/g,
        transform: value => value
      },

      // 邮箱规则
      email: {
        fields: [
          'shipperEmail', 'consigneeEmail',
          'sellerEmail', 'buyerEmail'
        ],
        pattern: /[^a-zA-Z0-9+@ \-_]/g,
        transform: value => value
      },

      // EORI规则
      eori: {
        fields: [
          'shipperEori', 'consigneeEori',
          'sellerEori', 'buyerEori'
        ],
        pattern: /[^A-Z0-9]/g,
        maxLength: 17,
        transform: value => value.toUpperCase()
      }
    }

    // 查找适用的规则
    const rule = Object.values(validationRules).find(r => r.fields.includes(field))
    if (!rule) return

    // 应用验证规则
    let value = rule.transform(addressForm[field])
    value = value.replace(rule.pattern, '')
    if (rule.maxLength) {
      value = value.slice(0, rule.maxLength)
    }

    // 如果值发生变化，更新表单
    if (value !== addressForm[field]) {
      addressForm[field] = value
    }
  }

  existContainerUsage(u, newType) {
    const containerList = this.view.tabAfr ? this.view.afrContainer.rowData : this.view.container.rowData
    const container = (this.job.masterFlag || newType) ? u : u.container
    for (const item of containerList) {
      if (!item.deleted && container.eqSize === item.eqSize && container.eqType === item.eqType &&
        container.containerNo === item.containerNo && container.sealNo === item.sealNo) {
        return true
      }
    }
    return false
  }
  async existAfrContainerUsage(u, doc, onlyContainerNo) {
    const containerList = await new SeaCargoDoc(doc).getEdiContainer()
    const container = this.job.masterFlag ? u : u.container
    for (const item of containerList) {
      if (!item.deleted && container.eqSize === item.eqSize && container.eqType === item.eqType &&
        container.containerNo === item.containerNo && container.sealNo === item.sealNo) {
        item.hsCodeContainer = doc.hsCode
        if (doc.hblNbr2 === this.afrForm.hblNbr2) {
          this.view.afrContainer.gridOptions.api.refreshCells({ force: true })
        }
        return true
      }
    }
    return false
  }
  /**
   * refresh  刷新计件重体
   */
  refreshEdiGrid() {
    const pakInfo = this.view.container.rowData
    if (pakInfo) {
      let quantity = 0
      let weight = 0.000
      let cubage = 0.000
      for (const container of pakInfo) {
        if (container.deleted) {
          continue
        }
        quantity += container.quantity
        weight += container.weight
        cubage += container.cubage
      }
      this.form.quantity = quantity
      this.form.weight = weight
      this.form.cubage = cubage
    }
  }
  async refreshAfrEdiGrid() {
    for (const doc of this.afrCargoDocs) {
      const curContainer = await new SeaCargoDoc(doc).getEdiContainer()
      if (curContainer && curContainer.length > 0) {
        let quantity = 0
        let weight = 0.000
        let cubage = 0.000
        for (const container of curContainer) {
          if (container.deleted) {
            continue
          }
          quantity += container.quantity
          weight += container.weight
          cubage += container.cubage
        }
        doc.quantity = quantity
        doc.weight = weight
        doc.cubage = cubage
      }
    }
  }
  selectionItemHandler(row) {
    const afrAddress = this.view.tabAfr ? this.afrForm.afrAddress[0] : this.form.afrAddress[0]
    this.syncAfrAddress('shipper', row, afrAddress)
    this.syncAfrAddress('consignee', row, afrAddress)
    this.syncAfrAddress('notify', row, afrAddress)
    this.syncAfrAddress('alsonotify', row, afrAddress)
    if (this.view.activeTabName === 'ens') {
      this.syncAfrAddressEns('shipper', row, afrAddress)
      this.syncAfrAddressEns('consignee', row, afrAddress)
      this.syncAfrAddressEns('notify', row, afrAddress)
      this.syncBuyerSellerAfrAddress('seller', row, afrAddress)
      this.syncBuyerSellerAfrAddress('buyer', row, afrAddress)
    }
  }
  selectionItemHandlerByType(row) {
    const afrAddress = this.view.tabAfr ? this.afrForm.afrAddress[0] : this.form.afrAddress[0]
    this.syncAfrAddress(row.customerType, row, afrAddress)
  }
  syncAfrAddress(type, source, target) {
    for (const key of this.addressFields) {
      target[type + key] = source[type + key] || ''
    }
  }
  syncAfrAddressEns(type, source, target) {
    for (const key of this.addressFieldsEns) {
      target[type + key] = source[type + key] || ''
    }
  }
  syncBuyerSellerAfrAddress(type, source, target) {
    for (const key of this.buyerSellerAddressFields) {
      target[type + key] = source[type + key] || ''
    }
  }
  /**
   * AMS类型切换事件
   * @public
   */
  AMSTypeChangeHandler(type) {
    switch (type) {
      case 0:
        this.view.form.printParam1 = true
        this.view.form.printParam7 = false
        break
      case 1:
        this.view.form.printParam1 = false
        this.view.form.printParam7 = false
        break
      default:
        this.view.form.printParam1 = false
        this.view.form.printParam7 = true
        break
    }
    this.AMSTypeChange(type)
  }
  setStatus(value, isCn) {
    switch (value) {
      case 0:
        return isCn ? '发送失败' : 'Fail'
      case 1:
        return isCn ? this.view.$t('SeaExport.SendSucceeded') : 'Success'
      case 2:
        return isCn ? this.view.$t('SeaExport.SendSucceeded') : 'Success'
      default:
        return isCn ? this.view.$t('SeaExport.NotSent') : 'Unsend'
    }
  }

  setStatusWithColor(value, isCn) {
    switch (value) {
      case 0:
        return isCn ? `<span class="status-dot-red">发送失败</span>` : `<span class="status-dot-red">Fail</span>`
      case 1:
        return isCn ? `<span class="status-dot-green">${this.view.$t('SeaExport.SendSucceeded')}</span>` : `<span class="status-dot-green">Success</span>`
      case 2:
        return isCn ? `<span class="status-dot-green">${this.view.$t('SeaExport.hasBeanSend')}</span>` : `<span class="status-dot-green">Sent</span>`
      case null:
        return isCn ? `<span class="status-dot-gray">${this.view.$t('SeaExport.NotSent')}</span>` : `<span class="status-dot-green">Unsent</span>`
      default:
        return null
    }
  }

  setJsStatus(value, isCn) {
    if (value === 'success') {
      return isCn ? this.view.$t('SeaExport.SendSucceeded') : 'Success'
    } else if (value === 'error') {
      return isCn ? this.view.$t('SeaExport.SendError') : 'Fail'
    } else {
      return isCn ? this.view.$t('SeaExport.NotSent') : 'Unsend'
    }
  }

  setJsAciReceiptStatus(value) {
    switch (value) {
      case '1':
        return 'Accepted'
      case '17':
        return 'Accepted'
      case '14':
        return 'Rejected'
      default:
        return value
    }
  }

  setJsAfrReceiptStatus(value) {
    switch (value) {
      case 'SubmitSuccess':
        return 'Accepted'
      case 'SubmitReject':
        return 'Rejected'
      default:
        return value
    }
  }

  // 亿通回执转换
  setYtEnsReceiptStatus(value) {
    switch (value) {
      case 'T':
        return this.view.getItemTitle('Send Success')
      case 'F':
        return this.view.getItemTitle('Rejected')
      default:
        return value
    }
  }

  // 亿通海关状态转换
  setCustomsStatusWithColor(status, isCn) {
    // 遍历状态列表查找匹配项
    let statusList
    if (this.view.activeTabName === 'ams' && this.view.amsIsLink) {
      statusList = SystemConstants.AMS_STATUS_LINK_LIST
    } else if (this.view.activeTabName === 'afr' && this.view.afrIsLink) {
      statusList = SystemConstants.AFR_STATUS_LINK_LIST
    } else if (this.view.activeTabName === 'ens' && this.view.ensIsLink) {
      statusList = SystemConstants.CUSTOMS_STATUS_LINK_LIST
    } else {
      statusList = SystemConstants.CUSTOMS_STATUS_LIST
    }
    for (const item of statusList) {
      if (item.code === status) {
        return `<span class="status-dot-${item.children}">${isCn ? item.chineseName : item.englishName}</span>`
      }
    }
    // 如果没有找到匹配的状态，返回原始状态值
    return status || ''
  }

  // 一飞回执转换
  setEfEnsReceiptStatus(value) {
    switch (value) {
      case 'A':
        return this.view.getItemTitle('Send Success')
      case 'R':
        return this.view.getItemTitle('Rejected')
      case 'SN':
        return this.view.getItemTitle('Status Notification')
      default:
        return value
    }
  }
  /**
   * AFR确认删除
   */
  confirmDeletion() {
    this.view.jsAfrDeleteDialog.visible = false
    this.jsSendAFR(2)
  }

  setDelStatus(value) {
    return value === 1 ? 'send' : ''
  }

  /**
   * vessel change
   */
  async onVesselSelectionChange(currentVessel) {
    this.view.form.vessel = currentVessel.value
    this.getVoyageByVessel(currentVessel)
    if (currentVessel.value && currentVessel.uuid) {
      this.view.form.vesselIMO = currentVessel.imoCode
    } else {
      this.view.form.vesselIMO = ''
    }
    if (this.view.isJs) {
      let vesselGrid = []
      await getVesselList().then(res => {
        if (res.data) {
          vesselGrid = res.data.filter(p => p.englishName === currentVessel.englishName)
        }
      })
      if (vesselGrid) {
        for (const item of vesselGrid) {
          if (item.regCountry) {
            this.view.form.nationalityCodeofVessel = item.regCountry
            break
          }
        }
      }
    }
  }
  async getVoyageByVessel(currentVessel) {
    if (currentVessel && currentVessel.vesselId) {
      this.view.localData.voyages = await Voyage.getVoyage(currentVessel.vesselId)
    } else {
      this.view.localData.voyages = []
    }
  }

  /**
   * AMS类型切换,加载efreigh下来列表值
   * @public
   */
  async eFreighChangeHandler(type) {
    if (!this.view.localData.eFreighs) {
      this.view.localData.eFreighs = []
      const currentOfficeId = this.view.$store.getters.currentOfficeId
      const officeById = await Office.getOfficeById(currentOfficeId)
      const efreighAmsStr = officeById.efreighAms
      if (efreighAmsStr !== '') {
        this.formateEFreighs(null, efreighAmsStr, type)
      }
      const efreighAciStr = officeById.efreighAci
      if (efreighAciStr !== '') {
        this.formateEFreighs(efreighAciStr, null, type)
      }
      const nvoccScacStr = officeById.nvoccScac
      if (!StrUtils.isEmpty(nvoccScacStr)) {
        this.formateStrToList(nvoccScacStr, 'nvoccScacList')
        if (this.view.isEdit && !this.form.uuid && StrUtils.isEmpty(this.form.nvoccScac)) {
          this.form.nvoccScac = this.view.localData.nvoccScacList[0]
        }
        if (this.view.isEdit && !this.form.uuid && StrUtils.isEmpty(this.form.efNvoccScac)) {
          // CARGO-50015  优先取“8开头”的
          this.view.localData.nvoccScacList.sort((a, b) => {
            const aStartsWith8 = a.startsWith('8') ? 0 : 1 // 8开头的优先级高
            const bStartsWith8 = b.startsWith('8') ? 0 : 1
            return aStartsWith8 - bStartsWith8
          })
          this.form.efNvoccScac = this.view.localData.nvoccScacList[0]
        }
      }
      if (efreighAmsStr === '' || efreighAciStr === '') {
        const tenantId = this.view.$store.getters.tenantId
        getOfficeListByTenantId({ tenantId }).then((res) => {
          this.queryOfficesSuccess(res)
        })
      }
    }
  }

  queryOfficesSuccess(resp) {
    const offices = resp.data
    for (const office of offices) {
      if (office.code === 'HQ') {
        if ((!this.view.localData.eFreighsAciList || this.view.localData.eFreighsAciList.length === 0) && office.efreighAci != null && office.efreighAci !== '') {
          this.formateEFreighs(office.efreighAci, null, 2)
        }
        if ((!this.view.localData.eFreighsAmsList || this.view.localData.eFreighsAmsList.length === 0) && office.efreighAms != null && office.efreighAms !== '') {
          this.formateEFreighs(null, office.efreighAms, 1)
        }
        break
      }
    }
  }

  /**
   * 格式化eFreighs账户
   */
  formateEFreighs(AciStr, AmsStr, type) {
    if (AciStr != null && AciStr !== '') {
      const eFreighsAciList = []
      eFreighsAciList.push('   ')
      if (AciStr != null && AciStr !== '') {
        const r = AciStr.split('\r')
        for (let j = 0; j < r.length; j++) {
          eFreighsAciList.push(r[j])
        }
      }
      this.view.localData.eFreighsAciList = eFreighsAciList
    } else if (AmsStr != null && AmsStr !== '') {
      const eFreighsAmsList = []
      eFreighsAmsList.push('   ')
      if (AmsStr != null && AmsStr !== '') {
        const r = AmsStr.split('\r')
        for (let j = 0; j < r.length; j++) {
          eFreighsAmsList.push(r[j])
        }
      }
      this.view.localData.eFreighsAmsList = eFreighsAmsList
    }
    this.AMSTypeChange(type)
  }
  formateStrToList(valueStr, listField) {
    if (!StrUtils.isEmpty(valueStr)) {
      const list = []
      const r = valueStr.trim().split('\n')
      for (let j = 0; j < r.length; j++) {
        list.push(r[j])
      }
      this.view.localData[listField] = list
    }
  }
  // ams emainfest切换
  async AMSTypeChange(type) {
    this.view.localData.emainAccountStr = ''
    this.view.localData.emainAccountAciStr = ''
    const currentOfficeId = this.view.$store.getters.currentOfficeId
    const officeById = await Office.getOfficeById(currentOfficeId)
    const nvoccScacStr = officeById.nvoccScac
    if (!StrUtils.isEmpty(nvoccScacStr)) {
      this.formateStrToList(nvoccScacStr, 'nvoccScacList')
      // 编辑新增情况下
      if (this.view.isEdit && !this.form.uuid && StrUtils.isEmpty(this.form.nvoccScac)) {
        this.form.nvoccScac = this.view.localData.nvoccScacList[0]
      }
      if (this.view.isEdit && !this.form.uuid && StrUtils.isEmpty(this.form.efNvoccScac)) {
        // CARGO-50015  优先取“8开头”的
        this.view.localData.nvoccScacList.sort((a, b) => {
          const aStartsWith8 = a.startsWith('8') ? 0 : 1 // 8开头的优先级高
          const bStartsWith8 = b.startsWith('8') ? 0 : 1
          return aStartsWith8 - bStartsWith8
        })
        this.form.efNvoccScac = this.view.localData.nvoccScacList[0]
      }
    }
    const flag = this.view.form.AMSType === 0// 是否选中AMS账号
    this.view.localData.eFreighs = flag ? this.view.localData.eFreighsAmsList : this.view.localData.eFreighsAciList
    const efreighStr = flag ? officeById.efreighAms : officeById.efreighAci
    let result
    if (efreighStr != null && efreighStr !== '') {
      const values = efreighStr.split('\r')
      result = values[0]
    }
    // 本身有匹配下拉框选项则不重新赋值，没有匹配下拉框选项，查找form.emainAccount
    const emainAccountStr = this.view.localData.eFreighsAmsList.find(el => el === this.view.localData.emainAccountStr)
    if (!emainAccountStr) {
      const emainAccount = this.view.localData.eFreighsAmsList.find(el => el === this.form.emainAccount)
      this.view.localData.emainAccountStr = emainAccount || result
    }
    // 本身有匹配下拉框选项则不重新赋值，没有匹配下拉框选项，查找form.emainAccount
    const emainAccountAciStr = this.view.localData.eFreighsAciList.find(el => el === this.view.localData.emainAccountAciStr)
    if (!emainAccountAciStr) {
      const emainAccount = this.view.localData.eFreighsAciList.find(el => el === this.form.emainAccountAci)
      this.view.localData.emainAccountAciStr = emainAccount || result
    }
  }

  // 初始化subLoc显示
  async initSubLocLabel() {
    this.view.localData.dishSubLocStr = ''
    this.view.localData.subLocationCodeStr = ''
    if (this.form.dishSubLoc) {
      const location = await this.getLocation(this.form.dishSubLoc)
      if (location) {
        this.selectSubLocCallBack(location, 1)
      }
    }
    if (this.form.subLocationCode) {
      const location = await this.getLocation(this.form.subLocationCode)
      if (location) {
        this.selectSubLocCallBack(location, 2)
      }
    }
  }

  selectSubLocCallBack(row, type) {
    if (type === 1) {
      if (row) {
        this.view.form.dishSubLoc = row.subLocationCode
        this.view.localData.dishSubLocStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
      } else {
        this.view.form.dishSubLoc = ''
        this.view.localData.dishSubLocStr = ''
      }
    } else if (type === 2) {
      if (row) {
        this.view.form.subLocationCode = row.subLocationCode
        this.view.localData.subLocationCodeStr = row.subLocationCode + '-' + row.aciPortCode + '-' + row.inlandLocation
      } else {
        this.view.form.subLocationCode = ''
        this.view.localData.subLocationCodeStr = ''
      }
    }
    if (this.view.selectSubLocDialog) {
      this.view.selectSubLocDialog.visible = false
    }
  }

  // 获取locationCode匹配的location对象
  async getLocation(subLocationCode) {
    const params = {}
    params.likeName = subLocationCode
    params.pageNum = 1
    params.pageSize = 10
    const list = await destinationInlandLocationApi.destinationInlandLocations(params).then(resp => resp.data.list)
    if (list && list.length > 0) {
      for (const el of list) {
        if (el.subLocationCode === subLocationCode) {
          return el
        }
      }
    }
    return null
  }
  changeIsfActiveTab(activeName) {
    this.view.activeIsfTabName = activeName
  }
  refAmsData() {
    for (const item of this.amsDataList) {
      if (this.view.oldAmsNo === item.hblNbr2) {
        item.hblNbr2 = this.form.hblNbr2
      }
    }
    this.view.ams2.rowData = this.amsDataList
    this.view.ams2.gridOptions.api.clearFocusedCell()
    this.view.ams2.gridOptions.api.refreshCells({ force: true })
  }
  refAfrData() {
    for (const item of this.afrDataList) {
      if (this.view.oldAfrNo === item.hblNbr2) {
        item.hblNbr2 = this.afrForm.hblNbr2
      }
    }
    this.view.afr2.rowData = this.afrDataList
    this.view.afr2.gridOptions.api.clearFocusedCell()
    this.view.afr2.gridOptions.api.refreshCells({ force: true })
  }
  convertSpecialCharactersInHblNbr2(hblNbr2) {
    if (!hblNbr2.includes('-')) {
      return hblNbr2
    }
    const scIndex = hblNbr2.lastIndexOf('-')
    const number = hblNbr2.substr(scIndex + 1)
    const hblNbr2Prefix = hblNbr2.substr(0, scIndex)
    if (number < 10) {
      return hblNbr2Prefix + '0' + number
    }
    return hblNbr2Prefix + number
  }

  async sendAmsXml() {
    const params = {}
    params.key = this.form.uuid
    params.amsCheck = this.view.amsCheck
    params.currentOfficeId = this.view.$store.getters.currentOfficeId
    params.currentDepartmentCode = this.view.$store.getters.currentDept.code
    params.index = this.form.currentIndex
    params.jobNo = this.view.job.jobNo
    params.sendType = this.getSendType()
    params.sendXml = this.view.amsXmlDialog.content
    const loading = getLoading()
    seaCargoDocApi.sendAMSXml(params).then(resp => {
      this.view.amsXmlDialog.visible = false
      this.sendeAMSResultHandler(resp)
    }).finally(() => loading.close())
  }

  downloadAMSTxtFile() {
    const data = this.view.amsXmlDialog.content
    const blob = new Blob([data], { type: 'text/plain' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    const name = this.getNoType(this.view.activeTabName) + 'ReportXml' + new Date().getTime() + '.txt'
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  getISF(isfType, index) {
    const doc = this.view.form
    if (doc) {
      let flag = (isfType === 10) ? this.checkIsf10Model() : this.checkIsf05Model()
      if (Number(this.config.get('AmsOriginAgentCode')) === 1) {
        const d = this.view.$store.getters.currentDept.code
        if (flag && (d == null || d === '')) {
          this.$message.info(this.view.$t('SeaExport.PleaseOfYourCurrentFirst'))
          flag = false
        }
      }
      if (flag) {
        const amsCheck = this.view.amsCheck
        const params = {}
        params.key = this.form.uuid
        params.amsCheck = amsCheck
        params.currentOfficeId = this.view.$store.getters.currentOfficeId
        params.currentDepartmentCode = this.view.$store.getters.currentDept.code
        params.index = index
        params.jobNo = this.view.job.jobNo
        params.isfType = isfType
        const loading = getLoading()
        seaCargoDocApi.getISF(params).then(resp => {
          if (resp.data) {
            if (resp.data.isSuccess) {
              this.view.amsXmlDialog.visible = true
              this.view.amsXmlDialog.content = resp.data.text || ''
            } else {
              const text = resp.data.text
              if (text && text.indexOf('\n') !== -1) {
                const textArr = text.split('\n')
                this.$message.warning({ dangerouslyUseHTMLString: true, message: textArr.join(' <br/> ') })
              } else {
                this.$message.warning(text)
              }
            }
          }
        }).finally(() => loading.close())
      }
    } else {
      this.$message.info(this.view.$t('Message.PleaseSelectTheAMSNO'))
    }
  }

  sendISFXml(index, isfType) {
    const params = {}
    params.key = this.form.uuid
    params.amsCheck = this.view.amsCheck
    params.currentOfficeId = this.view.$store.getters.currentOfficeId
    params.currentDepartmentCode = this.view.$store.getters.currentDept.code
    params.index = index
    params.jobNo = this.view.job.jobNo
    params.isfType = isfType === 'ISF10' ? 10 : 5
    params.sendXml = this.view.amsXmlDialog.content
    const loading = getLoading()
    seaCargoDocApi.sendISFXml(params).then(resp => {
      this.view.amsXmlDialog.visible = false
      this.sendeAMSResultHandler(resp)
    }).finally(() => loading.close())
  }

  /**
   * 新增一个空白的AFR
   * @returns {Promise<void>}
   */
  async onAddNewAfrCargoDoc() {
    const cargoDoc = await CargoDocUtil.addAFR(this.job, true)
    this.afrForm = new SeaCargoDoc(cargoDoc).fillDefaultValue().getData()
    this.clearAfrForm(this.afrForm)
    const gdList = this.afrCargoDocs
    const hblList = []
    let hbl2
    if (gdList.length > 0) {
      for (const sea of gdList) {
        hblList.push(sea.hblNbr2)
      }
      hbl2 = this.afrForm.hblNbr2 + this.hbl2Arr[gdList.length - 1]
      if (hblList.includes(hbl2)) {
        for (let i = 0; i < this.hbl2Arr.length; ++i) {
          const hblNo = this.afrForm.hblNbr2 + this.hbl2Arr[i]
          if (!hblList.includes(hblNo)) {
            this.afrForm.hblNbr2 = hblNo
            break
          }
        }
      } else {
        this.afrForm.hblNbr2 = hbl2
      }
      this.afrForm.afrLast = false
    } else {
      this.afrForm.afrLast = true
    }
    this.afrForm.fromAdd = true
    this.afrForm.goodsType = 0
    this.afrCargoDocs.push(this.afrForm)
    if (hbl2) {
      const newDOC = {}
      newDOC.jobNo = this.job.jobNo
      newDOC.hblNbr2 = this.afrForm.hblNbr2
      newDOC.afrStatus = -1
      newDOC.afrLast = false
      this.afrDataList.push(newDOC)
    }
    this.view.afr2.rowData = this.afrDataList
    setTimeout(() => {
      this.setSelectAfrNode(this.view.afr2.rowData.length - 1)
    }, 100)
    // 列表选择
    await this.onAfrSelectionChange(this.view.afr2.rowData[this.view.afr2.rowData.length - 1])
    this.view.afrContainer.rowData = await new SeaCargoDoc(this.afrForm).getEdiContainer()
  }

  /**
   * 从订舱和基本页签同步信息
   */
  onSyncBooking() {
    this.afrForm.mblNbr2 = this.job.mbl
    this.afrForm.vessel = this.job.vessel
    this.afrForm.voyageFlight = CargoDocUtil.replaceVoyage(this.job.voyageFlight, true)
    this.afrForm.vesselCode = this.job.vesselCode
    this.afrForm.vesselIMO = this.job.vesselIMO
    // CARGO-35213 AFR从订舱页签取不到船舶呼号和IMO的时候，直接从船名维护那里匹配取值
    if (!this.afrForm.vesselCode || !this.afrForm.vesselIMO) {
      const vessel = getObjectByCache(TYPE_NAMES.basic_data_Vessel, 'englishName', this.afrForm.vessel)
      // 船舶呼号
      if (!this.afrForm.vesselCode && vessel) {
        this.afrForm.vesselCode = vessel.callSign
      }
      // IMO
      if (!this.afrForm.vesselIMO && vessel) {
        this.afrForm.vesselIMO = vessel.imoCode
      }
    }
    this.afrForm.eta = this.job.eta
    this.afrForm.etd = this.job.etd
    this.afrForm.loadingPortCode = this.job.loadingPortCode
    const jobLoadingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.loadingPortCode)
    if (jobLoadingPort) {
      this.afrForm.loadingPort = jobLoadingPort.englishName
    }
    this.afrForm.dischargingPortCode = this.job.dischargingPortCode
    const jobDischargingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode)
    if (jobDischargingPort) {
      this.afrForm.dischargingPort = jobDischargingPort.englishName
    }
  }

  /**
   * 检查HBLNo是否重复
   */
  checkHBLNoRepeat() {
    let duplicateAfrCargoDoc
    const afrCargoDocMap = {}
    for (let i = 0; i < this.afrCargoDocs.length; i++) {
      if (this.afrCargoDocs[i].deleted) {
        continue
      }
      const element = this.afrCargoDocs[i].hblNbr2
      // 如果当前元素已经在 afrCargoDocMap 中存在，则表示出现了重复元素
      if (afrCargoDocMap.hasOwnProperty(element)) {
        duplicateAfrCargoDoc = element
        break
      } else if (!this.afrCargoDocs[i].deleted) { // 否则，如果没有被删除，将当前元素添加到 afrCargoDocMap，并设置初始计数为 1
        afrCargoDocMap[element] = 1
      }
    }
    // 有值代表此HBL重复
    if (duplicateAfrCargoDoc) {
      throw new TabError(this.view.$t('SeaExport.HBLNoRepeat', [duplicateAfrCargoDoc]), 'tabAMS')
    }
  }

  afrAllMatched() {
    if (!this.afrDataList || !(this.afrDataList.length > 0)) {
      return false
    }
    for (const item of this.afrDataList) {
      if (item.afrReceiptStatus !== 'Matched') {
        return false
      }
    }
    return true
  }
  // CARGO-37467 优化：手工点add，带出的信息应该为空白   add FFR时，清除不必要的信息
  clearAfrForm(afrForm) {
    afrForm.hblNbr2 = ''
    afrForm.packing = ''
    afrForm.dispatchingPlace = ''
    afrForm.dispatchingPlaceCode = ''
    afrForm.loadingPort = ''
    afrForm.loadingPortCode = ''
    afrForm.dischargingPort = ''
    afrForm.dischargingPortCode = ''
    afrForm.destinationPort = ''
    afrForm.destinationPortCode = ''
    afrForm.etd = ''
    afrForm.eta = ''
    afrForm.vessel = ''
    afrForm.vesselCode = ''
    afrForm.voyageFlight = ''
    afrForm.countryOrigin = ''
    afrForm.quantity = ''
    afrForm.weight = 0
    afrForm.cubage = 0
    afrForm.hsCode = ''
    this.view.localData.nameOfCountry = ''
    if (afrForm.afrAddress && afrForm.afrAddress.length > 0) {
      afrForm.afrAddress[0].notifyLine1 = ''
    }
  }

  // 格式化收发通信息
  formatAddress(newDoc) {
    if (!newDoc.afrAddress || newDoc.afrAddress.length === 0) {
      return
    }
    newDoc.afrAddress[0].shipperLine1 = this.afrValidateAddressField(newDoc.afrAddress[0].shipperLine1)
    newDoc.afrAddress[0].shipperLine3 = this.afrValidateAddressField(newDoc.afrAddress[0].shipperLine3)
    newDoc.afrAddress[0].shipperLine4 = this.afrValidateAddressField(newDoc.afrAddress[0].shipperLine4)
    newDoc.afrAddress[0].consigneeLine1 = this.afrValidateAddressField(newDoc.afrAddress[0].consigneeLine1)
    newDoc.afrAddress[0].consigneeLine3 = this.afrValidateAddressField(newDoc.afrAddress[0].consigneeLine3)
    newDoc.afrAddress[0].consigneeLine4 = this.afrValidateAddressField(newDoc.afrAddress[0].consigneeLine4)
    newDoc.afrAddress[0].notifyLine1 = this.afrValidateAddressField(newDoc.afrAddress[0].notifyLine1)
    newDoc.afrAddress[0].notifyLine3 = this.afrValidateAddressField(newDoc.afrAddress[0].notifyLine3)
    newDoc.afrAddress[0].notifyLine4 = this.afrValidateAddressField(newDoc.afrAddress[0].notifyLine4)
  }

  // 地址信息 字段验证方法
  afrValidateAddressField(value) {
    if (!value) return
    // 允许大小写字母、数字、短横杠、斜杠、逗号、空格、冒号、引号、加号、下划线
    const validChars = /[A-Za-z0-9\-/,\s:"'_+]/g
    return value.match(validChars)?.join('') || ''
  }
  // 箱号校验
  afrValidateContainerNo(value) {
    if (!value) return value
    // 11个字符
    let processed = value.toUpperCase().substring(0, 11)
    // 移除不合规字符
    processed = processed.replace(/[^A-Z0-9]/g, '')
    return processed
  }
  // 唛头 品名校验
  afrValidateMarksDescription(value) {
    if (!value) return value
    // 与地址字段相同的验证规则
    const validChars = /[A-Za-z0-9\-/,\s:"'_+]/g
    return value.match(validChars)?.join('') || ''
  }
  // hsCode 校验
  afrValidateHsCodeDescription(value) {
    if (!value) {
      return value
    }
    // 过滤不合规字符，只保留数字
    let valueHsCode = value
      .replace(/[^\d]/g, '')
      .slice(0, 6) // 限制长度为6位

    // 补全到6位
    if (valueHsCode.length < 6) {
      valueHsCode = valueHsCode.padEnd(6, '0')
    }
    return valueHsCode
  }
}
